/* L'ODAR Maison v18 – deferred bundle (built from the v17 files below, same order, unchanged).
   Each former file runs in its own try/catch, so an error in one does not stop the next.
   Global contract:
     window: LODAR_I18N, LODAR_ASSET_BASE, LODAR_X3D, LODAR_ROOM, LODAR_INTRO_VIDEO, LODAR_HOUSE_VIDEO,
             __lodarIntroDone, __lodarBar3d, __lodarUnlockHouse
     events: lodar:intro, lodar:introbuffered, lodar:bar, lodar:bar3d, lodar:barclick, lodar:barready
     v18 (B2): window.__lodarIntroBuffered; sessionStorage lodar-bar {b,c,u}, lodar-label {n,d}, lodar-wiz {a,p,d,o}
   Order rules: the i18n dictionaries first, then "v18 i18n" (before lodar-x9); lodar-x7 before lodar-x; lodar-xh after three.js;
   lodar-x3d after lodar-xh (both in lodar-v18-3d.js / lodar-v18-x3d.js, loaded after three.js). */
/* ==== lodar-maison-i18n.js ==== */
try{
window.LODAR_I18N = {
"fr": {
"Hauptnavigation": "Navigation principale",
"Das Erlebnis": "L’expérience",
"Pakete": "Formules",
"Fragen": "Questions",
"L’ODAR Startseite": "L’ODAR, accueil",
"L’ODAR": "L’ODAR",
"Bar anfragen": "Demander le bar",
"Perfumebar für Hochzeiten und private Anlässe": "Bar à parfum pour mariages et réceptions privées",
"Ein Duft,": "Un parfum",
"der bleibt.": "qui reste.",
"Die L’ODAR Perfumebar kommt an euer Fest. Eure Gäste wählen ihr Extrait de Parfum, füllen es selbst ab und nehmen es im Flakon mit euren Namen mit nach Hause.": "Le bar à parfum L’ODAR vient à votre fête. Vos invités choisissent leur extrait de parfum, le remplissent eux-mêmes et le rapportent chez eux dans un flacon à vos noms.",
"So läuft es ab": "Le déroulement",
"Die L’ODAR Perfumebar mit ihren Duftspendern": "Le bar à parfum L’ODAR et ses distributeurs",
"Die Bar, aufgebaut in einem Festsaal": "Le bar, installé dans une salle de réception",
"Kein Gastgeschenk, das in einer Schublade verschwindet. Ein Duft, der eure Gäste noch Jahre später an euren Tag erinnert.": "Pas un cadeau qui finit au fond d’un tiroir. Un parfum qui rappellera votre journée à vos invités, des années plus tard.",
"Von der ersten Begegnung bis zum letzten Flakon begleiten wir euch persönlich.": "De la première rencontre au dernier flacon, nous vous accompagnons personnellement.",
"I": "I",
"Kennenlernen": "La rencontre",
"Wir treffen uns persönlich. Ihr riecht unsere Extraits und wählt die Düfte für euren Tag.": "Nous nous rencontrons en personne. Vous découvrez nos extraits et choisissez les parfums de votre journée.",
"II": "II",
"Euer Etikett": "Votre étiquette",
"Jeder Flakon trägt eure Namen und das Datum. Gedruckt wird erst nach eurer Freigabe.": "Chaque flacon porte vos noms et la date. L’impression n’a lieu qu’après votre validation.",
"III": "III",
"Am Fest": "Le jour J",
"Wir bauen die Bar auf und begleiten eure Gäste rund vier Stunden lang.": "Nous installons le bar et accompagnons vos invités pendant environ quatre heures.",
"IV": "IV",
"Zum Mitnehmen": "Le souvenir",
"Jeder Gast füllt sein Extrait de Parfum selbst ab und nimmt den 25-ml-Flakon mit nach Hause.": "Chaque invité remplit lui-même son extrait de parfum et repart avec son flacon de 25 ml.",
"Bilder der Perfumebar": "Images du bar à parfum",
"Die Duftspender der Perfumebar": "Les distributeurs du bar à parfum",
"25-ml-Flakons mit schwarzer Kugelkappe vor den Duftspendern": "Flacons de 25 ml avec bouchon sphérique noir devant les distributeurs",
"Die Bar auf weissem Marmor": "Le bar sur marbre blanc",
"Eure Namen auf jedem Flakon.": "Vos noms sur chaque flacon.",
"Das Etikett macht aus jedem Duft ein Andenken an euren Tag. Schreibt eure Namen hinein und seht, wie es aussieht.": "L’étiquette fait de chaque parfum un souvenir de votre journée. Écrivez vos noms et voyez le résultat.",
"Namen": "Noms",
"Datum": "Date",
"Flakon mit persönlichem Etikett": "Flacon avec étiquette personnalisée",
"Flakon 25 ml, Extrait de Parfum": "Flacon 25 ml, extrait de parfum",
"Ein Preis, alles inbegriffen. Ihr wählt nur, wie viele Gäste einen Flakon mitnehmen.": "Un prix, tout compris. Vous choisissez seulement combien d’invités repartent avec un flacon.",
"Bis 20 Gäste": "Jusqu’à 20 invités",
"20 Flakons à 25 ml": "20 flacons de 25 ml",
"CHF": "CHF",
"700": "700",
"Anfragen": "Demander",
"Bis 50 Gäste": "Jusqu’à 50 invités",
"50 Flakons à 25 ml": "50 flacons de 25 ml",
"1300": "1300",
"Bis 100 Gäste": "Jusqu’à 100 invités",
"100 Flakons à 25 ml": "100 flacons de 25 ml",
"1900": "1900",
"Mehr als 100 Gäste": "Plus de 100 invités",
"Individuelles Angebot": "Offre sur mesure",
"Auf Anfrage": "Sur demande",
"In jedem Paket: persönliches Kennenlernen, Etiketten mit euren Namen, Auf- und Abbau der Bar und Betreuung vor Ort. Die Anfahrt in der Region Biel, Bern und Solothurn ist inbegriffen.": "Dans chaque formule : rencontre personnelle, étiquettes à vos noms, montage et démontage du bar et accompagnement sur place. Le déplacement dans la région Bienne, Berne et Soleure est inclus.",
"Erzählt uns von eurem Anlass. Wir melden uns persönlich und vereinbaren ein Kennenlernen. Die Anfrage ist unverbindlich.": "Parlez-nous de votre événement. Nous vous contactons personnellement pour convenir d’une rencontre. La demande est sans engagement.",
"Oder schreibt uns direkt an": "Ou écrivez-nous directement à",
"info@lodarperfumes.com": "info@lodarperfumes.com",
"Anlass": "Événement",
"Hochzeit": "Mariage",
"Firmenanlass": "Événement d’entreprise",
"Geburtstag": "Anniversaire",
"Private Feier": "Fête privée",
"Anderes": "Autre",
"Gäste": "Invités",
"Noch unklar": "Pas encore défini",
"Ort": "Lieu",
"z. B. Bern": "p. ex. Lausanne",
"Name": "Nom",
"E-Mail": "E-mail",
"Telefon (optional)": "Téléphone (facultatif)",
"Nachricht": "Message",
"Was sollen wir über euer Fest wissen?": "Que devons-nous savoir sur votre fête ?",
"Anfrage senden": "Envoyer la demande",
"Häufige Fragen": "Questions fréquentes",
"Was kostet die Perfumebar?": "Combien coûte le bar à parfum ?",
"Bis 20 Gäste CHF 700, bis 50 Gäste CHF 1300 und bis 100 Gäste CHF 1900. Für mehr als 100 Gäste machen wir euch ein individuelles Angebot. Im Preis enthalten sind das Vorgespräch, Auf- und Abbau, die Betreuung vor Ort sowie alle Flakons mit euren Etiketten.": "Jusqu’à 20 invités CHF 700, jusqu’à 50 invités CHF 1300 et jusqu’à 100 invités CHF 1900. Pour plus de 100 invités, nous vous faisons une offre sur mesure. Le prix comprend l’entretien préalable, le montage et le démontage, le service sur place et tous les flacons avec vos étiquettes.",
"Wie früh sollten wir buchen?": "Combien de temps à l’avance réserver ?",
"Mindestens 3 Wochen vor dem Anlass. Je nach Verfügbarkeit lohnt es sich aber, früher anzufragen, denn beliebte Daten sind schnell weg. Die finale Gästezahl und den Text für die Etiketten brauchen wir 14 Tage vorher, bei kurzfristigen Buchungen direkt mit der Buchung.": "Au moins 3 semaines avant l’événement. Selon les disponibilités, mieux vaut toutefois nous contacter plus tôt, car les dates les plus prisées partent vite. Il nous faut le nombre définitif d’invités et le texte des étiquettes 14 jours avant l’événement ; pour une réservation de dernière minute, dès la réservation.",
"Was braucht ihr vor Ort?": "De quoi avez-vous besoin sur place ?",
"Eine ebene, wettergeschützte Fläche von etwa 2 × 1.5 m und einen Zugang für den Aufbau. Alles andere bringen wir mit.": "Une surface plane et abritée d’environ 2 × 1,5 m et un accès pour le montage. Nous apportons tout le reste.",
"Wie lange ist die Bar an unserem Fest?": "Combien de temps le bar reste-t-il à notre fête ?",
"Die Betreuung dauert rund 4 Stunden. Länger ist nach Absprache möglich.": "L’accompagnement dure environ 4 heures. Une prolongation est possible sur demande.",
"Wo seid ihr unterwegs?": "Où vous déplacez-vous ?",
"In der ganzen Schweiz. Die Anfahrt in der Region Biel, Bern und Solothurn ist inbegriffen, weitere Strecken verrechnen wir nach Absprache.": "Dans toute la Suisse. Le déplacement dans la région de Bienne, Berne et Soleure est compris, les trajets plus longs sont facturés sur demande.",
"Können wir die Düfte vorher riechen?": "Pouvons-nous découvrir les parfums à l’avance ?",
"Ja. Beim Kennenlernen bringen wir unsere Extraits mit, und ihr wählt in Ruhe die Düfte für euren Tag.": "Oui. Lors de notre rencontre, nous apportons nos extraits et vous choisissez en toute tranquillité les parfums de votre journée.",
"Was steht auf dem Etikett?": "Qu’est-ce qui figure sur l’étiquette ?",
"Was ihr möchtet, zum Beispiel eure Namen und das Datum. Bei Firmenanlässen ist auch euer Logo möglich.": "Ce que vous souhaitez, par exemple vos noms et la date. Pour un événement d’entreprise, nous pouvons aussi y faire figurer votre logo.",
"Was ist ein Extrait de Parfum?": "Qu’est-ce qu’un Extrait de Parfum ?",
"Die höchste Duftkonzentration der Parfumerie. Unsere Extraits enthalten über 30 % Parfumöl, deutlich mehr als ein Eau de Parfum. Die Duftöle stammen aus Grasse in Südfrankreich.": "La forme de parfum la plus concentrée. Nos extraits contiennent plus de 30 % de concentré de parfum, bien plus qu’une eau de parfum. Ces concentrés proviennent de Grasse, dans le sud de la France.",
"Wie bezahlen wir?": "Comment se déroule le paiement ?",
"Nach eurer Anfrage treffen wir uns persönlich. Ihr wählt eure Düfte und die Etiketten, und wir unterschreiben gemeinsam den Vertrag. Der gesamte Betrag ist mit der Unterzeichnung fällig, euer Datum ist nach Zahlungseingang fest reserviert. Ihr bezahlt per Banküberweisung oder TWINT.": "Après votre demande, nous nous rencontrons en personne. Vous choisissez vos parfums et les étiquettes, et nous signons ensemble le contrat. Le montant total est dû à la signature ; votre date est réservée ferme dès réception du paiement. Vous payez par virement bancaire ou TWINT.",
"Perfumebar für Hochzeiten und Events in der ganzen Schweiz, aus Biel/Bienne.": "Bar à parfum pour mariages et événements dans toute la Suisse, depuis Biel/Bienne.",
"Rechtliches": "Informations légales",
"AGB": "CG",
"Datenschutz": "Confidentialité",
"Impressum": "Mentions légales",
"© 2026 L’ODAR": "© 2026 L’ODAR",
"Zurück zur Startseite": "Retour à l’accueil",
"Allgemeine Geschäftsbedingungen": "Conditions générales",
"Stand: Oktober 2026": "État : octobre 2026",
"Die deutsche Fassung ist massgebend. Die Übersetzung dient nur der Information.": "Seule la version allemande fait foi. La traduction est fournie à titre informatif.",
"1. Geltungsbereich": "1. Champ d’application",
"Diese AGB gelten für die Buchung der L’ODAR Perfumebar für Veranstaltungen wie Hochzeiten, Firmenanlässe und private Feiern. Vertragspartner ist L’ODAR, Inhaber Hassen Ltaief, Südstrasse 2, 2504 Biel (nachfolgend «L’ODAR» oder «wir»). Abweichende Bedingungen des Kunden gelten nur, wenn wir ihnen schriftlich zustimmen.": "Les présentes CG s’appliquent à la réservation du bar à parfum L’ODAR pour des événements tels que mariages, événements d’entreprise et fêtes privées. Le partenaire contractuel est L’ODAR, titulaire Hassen Ltaief, Reitschulstrasse 5, 2502 Bienne (ci-après « L’ODAR » ou « nous »). Les conditions divergentes du client ne s’appliquent qu’avec notre accord écrit.",
"2. Anfrage und Vertragsschluss": "2. Demande et conclusion du contrat",
"Eine Anfrage über die Website ist unverbindlich. Danach treffen wir uns persönlich: Der Kunde riecht die Kollektion und wählt die sechs Düfte und die Gestaltung der Etiketten. Der Vertrag kommt mit der Unterzeichnung des schriftlichen Buchungsvertrags durch beide Parteien zustande. Darin halten wir Datum, Ort, Paket, Gästezahl, die sechs gewählten Düfte, die Gestaltung der Etiketten und den Preis fest. Diese AGB sind Bestandteil des Vertrags.": "Une demande via le site web est sans engagement. Nous nous rencontrons ensuite en personne : le client découvre la collection et choisit les six parfums ainsi que le design des étiquettes. Le contrat est conclu lorsque les deux parties signent le contrat de réservation écrit. Celui-ci précise la date, le lieu, la formule, le nombre d’invités, les six parfums choisis, le design des étiquettes et le prix. Les présentes CG font partie intégrante du contrat.",
"3. Preise": "3. Prix",
"Es gelten die Paketpreise zum Zeitpunkt der Vertragsunterzeichnung: bis 20 Gäste CHF 700, bis 50 Gäste CHF 1300, bis 100 Gäste CHF 1900. Für mehr als 100 Gäste erstellen wir ein individuelles Angebot. Alle Preise verstehen sich in Schweizer Franken. L’ODAR ist nicht mehrwertsteuerpflichtig.": "Les prix des formules en vigueur au moment de la signature du contrat s’appliquent : jusqu’à 20 invités CHF 700, jusqu’à 50 invités CHF 1300, jusqu’à 100 invités CHF 1900. Pour plus de 100 invités, nous établissons une offre individuelle. Tous les prix s’entendent en francs suisses. L’ODAR n’est pas assujetti à la TVA.",
"4. Zahlung": "4. Paiement",
"Der gesamte Preis ist mit der Unterzeichnung des Vertrags fällig und innert 5 Tagen zu bezahlen, in jedem Fall aber vor dem Anlass. Der Termin ist erst nach Zahlungseingang verbindlich reserviert. Die Zahlung erfolgt per Banküberweisung oder TWINT.": "Le prix total est dû à la signature du contrat et payable dans les 5 jours, mais en tout cas avant l’événement. La date n’est réservée ferme qu’après réception du paiement. Le paiement s’effectue par virement bancaire ou TWINT.",
"5. Gästezahl und Etiketten": "5. Nombre d’invités et étiquettes",
"Die finale Gästezahl und der Text für die Etiketten sind uns spätestens 14 Tage vor dem Anlass mitzuteilen, bei kurzfristigen Buchungen mit der Buchung. Eine spätere Reduktion der Gästezahl führt zu keiner Preisminderung. Die Etiketten werden nach Freigabe durch den Kunden gedruckt. Für Fehler in freigegebenen Texten übernehmen wir keine Haftung.": "Le nombre final d’invités et le texte des étiquettes doivent nous être communiqués au plus tard 14 jours avant l’événement, et pour les réservations de dernière minute avec la réservation. Une réduction ultérieure du nombre d’invités ne donne droit à aucune réduction de prix. Les étiquettes sont imprimées après validation par le client. Nous déclinons toute responsabilité pour les erreurs dans les textes validés.",
"6. Annullierung durch den Kunden": "6. Annulation par le client",
"Annulliert der Kunde die Buchung, behält L’ODAR vom bezahlten Preis folgende Entschädigung ein und erstattet den Rest zurück:": "Si le client annule la réservation, L’ODAR retient sur le prix payé l’indemnité suivante et rembourse le solde :",
"90 Tage oder mehr vor dem Anlass: 30 %": "90 jours ou plus avant l’événement : 30 %",
"89 bis 30 Tage vor dem Anlass: 50 %": "de 89 à 30 jours avant l’événement : 50 %",
"weniger als 30 Tage vor dem Anlass: 100 %": "moins de 30 jours avant l’événement : 100 %",
"Bereits gedruckte Etiketten werden in jedem Fall verrechnet. Eine Verschiebung des Termins ist nach Verfügbarkeit möglich.": "Les étiquettes déjà imprimées sont facturées dans tous les cas. Un report de la date est possible selon les disponibilités.",
"7. Leistungen vor Ort": "7. Prestations sur place",
"Im Preis enthalten sind das Vorgespräch, die Perfumebar mit Auf- und Abbau, die Betreuung während rund 4 Stunden sowie die vereinbarte Anzahl 25-ml-Flakons mit Etiketten. Der Kunde stellt eine ebene, wettergeschützte Fläche von mindestens 2 × 1.5 m und einen Zugang für den Aufbau zur Verfügung. Anfahrten ausserhalb der Region Biel, Bern und Solothurn sowie zusätzliche Stunden werden nach Absprache verrechnet.": "Le prix comprend l’entretien préalable, le bar à parfum avec montage et démontage, le service pendant environ 4 heures ainsi que le nombre convenu de flacons de 25 ml avec étiquettes. Le client met à disposition une surface plane et abritée d’au moins 2 × 1,5 m et un accès pour le montage. Les déplacements hors de la région de Bienne, Berne et Soleure ainsi que les heures supplémentaires sont facturés sur demande.",
"8. Verhinderung": "8. Empêchement",
"Können wir den Anlass wegen höherer Gewalt, Krankheit oder Unfall nicht durchführen, bemühen wir uns um Ersatz. Ist dies nicht möglich, erstatten wir bereits geleistete Zahlungen vollständig zurück. Weitergehende Ansprüche sind ausgeschlossen.": "Si nous ne pouvons pas assurer l’événement en raison d’un cas de force majeure, d’une maladie ou d’un accident, nous nous efforçons de trouver une solution de remplacement. Si cela n’est pas possible, nous remboursons intégralement les paiements déjà effectués. Toute autre prétention est exclue.",
"9. Produkthinweise": "9. Informations sur les produits",
"Unsere Düfte sind kosmetische Produkte nur zur äusserlichen Anwendung. Sie enthalten Alkohol, sind leicht entzündlich und gehören nicht in Kinderhände. Nicht in die Augen oder auf verletzte Haut sprühen. Die Inhaltsstoffe und Allergene sind auf der Verpackung angegeben. Alle L’ODAR-Düfte sind eigenständige Produkte ohne Verbindung zu anderen Parfummarken.": "Nos parfums sont des produits cosmétiques à usage externe uniquement. Ils contiennent de l’alcool, sont facilement inflammables et doivent être tenus hors de portée des enfants. Ne pas vaporiser dans les yeux ni sur une peau lésée. Les ingrédients et allergènes figurent sur l’emballage. Tous les parfums L’ODAR sont des produits indépendants, sans lien avec d’autres marques de parfum.",
"10. Haftung": "10. Responsabilité",
"Wir haften für Schäden, die wir vorsätzlich oder grobfahrlässig verursachen. Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit gesetzlich zulässig. Die Haftung nach dem Produktehaftpflichtgesetz bleibt unberührt.": "Nous répondons des dommages causés intentionnellement ou par négligence grave. La responsabilité pour négligence légère est exclue dans la mesure permise par la loi. La responsabilité selon la loi fédérale sur la responsabilité du fait des produits demeure réservée.",
"11. Datenschutz": "11. Protection des données",
"Wie wir mit Personendaten umgehen, steht in unserer": "La manière dont nous traitons les données personnelles est décrite dans notre",
"Datenschutzerklärung": "Politique de confidentialité",
".": ".",
"12. Anwendbares Recht und Gerichtsstand": "12. Droit applicable et for",
"Es gilt ausschliesslich Schweizer Recht. Gerichtsstand ist Biel/Bienne. Für Konsumenten gelten die zwingenden Gerichtsstände nach der Schweizerischen Zivilprozessordnung, insbesondere am Wohnsitz des Konsumenten.": "Le droit suisse s’applique exclusivement. Le for est à Bienne. Pour les consommateurs, les fors impératifs du Code de procédure civile suisse s’appliquent, notamment au domicile du consommateur.",
"13. Schlussbestimmungen": "13. Dispositions finales",
"Sollte eine Bestimmung dieser AGB unwirksam sein, bleiben die übrigen Bestimmungen gültig. Es gilt die Fassung, die zum Zeitpunkt der Vertragsunterzeichnung auf der Website veröffentlicht ist.": "Si une disposition des présentes CG devait être invalide, les autres dispositions restent valables. La version publiée sur le site web au moment de la signature du contrat fait foi.",
"Wir nehmen den Schutz deiner Personendaten ernst. Diese Erklärung informiert dich nach dem Schweizer Datenschutzgesetz (DSG) darüber, welche Daten wir bearbeiten, wozu und welche Rechte du hast.": "Nous prenons la protection de vos données personnelles au sérieux. Conformément à la loi fédérale sur la protection des données (LPD), la présente déclaration vous informe des données que nous traitons, dans quel but et de vos droits.",
"1. Verantwortlicher": "1. Responsable du traitement",
"L’ODAR, Inhaber Hassen Ltaief, Südstrasse 2, 2504 Biel, Schweiz. E-Mail:": "L’ODAR, titulaire Hassen Ltaief, Reitschulstrasse 5, 2502 Bienne, Suisse. E-mail :",
"2. Welche Daten wir bearbeiten": "2. Données traitées",
"Event-Anfragen und Buchungen:": "Demandes et réservations d’événements :",
"Name, Kontaktdaten, Anlass, Datum, Ort, Gästezahl, gewählte Düfte und der Text für die Etiketten (z. B. Namen eines Brautpaars).": "nom, coordonnées, type d’événement, date, lieu, nombre d’invités, parfums choisis et texte des étiquettes (p. ex. prénoms des mariés).",
"Kontakt:": "Contact :",
"Inhalte und Kontaktdaten, wenn du uns schreibst.": "contenu et coordonnées lorsque vous nous écrivez.",
"Nutzung der Website:": "Utilisation du site web :",
"technisch notwendige Daten wie IP-Adresse, Browser und Zeitpunkt des Aufrufs, die beim Hosting anfallen.": "données techniquement nécessaires générées par l’hébergement, telles que l’adresse IP, le navigateur et l’heure de consultation.",
"3. Zweck": "3. Finalité",
"Wir bearbeiten deine Daten, um Event-Buchungen zu planen und durchzuführen, deine Anfragen zu beantworten und unsere gesetzlichen Pflichten (z. B. Buchführung) zu erfüllen. Wir verkaufen deine Daten nicht und nutzen sie nicht für Werbung ohne deine Einwilligung.": "Nous traitons vos données pour planifier et réaliser les réservations d’événements, répondre à vos demandes et remplir nos obligations légales (p. ex. comptabilité). Nous ne vendons pas vos données et ne les utilisons pas à des fins publicitaires sans votre consentement.",
"4. Weitergabe an Dritte": "4. Transmission à des tiers",
"Wir geben Daten nur weiter, soweit es für die Abwicklung nötig ist:": "Nous ne transmettons des données que dans la mesure nécessaire au traitement :",
"Shopify (Betrieb der Website und Übermittlung der Anfragen)": "Shopify (exploitation du site et transmission des demandes)",
"Google Workspace (E-Mail)": "Google Workspace (e-mail)",
"TWINT und unsere Bank (Zahlungsabwicklung)": "TWINT et notre banque (traitement des paiements)",
"5. Externe Dienste auf der Website": "5. Services externes sur le site web",
"Für die Darstellung laden wir Schriften von Google Fonts (Google, USA). Dabei wird deine IP-Adresse an diesen Anbieter übermittelt. Eine Übermittlung in die USA erfolgt auf Grundlage des Swiss-U.S. Data Privacy Framework oder anderer geeigneter Garantien.": "Pour l’affichage, nous chargeons des polices depuis Google Fonts (Google, États-Unis). Votre adresse IP est alors transmise à ce prestataire. Un transfert vers les États-Unis a lieu sur la base du Swiss-U.S. Data Privacy Framework ou d’autres garanties appropriées.",
"6. Cookies und lokale Speicherung": "6. Cookies et stockage local",
"Wir setzen keine Tracking- oder Werbe-Cookies. Für Komfortfunktionen wie die gewählte Sprache speichern wir Angaben lokal in deinem Browser. Diese Daten verlassen dein Gerät nicht und du kannst sie jederzeit in den Browser-Einstellungen löschen.": "Nous n’utilisons pas de cookies de suivi ou publicitaires. Pour des fonctions de confort comme la langue choisie, nous enregistrons des informations localement dans votre navigateur. Ces données ne quittent pas votre appareil et vous pouvez les supprimer à tout moment dans les réglages du navigateur.",
"7. Aufbewahrung": "7. Conservation",
"Wir bewahren Daten so lange auf, wie es für den Zweck nötig ist. Buchhaltungsrelevante Unterlagen bewahren wir nach Art. 958f OR während 10 Jahren auf. Event-Anfragen ohne Buchung löschen wir nach 12 Monaten.": "Nous conservons les données aussi longtemps que nécessaire. Les documents comptables sont conservés 10 ans selon l’art. 958f CO. Les demandes d’événement sans réservation sont supprimées après 12 mois.",
"8. Deine Rechte": "8. Vos droits",
"Du hast das Recht auf Auskunft über deine Daten, auf Berichtigung, Löschung und Herausgabe sowie das Recht, einer Bearbeitung zu widersprechen. Schreib uns dafür an": "Vous disposez d’un droit d’accès à vos données ainsi que du droit d’en demander la rectification, l’effacement et la remise, et de vous opposer à leur traitement. Pour ce faire, écrivez-nous à",
". Du kannst dich ausserdem beim Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten (EDÖB) beschweren.": ". Vous pouvez en outre déposer une plainte auprès du Préposé fédéral à la protection des données et à la transparence (PFPDT).",
"9. Änderungen": "9. Modifications",
"Wir können diese Datenschutzerklärung anpassen. Es gilt die jeweils auf der Website veröffentlichte Fassung.": "Nous pouvons modifier la présente politique de confidentialité. La version publiée sur le site web fait foi.",
"Einzelunternehmen, Inhaber: Hassen Ltaief": "Entreprise individuelle, titulaire : Hassen Ltaief",
"Südstrasse 2": "Südstrasse 2",
"2504 Biel": "2504 Biel",
"Schweiz": "Suisse",
"E-Mail:": "E-mail :",
"Haftungsausschluss": "Exclusion de responsabilité",
"Wir prüfen die Inhalte dieser Website sorgfältig, übernehmen aber keine Gewähr für Richtigkeit, Vollständigkeit und Aktualität. Für Inhalte verlinkter externer Seiten sind ausschliesslich deren Betreiber verantwortlich.": "Nous vérifions soigneusement le contenu de ce site web, mais ne garantissons ni son exactitude, ni son exhaustivité, ni son actualité. Les exploitants des sites externes liés sont seuls responsables de leur contenu.",
"Urheberrechte": "Droits d’auteur",
"Texte, Bilder, Logo und Gestaltung dieser Website gehören L’ODAR. Jede Verwendung ohne schriftliche Zustimmung ist untersagt.": "Les textes, images, logo et design de ce site web appartiennent à L’ODAR. Toute utilisation sans autorisation écrite est interdite.",
"L’ODAR Perfumebar – Ein Duft, der bleibt": "Bar à parfum L’ODAR – Un parfum qui reste",
"Danke für eure Anfrage.": "Merci pour votre demande.",
"Sie ist bei uns angekommen. Wir melden uns persönlich bei euch.": "Nous l’avons bien reçue. Nous vous contacterons personnellement.",
"Die Anfrage wurde nicht gesendet. Bitte prüft Name und E-Mail-Adresse.": "Votre demande n’a pas pu être envoyée. Veuillez vérifier votre nom et votre adresse e-mail."
},
"en": {
"Hauptnavigation": "Main navigation",
"Das Erlebnis": "The experience",
"Pakete": "Packages",
"Fragen": "Questions",
"L’ODAR Startseite": "L’ODAR home",
"L’ODAR": "L’ODAR",
"Bar anfragen": "Enquire about the bar",
"Perfumebar für Hochzeiten und private Anlässe": "Perfume bar for weddings and private celebrations",
"Ein Duft,": "A scent",
"der bleibt.": "that stays.",
"Die L’ODAR Perfumebar kommt an euer Fest. Eure Gäste wählen ihr Extrait de Parfum, füllen es selbst ab und nehmen es im Flakon mit euren Namen mit nach Hause.": "The L’ODAR perfume bar comes to your celebration. Your guests choose their extrait de parfum, fill it themselves and take it home in a bottle bearing your names.",
"So läuft es ab": "How it works",
"Die L’ODAR Perfumebar mit ihren Duftspendern": "The L’ODAR Perfumebar with its dispensers",
"Die Bar, aufgebaut in einem Festsaal": "The bar, set up in a reception hall",
"Kein Gastgeschenk, das in einer Schublade verschwindet. Ein Duft, der eure Gäste noch Jahre später an euren Tag erinnert.": "Not a favour that disappears into a drawer. A scent that reminds your guests of your day, years later.",
"Von der ersten Begegnung bis zum letzten Flakon begleiten wir euch persönlich.": "From the first meeting to the last bottle, we look after you personally.",
"I": "I",
"Kennenlernen": "First meeting",
"Wir treffen uns persönlich. Ihr riecht unsere Extraits und wählt die Düfte für euren Tag.": "We meet in person. You try our extraits and choose the scents for your day.",
"II": "II",
"Euer Etikett": "Your label",
"Jeder Flakon trägt eure Namen und das Datum. Gedruckt wird erst nach eurer Freigabe.": "Every bottle carries your names and the date. We print only after your approval.",
"III": "III",
"Am Fest": "On the day",
"Wir bauen die Bar auf und begleiten eure Gäste rund vier Stunden lang.": "We set up the bar and look after your guests for about four hours.",
"IV": "IV",
"Zum Mitnehmen": "To take home",
"Jeder Gast füllt sein Extrait de Parfum selbst ab und nimmt den 25-ml-Flakon mit nach Hause.": "Each guest fills their own extrait de parfum and takes the 25 ml bottle home.",
"Bilder der Perfumebar": "Images of the perfume bar",
"Die Duftspender der Perfumebar": "The dispensers of the perfume bar",
"25-ml-Flakons mit schwarzer Kugelkappe vor den Duftspendern": "25 ml bottles with black ball caps in front of the dispensers",
"Die Bar auf weissem Marmor": "The bar on white marble",
"Eure Namen auf jedem Flakon.": "Your names on every bottle.",
"Das Etikett macht aus jedem Duft ein Andenken an euren Tag. Schreibt eure Namen hinein und seht, wie es aussieht.": "The label turns every scent into a keepsake of your day. Type your names and see how it looks.",
"Namen": "Names",
"Datum": "Date",
"Flakon mit persönlichem Etikett": "Bottle with a personalised label",
"Flakon 25 ml, Extrait de Parfum": "25 ml bottle, extrait de parfum",
"Ein Preis, alles inbegriffen. Ihr wählt nur, wie viele Gäste einen Flakon mitnehmen.": "One price, everything included. You only choose how many guests take a bottle home.",
"Bis 20 Gäste": "Up to 20 guests",
"20 Flakons à 25 ml": "20 bottles of 25 ml",
"CHF": "CHF",
"700": "700",
"Anfragen": "Enquire",
"Bis 50 Gäste": "Up to 50 guests",
"50 Flakons à 25 ml": "50 bottles of 25 ml",
"1300": "1300",
"Bis 100 Gäste": "Up to 100 guests",
"100 Flakons à 25 ml": "100 bottles of 25 ml",
"1900": "1900",
"Mehr als 100 Gäste": "More than 100 guests",
"Individuelles Angebot": "Tailored offer",
"Auf Anfrage": "On request",
"In jedem Paket: persönliches Kennenlernen, Etiketten mit euren Namen, Auf- und Abbau der Bar und Betreuung vor Ort. Die Anfahrt in der Region Biel, Bern und Solothurn ist inbegriffen.": "Every package includes a personal meeting, labels with your names, setup and teardown of the bar and our team on site. Travel within the Biel, Bern and Solothurn region is included.",
"Erzählt uns von eurem Anlass. Wir melden uns persönlich und vereinbaren ein Kennenlernen. Die Anfrage ist unverbindlich.": "Tell us about your occasion. We will get in touch personally to arrange a meeting. The enquiry is non-binding.",
"Oder schreibt uns direkt an": "Or write to us directly at",
"info@lodarperfumes.com": "info@lodarperfumes.com",
"Anlass": "Occasion",
"Hochzeit": "Wedding",
"Firmenanlass": "Corporate event",
"Geburtstag": "Birthday",
"Private Feier": "Private party",
"Anderes": "Other",
"Gäste": "Guests",
"Noch unklar": "Not sure yet",
"Ort": "Venue",
"z. B. Bern": "e.g. Bern",
"Name": "Name",
"E-Mail": "Email",
"Telefon (optional)": "Phone (optional)",
"Nachricht": "Message",
"Was sollen wir über euer Fest wissen?": "What should we know about your celebration?",
"Anfrage senden": "Send enquiry",
"Häufige Fragen": "Frequently asked questions",
"Was kostet die Perfumebar?": "How much does the perfume bar cost?",
"Bis 20 Gäste CHF 700, bis 50 Gäste CHF 1300 und bis 100 Gäste CHF 1900. Für mehr als 100 Gäste machen wir euch ein individuelles Angebot. Im Preis enthalten sind das Vorgespräch, Auf- und Abbau, die Betreuung vor Ort sowie alle Flakons mit euren Etiketten.": "Up to 20 guests CHF 700, up to 50 guests CHF 1300 and up to 100 guests CHF 1900. For more than 100 guests, we will prepare a tailored quote. The price includes the consultation, set-up and dismantling, on-site service and all bottles with your labels.",
"Wie früh sollten wir buchen?": "How early should we book?",
"Mindestens 3 Wochen vor dem Anlass. Je nach Verfügbarkeit lohnt es sich aber, früher anzufragen, denn beliebte Daten sind schnell weg. Die finale Gästezahl und den Text für die Etiketten brauchen wir 14 Tage vorher, bei kurzfristigen Buchungen direkt mit der Buchung.": "At least 3 weeks before the event. That said, it is worth enquiring earlier, as popular dates go quickly. We need the final guest count and the label text 14 days before, or with the booking itself for short-notice bookings.",
"Was braucht ihr vor Ort?": "What do you need on site?",
"Eine ebene, wettergeschützte Fläche von etwa 2 × 1.5 m und einen Zugang für den Aufbau. Alles andere bringen wir mit.": "A flat, sheltered area of about 2 × 1.5 m and access for set-up. We bring everything else.",
"Wie lange ist die Bar an unserem Fest?": "How long does the bar stay at our celebration?",
"Die Betreuung dauert rund 4 Stunden. Länger ist nach Absprache möglich.": "Service lasts about 4 hours. We can stay longer by arrangement.",
"Wo seid ihr unterwegs?": "Which areas do you cover?",
"In der ganzen Schweiz. Die Anfahrt in der Region Biel, Bern und Solothurn ist inbegriffen, weitere Strecken verrechnen wir nach Absprache.": "All over Switzerland. Travel within the Biel, Bern and Solothurn region is included, longer distances are charged by arrangement.",
"Können wir die Düfte vorher riechen?": "Can we try the scents beforehand?",
"Ja. Beim Kennenlernen bringen wir unsere Extraits mit, und ihr wählt in Ruhe die Düfte für euren Tag.": "Yes. When we meet, we bring our extraits and you choose the scents for your day at your leisure.",
"Was steht auf dem Etikett?": "What goes on the label?",
"Was ihr möchtet, zum Beispiel eure Namen und das Datum. Bei Firmenanlässen ist auch euer Logo möglich.": "Whatever you like, for example your names and the date. For corporate events, we can also add your logo.",
"Was ist ein Extrait de Parfum?": "What is an Extrait de Parfum?",
"Die höchste Duftkonzentration der Parfumerie. Unsere Extraits enthalten über 30 % Parfumöl, deutlich mehr als ein Eau de Parfum. Die Duftöle stammen aus Grasse in Südfrankreich.": "The highest fragrance concentration in perfumery. Our extraits contain over 30% perfume oil, significantly more than an eau de parfum. The perfume oils come from Grasse in the south of France.",
"Wie bezahlen wir?": "How do we pay?",
"Nach eurer Anfrage treffen wir uns persönlich. Ihr wählt eure Düfte und die Etiketten, und wir unterschreiben gemeinsam den Vertrag. Der gesamte Betrag ist mit der Unterzeichnung fällig, euer Datum ist nach Zahlungseingang fest reserviert. Ihr bezahlt per Banküberweisung oder TWINT.": "After your enquiry we meet in person. You choose your scents and labels, and we sign the contract together. The full amount is due on signing, and your date is firmly reserved once payment has been received. You pay by bank transfer or TWINT.",
"Perfumebar für Hochzeiten und Events in der ganzen Schweiz, aus Biel/Bienne.": "Perfume bar for weddings and events across Switzerland, from Biel/Bienne.",
"Rechtliches": "Legal",
"AGB": "Terms",
"Datenschutz": "Privacy",
"Impressum": "Legal notice",
"© 2026 L’ODAR": "© 2026 L’ODAR",
"Zurück zur Startseite": "Back to home",
"Allgemeine Geschäftsbedingungen": "General Terms and Conditions",
"Stand: Oktober 2026": "Last updated: October 2026",
"Die deutsche Fassung ist massgebend. Die Übersetzung dient nur der Information.": "The German version is legally binding. This translation is provided for information only.",
"1. Geltungsbereich": "1. Scope",
"Diese AGB gelten für die Buchung der L’ODAR Perfumebar für Veranstaltungen wie Hochzeiten, Firmenanlässe und private Feiern. Vertragspartner ist L’ODAR, Inhaber Hassen Ltaief, Südstrasse 2, 2504 Biel (nachfolgend «L’ODAR» oder «wir»). Abweichende Bedingungen des Kunden gelten nur, wenn wir ihnen schriftlich zustimmen.": "These terms apply to bookings of the L’ODAR perfume bar for events such as weddings, corporate events and private parties. The contracting party is L’ODAR, owner Hassen Ltaief, Südstrasse 2, 2504 Biel (hereinafter “L’ODAR” or “we”). Deviating terms of the customer apply only with our written consent.",
"2. Anfrage und Vertragsschluss": "2. Enquiry and conclusion of contract",
"Eine Anfrage über die Website ist unverbindlich. Danach treffen wir uns persönlich: Der Kunde riecht die Kollektion und wählt die sechs Düfte und die Gestaltung der Etiketten. Der Vertrag kommt mit der Unterzeichnung des schriftlichen Buchungsvertrags durch beide Parteien zustande. Darin halten wir Datum, Ort, Paket, Gästezahl, die sechs gewählten Düfte, die Gestaltung der Etiketten und den Preis fest. Diese AGB sind Bestandteil des Vertrags.": "An enquiry via the website is non-binding. We then meet in person: the customer tries the collection and chooses the six scents and the label design. The contract is concluded when both parties sign the written booking contract. It sets out the date, venue, package, guest count, the six chosen scents, the label design and the price. These terms and conditions form part of the contract.",
"3. Preise": "3. Prices",
"Es gelten die Paketpreise zum Zeitpunkt der Vertragsunterzeichnung: bis 20 Gäste CHF 700, bis 50 Gäste CHF 1300, bis 100 Gäste CHF 1900. Für mehr als 100 Gäste erstellen wir ein individuelles Angebot. Alle Preise verstehen sich in Schweizer Franken. L’ODAR ist nicht mehrwertsteuerpflichtig.": "The package prices valid at the time the contract is signed apply: up to 20 guests CHF 700, up to 50 guests CHF 1300, up to 100 guests CHF 1900. For more than 100 guests we prepare an individual quote. All prices are in Swiss francs. L’ODAR is not subject to VAT.",
"4. Zahlung": "4. Payment",
"Der gesamte Preis ist mit der Unterzeichnung des Vertrags fällig und innert 5 Tagen zu bezahlen, in jedem Fall aber vor dem Anlass. Der Termin ist erst nach Zahlungseingang verbindlich reserviert. Die Zahlung erfolgt per Banküberweisung oder TWINT.": "The full price is due when the contract is signed and payable within 5 days, but in any case before the event. The date is only firmly reserved once payment has been received. Payment is made by bank transfer or TWINT.",
"5. Gästezahl und Etiketten": "5. Guest count and labels",
"Die finale Gästezahl und der Text für die Etiketten sind uns spätestens 14 Tage vor dem Anlass mitzuteilen, bei kurzfristigen Buchungen mit der Buchung. Eine spätere Reduktion der Gästezahl führt zu keiner Preisminderung. Die Etiketten werden nach Freigabe durch den Kunden gedruckt. Für Fehler in freigegebenen Texten übernehmen wir keine Haftung.": "The final guest count and the label text must be provided to us no later than 14 days before the event, or with the booking for short-notice bookings. A later reduction in the guest count does not lead to a price reduction. Labels are printed after approval by the customer. We accept no liability for errors in approved texts.",
"6. Annullierung durch den Kunden": "6. Cancellation by the customer",
"Annulliert der Kunde die Buchung, behält L’ODAR vom bezahlten Preis folgende Entschädigung ein und erstattet den Rest zurück:": "If the customer cancels the booking, L’ODAR retains the following compensation from the price paid and refunds the rest:",
"90 Tage oder mehr vor dem Anlass: 30 %": "90 days or more before the event: 30%",
"89 bis 30 Tage vor dem Anlass: 50 %": "89 to 30 days before the event: 50%",
"weniger als 30 Tage vor dem Anlass: 100 %": "Less than 30 days before the event: 100%",
"Bereits gedruckte Etiketten werden in jedem Fall verrechnet. Eine Verschiebung des Termins ist nach Verfügbarkeit möglich.": "Labels that have already been printed will be charged for in all cases. The date can be rescheduled, subject to availability.",
"7. Leistungen vor Ort": "7. Services on site",
"Im Preis enthalten sind das Vorgespräch, die Perfumebar mit Auf- und Abbau, die Betreuung während rund 4 Stunden sowie die vereinbarte Anzahl 25-ml-Flakons mit Etiketten. Der Kunde stellt eine ebene, wettergeschützte Fläche von mindestens 2 × 1.5 m und einen Zugang für den Aufbau zur Verfügung. Anfahrten ausserhalb der Region Biel, Bern und Solothurn sowie zusätzliche Stunden werden nach Absprache verrechnet.": "The price includes the consultation, the perfume bar with set-up and dismantling, service for about 4 hours and the agreed number of 25 ml bottles with labels. The customer provides a flat, sheltered area of at least 2 × 1.5 m and access for set-up. Travel outside the Biel, Bern and Solothurn region and extra hours are charged by arrangement.",
"8. Verhinderung": "8. Inability to perform",
"Können wir den Anlass wegen höherer Gewalt, Krankheit oder Unfall nicht durchführen, bemühen wir uns um Ersatz. Ist dies nicht möglich, erstatten wir bereits geleistete Zahlungen vollständig zurück. Weitergehende Ansprüche sind ausgeschlossen.": "If we are unable to carry out the event due to force majeure, illness or accident, we will endeavour to find a replacement. If this is not possible, we will refund all payments already made in full. Further claims are excluded.",
"9. Produkthinweise": "9. Product information",
"Unsere Düfte sind kosmetische Produkte nur zur äusserlichen Anwendung. Sie enthalten Alkohol, sind leicht entzündlich und gehören nicht in Kinderhände. Nicht in die Augen oder auf verletzte Haut sprühen. Die Inhaltsstoffe und Allergene sind auf der Verpackung angegeben. Alle L’ODAR-Düfte sind eigenständige Produkte ohne Verbindung zu anderen Parfummarken.": "Our scents are cosmetic products for external use only. They contain alcohol, are highly flammable and must be kept away from children. Do not spray into the eyes or onto broken skin. Ingredients and allergens are listed on the packaging. All L’ODAR scents are independent products with no connection to other perfume brands.",
"10. Haftung": "10. Liability",
"Wir haften für Schäden, die wir vorsätzlich oder grobfahrlässig verursachen. Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit gesetzlich zulässig. Die Haftung nach dem Produktehaftpflichtgesetz bleibt unberührt.": "We are liable for damage caused intentionally or through gross negligence. Liability for slight negligence is excluded to the extent permitted by law. Liability under the Product Liability Act remains unaffected.",
"11. Datenschutz": "11. Data protection",
"Wie wir mit Personendaten umgehen, steht in unserer": "How we handle personal data is described in our",
"Datenschutzerklärung": "Privacy Policy",
".": ".",
"12. Anwendbares Recht und Gerichtsstand": "12. Applicable law and jurisdiction",
"Es gilt ausschliesslich Schweizer Recht. Gerichtsstand ist Biel/Bienne. Für Konsumenten gelten die zwingenden Gerichtsstände nach der Schweizerischen Zivilprozessordnung, insbesondere am Wohnsitz des Konsumenten.": "Swiss law applies exclusively. Place of jurisdiction is Biel/Bienne. For consumers, the mandatory jurisdictions under the Swiss Civil Procedure Code apply, in particular at the consumer’s domicile.",
"13. Schlussbestimmungen": "13. Final provisions",
"Sollte eine Bestimmung dieser AGB unwirksam sein, bleiben die übrigen Bestimmungen gültig. Es gilt die Fassung, die zum Zeitpunkt der Vertragsunterzeichnung auf der Website veröffentlicht ist.": "Should any provision of these terms be invalid, the remaining provisions remain valid. The version published on the website at the time the contract is signed applies.",
"Wir nehmen den Schutz deiner Personendaten ernst. Diese Erklärung informiert dich nach dem Schweizer Datenschutzgesetz (DSG) darüber, welche Daten wir bearbeiten, wozu und welche Rechte du hast.": "We take the protection of your personal data seriously. In accordance with the Swiss Federal Act on Data Protection (FADP), this policy informs you which data we process, for what purpose and what rights you have.",
"1. Verantwortlicher": "1. Controller",
"L’ODAR, Inhaber Hassen Ltaief, Südstrasse 2, 2504 Biel, Schweiz. E-Mail:": "L’ODAR, owner Hassen Ltaief, Südstrasse 2, 2504 Biel, Switzerland. Email:",
"2. Welche Daten wir bearbeiten": "2. Data we process",
"Event-Anfragen und Buchungen:": "Event enquiries and bookings:",
"Name, Kontaktdaten, Anlass, Datum, Ort, Gästezahl, gewählte Düfte und der Text für die Etiketten (z. B. Namen eines Brautpaars).": "name, contact details, occasion, date, venue, number of guests, chosen scents and label text (e.g. names of a bridal couple).",
"Kontakt:": "Contact:",
"Inhalte und Kontaktdaten, wenn du uns schreibst.": "content and contact details when you write to us.",
"Nutzung der Website:": "Use of the website:",
"technisch notwendige Daten wie IP-Adresse, Browser und Zeitpunkt des Aufrufs, die beim Hosting anfallen.": "technically necessary data generated by hosting, such as IP address, browser and time of access.",
"3. Zweck": "3. Purpose",
"Wir bearbeiten deine Daten, um Event-Buchungen zu planen und durchzuführen, deine Anfragen zu beantworten und unsere gesetzlichen Pflichten (z. B. Buchführung) zu erfüllen. Wir verkaufen deine Daten nicht und nutzen sie nicht für Werbung ohne deine Einwilligung.": "We process your data to plan and carry out event bookings, answer your enquiries and meet our legal obligations (e.g. accounting). We do not sell your data and do not use it for advertising without your consent.",
"4. Weitergabe an Dritte": "4. Disclosure to third parties",
"Wir geben Daten nur weiter, soweit es für die Abwicklung nötig ist:": "We only pass on data to the extent necessary for processing:",
"Shopify (Betrieb der Website und Übermittlung der Anfragen)": "Shopify (operation of the website and transmission of enquiries)",
"Google Workspace (E-Mail)": "Google Workspace (email)",
"TWINT und unsere Bank (Zahlungsabwicklung)": "TWINT and our bank (payment processing)",
"5. Externe Dienste auf der Website": "5. External services on the website",
"Für die Darstellung laden wir Schriften von Google Fonts (Google, USA). Dabei wird deine IP-Adresse an diesen Anbieter übermittelt. Eine Übermittlung in die USA erfolgt auf Grundlage des Swiss-U.S. Data Privacy Framework oder anderer geeigneter Garantien.": "To display the site we load fonts from Google Fonts (Google, USA). Your IP address is transmitted to this provider. Any transfer to the USA is based on the Swiss-U.S. Data Privacy Framework or other appropriate safeguards.",
"6. Cookies und lokale Speicherung": "6. Cookies and local storage",
"Wir setzen keine Tracking- oder Werbe-Cookies. Für Komfortfunktionen wie die gewählte Sprache speichern wir Angaben lokal in deinem Browser. Diese Daten verlassen dein Gerät nicht und du kannst sie jederzeit in den Browser-Einstellungen löschen.": "We do not use tracking or advertising cookies. For convenience features such as the chosen language we store information locally in your browser. This data does not leave your device and you can delete it at any time in your browser settings.",
"7. Aufbewahrung": "7. Retention",
"Wir bewahren Daten so lange auf, wie es für den Zweck nötig ist. Buchhaltungsrelevante Unterlagen bewahren wir nach Art. 958f OR während 10 Jahren auf. Event-Anfragen ohne Buchung löschen wir nach 12 Monaten.": "We keep data as long as necessary for the purpose. Accounting records are kept for 10 years under Art. 958f CO. Event enquiries without a booking are deleted after 12 months.",
"8. Deine Rechte": "8. Your rights",
"Du hast das Recht auf Auskunft über deine Daten, auf Berichtigung, Löschung und Herausgabe sowie das Recht, einer Bearbeitung zu widersprechen. Schreib uns dafür an": "You have the right to access, rectify, erase and receive your data, as well as the right to object to processing. To do so, write to us at",
". Du kannst dich ausserdem beim Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten (EDÖB) beschweren.": ". You may also lodge a complaint with the Federal Data Protection and Information Commissioner (FDPIC).",
"9. Änderungen": "9. Changes",
"Wir können diese Datenschutzerklärung anpassen. Es gilt die jeweils auf der Website veröffentlichte Fassung.": "We may amend this Privacy Policy. The version published on the website applies.",
"Einzelunternehmen, Inhaber: Hassen Ltaief": "Sole proprietorship, owner: Hassen Ltaief",
"Südstrasse 2": "Südstrasse 2",
"2504 Biel": "2504 Biel",
"Schweiz": "Switzerland",
"E-Mail:": "Email:",
"Haftungsausschluss": "Disclaimer",
"Wir prüfen die Inhalte dieser Website sorgfältig, übernehmen aber keine Gewähr für Richtigkeit, Vollständigkeit und Aktualität. Für Inhalte verlinkter externer Seiten sind ausschliesslich deren Betreiber verantwortlich.": "We check the content of this website carefully but accept no liability for its accuracy, completeness or timeliness. The operators of linked external sites are solely responsible for their content.",
"Urheberrechte": "Copyright",
"Texte, Bilder, Logo und Gestaltung dieser Website gehören L’ODAR. Jede Verwendung ohne schriftliche Zustimmung ist untersagt.": "The texts, images, logo and design of this website belong to L’ODAR. Any use without written consent is prohibited.",
"L’ODAR Perfumebar – Ein Duft, der bleibt": "L’ODAR Perfume Bar – A scent that stays",
"Danke für eure Anfrage.": "Thank you for your enquiry.",
"Sie ist bei uns angekommen. Wir melden uns persönlich bei euch.": "We have received it and will get in touch personally.",
"Die Anfrage wurde nicht gesendet. Bitte prüft Name und E-Mail-Adresse.": "The enquiry was not sent. Please check your name and email address."
}
};

}catch(e){console.error("[lodar-maison-i18n.js]",e)}
/* ==== lodar-maison-i18n2.js ==== */
try{
/* L'ODAR Maison: Texte fuer Pakete-Karussell und Anfrage in Schritten */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  var add = {
"fr": {
"Ein Duft, der bleibt.": "Un parfum qui reste.",
"Ein Preis, alles inbegriffen. Wischt durch die Pakete und wählt, wie viele Gäste einen Flakon mitnehmen.": "Un prix, tout compris. Faites défiler les formules et choisissez combien d’invités repartent avec un flacon.",
"Vorheriges Paket": "Formule précédente",
"Nächstes Paket": "Formule suivante",
"Pakete, seitlich verschiebbar": "Formules, défilement horizontal",
"Etiketten mit euren Namen": "Étiquettes à vos noms",
"Auf- und Abbau der Bar": "Montage et démontage du bar",
"Rund 4 Stunden Betreuung": "Environ 4 heures d’accompagnement",
"Dieses Paket anfragen": "Demander cette formule",
"Unsere Empfehlung": "Notre recommandation",
"+": "+",
"So viele Flakons wie Gäste": "Autant de flacons que d’invités",
"Auf Wunsch längere Betreuung": "Accompagnement prolongé sur demande",
"Angebot anfragen": "Demander une offre",
"Vier kurze Fragen, dann melden wir uns persönlich bei euch. Die Anfrage ist unverbindlich.": "Quatre petites questions, puis nous vous contactons personnellement. La demande est sans engagement.",
"Datum und Ort": "Date et lieu",
"Kontakt": "Contact",
"Lieber direkt? Schreibt uns an": "Vous préférez écrire ? Contactez-nous à",
"Schritt": "Étape",
"1": "1",
"von": "sur",
"4": "4",
"Was feiert ihr?": "Que célébrez-vous ?",
"Wie viele Gäste erwartet ihr?": "Combien d’invités attendez-vous ?",
"20": "20",
"CHF 700": "CHF 700",
"50": "50",
"CHF 1300": "CHF 1300",
"100": "100",
"CHF 1900": "CHF 1900",
"100+": "100+",
"Wissen wir noch nicht": "Nous ne savons pas encore",
"Wann und wo feiert ihr?": "Quand et où a lieu votre fête ?",
"Noch kein Datum? Lasst das Feld einfach leer.": "Pas encore de date ? Laissez simplement le champ vide.",
"Wie erreichen wir euch?": "Comment vous joindre ?",
"Nachricht (optional)": "Message (facultatif)",
"Zurück": "Retour",
"Weiter": "Continuer"
},
"en": {
"Ein Duft, der bleibt.": "A scent that stays.",
"Ein Preis, alles inbegriffen. Wischt durch die Pakete und wählt, wie viele Gäste einen Flakon mitnehmen.": "One price, everything included. Swipe through the packages and choose how many guests take a bottle home.",
"Vorheriges Paket": "Previous package",
"Nächstes Paket": "Next package",
"Pakete, seitlich verschiebbar": "Packages, scroll sideways",
"Etiketten mit euren Namen": "Labels with your names",
"Auf- und Abbau der Bar": "Set-up and dismantling of the bar",
"Rund 4 Stunden Betreuung": "About 4 hours of service",
"Dieses Paket anfragen": "Enquire about this package",
"Unsere Empfehlung": "Our recommendation",
"+": "+",
"So viele Flakons wie Gäste": "As many bottles as guests",
"Auf Wunsch längere Betreuung": "Longer service on request",
"Angebot anfragen": "Request a quote",
"Vier kurze Fragen, dann melden wir uns persönlich bei euch. Die Anfrage ist unverbindlich.": "Four short questions, then we will get in touch personally. There is no obligation.",
"Datum und Ort": "Date and venue",
"Kontakt": "Contact",
"Lieber direkt? Schreibt uns an": "Prefer to write? Contact us at",
"Schritt": "Step",
"1": "1",
"von": "of",
"4": "4",
"Was feiert ihr?": "What are you celebrating?",
"Wie viele Gäste erwartet ihr?": "How many guests are you expecting?",
"20": "20",
"CHF 700": "CHF 700",
"50": "50",
"CHF 1300": "CHF 1300",
"100": "100",
"CHF 1900": "CHF 1900",
"100+": "100+",
"Wissen wir noch nicht": "We don’t know yet",
"Wann und wo feiert ihr?": "When and where is your celebration?",
"Noch kein Datum? Lasst das Feld einfach leer.": "No date yet? Just leave the field empty.",
"Wie erreichen wir euch?": "How can we reach you?",
"Nachricht (optional)": "Message (optional)",
"Zurück": "Back",
"Weiter": "Next"
}
};
  for(var l in add){ D[l] = D[l] || {}; for(var k in add[l]) D[l][k] = add[l][k]; }
})();

}catch(e){console.error("[lodar-maison-i18n2.js]",e)}
/* ==== lodar-x-i18n.js ==== */
try{
/* L'ODAR Maison v3: Duefte, Duftuhr und neue Texte (laedt nach lodar-maison-i18n.js und -i18n2.js) */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  var add = {
"fr": {
"Ein Moment, der bleibt.": "Un moment qui reste.",
"Überspringen": "Passer",
"Die Düfte": "Les parfums",
"Sprache": "Langue",
"3D-Ansicht der L’ODAR Perfumebar. Ziehen zum Drehen, auf einen Spender tippen.": "Vue 3D du bar à parfum L’ODAR. Faites glisser pour tourner, touchez un distributeur.",
"Die L’ODAR Perfumebar": "Le bar à parfum L’ODAR",
"Perfumebar für Hochzeiten und Events": "Bar à parfum pour mariages et événements",
"Düfte entdecken": "Découvrir les parfums",
"Gewählter Duft": "Parfum sélectionné",
"Herren": "Homme",
"Fruchtig-holzig": "Boisé fruité",
"Ananas": "Ananas",
"Bergamotte": "Bergamote",
"Eichenmoos": "Mousse de chêne",
"Saftige Ananas, Bergamotte und Eichenmoos. Strahlend und selbstbewusst.": "Ananas juteux, bergamote et mousse de chêne. Lumineux et affirmé.",
"Für den Tag": "Pour la journée",
"Fruchtig": "Fruité",
"Passionsfrucht": "Fruit de la passion",
"Pfirsich": "Pêche",
"Moschus": "Musc",
"Passionsfrucht und Pfirsich auf sinnlichem Moschus. Verführerisch und frei.": "Fruit de la passion et pêche sur un musc sensuel. Séduisant et libre.",
"Rauchig": "Fumé",
"Weihrauch": "Encens",
"Amber": "Ambre",
"Oud": "Oud",
"Weihrauch, Amber und Oud. Rauchig, mächtig, geheimnisvoll.": "Encens, ambre et oud. Fumé, puissant, mystérieux.",
"Für die Nacht": "Pour la nuit",
"Würzige Vanille": "Vanille épicée",
"Vanille": "Vanille",
"Wildleder": "Daim",
"Pfeffer": "Poivre",
"Rohe Vanille, Wildleder und Pfeffer. Wild, warm und magnetisch.": "Vanille brute, daim et poivre. Sauvage, chaud et magnétique.",
"Blumig-ledrig": "Floral cuiré",
"V": "V",
"Hibiskus": "Hibiscus",
"Rose": "Rose",
"Leder": "Cuir",
"Hibiskus und Damaszener Rose auf weichem Leder. Kühn und unvergesslich.": "Hibiscus et rose de Damas sur un cuir souple. Audacieux et inoubliable.",
"Für den Abend": "Pour le soir",
"Unisex": "Unisexe",
"Milchig-blumig": "Floral lacté",
"VI": "VI",
"Milch": "Lait",
"Tuberose": "Tubéreuse",
"Warme Milch, Tuberose und Moschus. Cremig, sinnlich und unendlich weich.": "Lait chaud, tubéreuse et musc. Crémeux, sensuel et infiniment doux.",
"Süss-ambriert": "Ambré gourmand",
"VII": "VII",
"Meersalz": "Sel marin",
"Praline": "Praliné",
"Meersalz trifft Praline und goldenes Amber. Süss, warm, unvergleichlich.": "Le sel marin rencontre le praliné et l’ambre doré. Doux, chaud, incomparable.",
"Damen": "Femme",
"Pudrige Vanille": "Vanille poudrée",
"VIII": "VIII",
"Kokos": "Coco",
"Puder": "Poudre",
"Pudrige Vanille mit einem Hauch Kokos. Weich wie warmer Kaschmir.": "Vanille poudrée et une touche de coco. Douce comme un cachemire tiède.",
"Blumig-holzig": "Floral boisé",
"IX": "IX",
"Birne": "Poire",
"Orangenblüte": "Fleur d’oranger",
"Saftige Birne, Orangenblüte und Oud. Ein Sonnenuntergang an der Riviera.": "Poire juteuse, fleur d’oranger et oud. Un coucher de soleil sur la Riviera.",
"Fruchtig-blumig": "Floral fruité",
"X": "X",
"Litschi": "Litchi",
"Pfingstrose": "Pivoine",
"Kakao": "Cacao",
"Litschi, Pfingstrose und ein Hauch Kakao. Verträumt und romantisch.": "Litchi, pivoine et une touche de cacao. Rêveur et romantique.",
"Pudrig-holzig": "Boisé poudré",
"XI": "XI",
"Sandelholz": "Santal",
"Cremiges Sandelholz, Puder und Vanille. Pariser Eleganz auf der Haut.": "Santal crémeux, notes poudrées et vanille. L’élégance parisienne sur la peau.",
"Gourmand": "Gourmand",
"XII": "XII",
"Karamell": "Caramel",
"Tonka": "Tonka",
"Karamellisierter Zucker, Vanille und Tonka. Ein Dessert zum Tragen.": "Sucre caramélisé, vanille et tonka. Un dessert à porter.",
"Duftnummer wählen": "Choisir un numéro",
"Nummer I": "Numéro I",
"Nummer II": "Numéro II",
"Nummer III": "Numéro III",
"Nummer IV": "Numéro IV",
"Nummer V": "Numéro V",
"Nummer VI": "Numéro VI",
"Nummer VII": "Numéro VII",
"Nummer VIII": "Numéro VIII",
"Nummer IX": "Numéro IX",
"Nummer X": "Numéro X",
"Nummer XI": "Numéro XI",
"Nummer XII": "Numéro XII",
"Ziehen zum Drehen. Tippt auf eine Nummer, und die Bar füllt sie ab.": "Faites glisser pour tourner. Touchez un numéro et le bar le remplit.",
"Hochzeiten": "Mariages",
"Firmenanlässe": "Événements d’entreprise",
"Geburtstage": "Anniversaires",
"Private Feiern": "Fêtes privées",
"Extrait de Parfum aus Grasse": "Extrait de Parfum de Grasse",
"Vor euren Augen abgefüllt": "Rempli sous vos yeux",
"Mit euren Namen": "À vos noms",
"Ein Duft, der bleibt": "Un parfum qui reste",
"Die Kollektion": "La collection",
"Kein Name.": "Aucun nom.",
"Nach Duftrichtung filtern": "Filtrer par famille olfactive",
"Alle": "Tous",
"In der Bar ansehen": "Voir dans le bar",
"Vom ersten Treffen": "De la première rencontre",
"bis zum letzten Flakon.": "au dernier flacon.",
"Ein Preis.": "Un prix.",
"Alles inbegriffen.": "Tout compris.",
"Wischt durch die Pakete und wählt, wie viele Gäste einen Flakon mitnehmen.": "Faites défiler les formules et choisissez combien d’invités repartent avec un flacon.",
"Anfrage": "Demande",
"Für die Darstellung laden wir Schriften von Google Fonts (Google, USA) und eine Grafikbibliothek über cdnjs (Cloudflare, USA). Dabei wird deine IP-Adresse an diese Anbieter übermittelt. Eine Übermittlung in die USA erfolgt auf Grundlage des Swiss-U.S. Data Privacy Framework oder anderer geeigneter Garantien.": "Pour l’affichage, nous chargeons des polices de Google Fonts (Google, États-Unis) et une bibliothèque graphique via cdnjs (Cloudflare, États-Unis). Votre adresse IP est alors transmise à ces prestataires. Le transfert vers les États-Unis repose sur le Swiss-U.S. Data Privacy Framework ou sur d’autres garanties appropriées."
},
"en": {
"Ein Moment, der bleibt.": "A moment that stays.",
"Überspringen": "Skip",
"Die Düfte": "The scents",
"Sprache": "Language",
"3D-Ansicht der L’ODAR Perfumebar. Ziehen zum Drehen, auf einen Spender tippen.": "3D view of the L’ODAR perfume bar. Drag to rotate, tap a dispenser.",
"Die L’ODAR Perfumebar": "The L’ODAR perfume bar",
"Perfumebar für Hochzeiten und Events": "Perfume bar for weddings and events",
"Düfte entdecken": "Discover the scents",
"Gewählter Duft": "Selected scent",
"Herren": "Men",
"Fruchtig-holzig": "Fruity woody",
"Ananas": "Pineapple",
"Bergamotte": "Bergamot",
"Eichenmoos": "Oakmoss",
"Saftige Ananas, Bergamotte und Eichenmoos. Strahlend und selbstbewusst.": "Juicy pineapple, bergamot and oakmoss. Radiant and confident.",
"Für den Tag": "For the day",
"Fruchtig": "Fruity",
"Passionsfrucht": "Passion fruit",
"Pfirsich": "Peach",
"Moschus": "Musk",
"Passionsfrucht und Pfirsich auf sinnlichem Moschus. Verführerisch und frei.": "Passion fruit and peach on sensual musk. Seductive and free.",
"Rauchig": "Smoky",
"Weihrauch": "Incense",
"Amber": "Amber",
"Oud": "Oud",
"Weihrauch, Amber und Oud. Rauchig, mächtig, geheimnisvoll.": "Incense, amber and oud. Smoky, powerful, mysterious.",
"Für die Nacht": "For the night",
"Würzige Vanille": "Spicy vanilla",
"Vanille": "Vanilla",
"Wildleder": "Suede",
"Pfeffer": "Pepper",
"Rohe Vanille, Wildleder und Pfeffer. Wild, warm und magnetisch.": "Raw vanilla, suede and pepper. Wild, warm and magnetic.",
"Blumig-ledrig": "Floral leather",
"V": "V",
"Hibiskus": "Hibiscus",
"Rose": "Rose",
"Leder": "Leather",
"Hibiskus und Damaszener Rose auf weichem Leder. Kühn und unvergesslich.": "Hibiscus and Damask rose on soft leather. Bold and unforgettable.",
"Für den Abend": "For the evening",
"Unisex": "Unisex",
"Milchig-blumig": "Milky floral",
"VI": "VI",
"Milch": "Milk",
"Tuberose": "Tuberose",
"Warme Milch, Tuberose und Moschus. Cremig, sinnlich und unendlich weich.": "Warm milk, tuberose and musk. Creamy, sensual and endlessly soft.",
"Süss-ambriert": "Sweet amber",
"VII": "VII",
"Meersalz": "Sea salt",
"Praline": "Praline",
"Meersalz trifft Praline und goldenes Amber. Süss, warm, unvergleichlich.": "Sea salt meets praline and golden amber. Sweet, warm, incomparable.",
"Damen": "Women",
"Pudrige Vanille": "Powdery vanilla",
"VIII": "VIII",
"Kokos": "Coconut",
"Puder": "Powder",
"Pudrige Vanille mit einem Hauch Kokos. Weich wie warmer Kaschmir.": "Powdery vanilla with a hint of coconut. Soft as warm cashmere.",
"Blumig-holzig": "Floral woody",
"IX": "IX",
"Birne": "Pear",
"Orangenblüte": "Orange blossom",
"Saftige Birne, Orangenblüte und Oud. Ein Sonnenuntergang an der Riviera.": "Juicy pear, orange blossom and oud. A sunset on the Riviera.",
"Fruchtig-blumig": "Fruity floral",
"X": "X",
"Litschi": "Lychee",
"Pfingstrose": "Peony",
"Kakao": "Cocoa",
"Litschi, Pfingstrose und ein Hauch Kakao. Verträumt und romantisch.": "Lychee, peony and a hint of cocoa. Dreamy and romantic.",
"Pudrig-holzig": "Powdery woody",
"XI": "XI",
"Sandelholz": "Sandalwood",
"Cremiges Sandelholz, Puder und Vanille. Pariser Eleganz auf der Haut.": "Creamy sandalwood, powder and vanilla. Parisian elegance on the skin.",
"Gourmand": "Gourmand",
"XII": "XII",
"Karamell": "Caramel",
"Tonka": "Tonka",
"Karamellisierter Zucker, Vanille und Tonka. Ein Dessert zum Tragen.": "Caramelised sugar, vanilla and tonka. A dessert to wear.",
"Duftnummer wählen": "Choose a scent number",
"Nummer I": "Number I",
"Nummer II": "Number II",
"Nummer III": "Number III",
"Nummer IV": "Number IV",
"Nummer V": "Number V",
"Nummer VI": "Number VI",
"Nummer VII": "Number VII",
"Nummer VIII": "Number VIII",
"Nummer IX": "Number IX",
"Nummer X": "Number X",
"Nummer XI": "Number XI",
"Nummer XII": "Number XII",
"Ziehen zum Drehen. Tippt auf eine Nummer, und die Bar füllt sie ab.": "Drag to rotate. Tap a number and the bar fills it.",
"Hochzeiten": "Weddings",
"Firmenanlässe": "Corporate events",
"Geburtstage": "Birthdays",
"Private Feiern": "Private parties",
"Extrait de Parfum aus Grasse": "Extrait de Parfum from Grasse",
"Vor euren Augen abgefüllt": "Filled before your eyes",
"Mit euren Namen": "With your names",
"Ein Duft, der bleibt": "A scent that stays",
"Die Kollektion": "The collection",
"Kein Name.": "No names.",
"Nach Duftrichtung filtern": "Filter by scent family",
"Alle": "All",
"In der Bar ansehen": "See it in the bar",
"Vom ersten Treffen": "From the first meeting",
"bis zum letzten Flakon.": "to the last bottle.",
"Ein Preis.": "One price.",
"Alles inbegriffen.": "Everything included.",
"Wischt durch die Pakete und wählt, wie viele Gäste einen Flakon mitnehmen.": "Swipe through the packages and choose how many guests take a bottle home.",
"Anfrage": "Enquiry",
"Für die Darstellung laden wir Schriften von Google Fonts (Google, USA) und eine Grafikbibliothek über cdnjs (Cloudflare, USA). Dabei wird deine IP-Adresse an diese Anbieter übermittelt. Eine Übermittlung in die USA erfolgt auf Grundlage des Swiss-U.S. Data Privacy Framework oder anderer geeigneter Garantien.": "For display purposes, we load fonts from Google Fonts (Google, USA) and a graphics library via cdnjs (Cloudflare, USA). In doing so, your IP address is transmitted to these providers. Transfers to the USA are based on the Swiss-U.S. Data Privacy Framework or other appropriate safeguards."
}
};
  for(var l in add){ D[l] = D[l] || {}; for(var k in add[l]) D[l][k] = add[l][k]; }
})();

}catch(e){console.error("[lodar-x-i18n.js]",e)}
/* ==== lodar-x4-i18n.js ==== */
try{
/* L'ODAR Maison v4: Texte fuer Bar und Flakon */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  var add = {
"fr": {
"Ein Duft.": "Un parfum.",
"Extraits de Parfum aus Grasse, an eurem Fest vor den Augen eurer Gäste abgefüllt. Stellt hier eure Bar zusammen.": "Des extraits de parfum de Grasse, mis en flacon pendant votre fête, sous les yeux de vos invités. Composez ici votre bar.",
"Eure Bar": "Votre bar",
"Sechs Düfte stehen schon in der Bar. Nehmt zuerst einen heraus.": "Six parfums sont déjà dans le bar. Retirez-en d’abord un.",
"In die Bar stellen": "Ajouter au bar",
"Aus der Bar nehmen": "Retirer du bar",
"Bar leeren": "Vider le bar",
"Wählt eure sechs Düfte": "Choisissez vos six parfums",
"Tippt auf eine Nummer: Der Spender kommt in die Bar und füllt einen Flakon mit 25 ml.": "Touchez un numéro : le distributeur arrive dans le bar et remplit un flacon de 25 ml.",
"Nummern": "Des numéros",
"statt Namen.": "plutôt que des noms.",
"Unsere Extraits tragen Nummern statt Namen, damit allein die Nase entscheidet. Beim Kennenlernen riecht ihr die ganze Kollektion und wählt sechs Düfte für euren Tag.": "Nos extraits portent des numéros au lieu de noms, pour que seul le nez décide. Lors de notre rencontre, vous sentez toute la collection et choisissez six parfums pour votre journée.",
"Die Düfte, seitlich verschiebbar": "Les parfums, défilement horizontal",
"Eure Namen": "Vos noms",
"auf jedem Flakon.": "sur chaque flacon.",
"Das Etikett macht aus jedem Duft ein Andenken an euren Tag. Schreibt eure Namen hinein und dreht den Flakon von allen Seiten.": "L’étiquette fait de chaque parfum un souvenir de votre journée. Écrivez vos noms et faites tourner le flacon pour le voir sous tous les angles.",
"Der 25-ml-Flakon mit eurem Etikett. Ziehen zum Drehen.": "Le flacon de 25 ml avec votre étiquette. Faites glisser pour le tourner.",
"Ziehen zum Drehen": "Faites glisser pour tourner",
"Nummern statt Namen": "Des numéros, pas de noms"
},
"en": {
"Ein Duft.": "A scent.",
"Extraits de Parfum aus Grasse, an eurem Fest vor den Augen eurer Gäste abgefüllt. Stellt hier eure Bar zusammen.": "Extraits de parfum from Grasse, filled at your celebration before your guests’ eyes. Put your bar together here.",
"Eure Bar": "Your bar",
"Sechs Düfte stehen schon in der Bar. Nehmt zuerst einen heraus.": "Six scents are already in the bar. Take one out first.",
"In die Bar stellen": "Add to your bar",
"Aus der Bar nehmen": "Remove from your bar",
"Bar leeren": "Clear the bar",
"Wählt eure sechs Düfte": "Choose your six scents",
"Tippt auf eine Nummer: Der Spender kommt in die Bar und füllt einen Flakon mit 25 ml.": "Tap a number: the dispenser comes into the bar and fills a 25 ml bottle.",
"Nummern": "Numbers",
"statt Namen.": "instead of names.",
"Unsere Extraits tragen Nummern statt Namen, damit allein die Nase entscheidet. Beim Kennenlernen riecht ihr die ganze Kollektion und wählt sechs Düfte für euren Tag.": "Our extraits carry numbers instead of names, so only your nose decides. When we meet, you smell the whole collection and choose six scents for your day.",
"Die Düfte, seitlich verschiebbar": "The scents, scroll sideways",
"Eure Namen": "Your names",
"auf jedem Flakon.": "on every bottle.",
"Das Etikett macht aus jedem Duft ein Andenken an euren Tag. Schreibt eure Namen hinein und dreht den Flakon von allen Seiten.": "The label turns every scent into a keepsake of your day. Type in your names and turn the bottle to see it from every angle.",
"Der 25-ml-Flakon mit eurem Etikett. Ziehen zum Drehen.": "The 25 ml bottle with your label. Drag to rotate.",
"Ziehen zum Drehen": "Drag to rotate",
"Nummern statt Namen": "Numbers, not names"
}
};
  for(var l in add){ D[l] = D[l] || {}; for(var k in add[l]) D[l][k] = add[l][k]; }
})();

}catch(e){console.error("[lodar-x4-i18n.js]",e)}
/* ==== lodar-x5-i18n.js ==== */
try{
/* L'ODAR Maison v5: Duftnoten, Seiten */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  var add = {
"fr": {
"Ananas": "Ananas",
"Bergamotte": "Bergamote",
"Grapefruit": "Pamplemousse",
"Jasmin": "Jasmin",
"Patchouli": "Patchouli",
"Zedernholz": "Bois de cèdre",
"Eichenmoos": "Mousse de chêne",
"Holznoten": "Notes boisées",
"Ambra": "Ambre gris",
"Passionsfrucht": "Fruit de la passion",
"Pfirsich": "Pêche",
"Birne": "Poire",
"Himbeere": "Framboise",
"Maiglöckchen": "Muguet",
"Pfingstrose": "Pivoine",
"Heliotrop": "Héliotrope",
"Vanille": "Vanille",
"Moschus": "Musc",
"Sandelholz": "Santal",
"Amber": "Ambre",
"Oregano": "Origan",
"Piment": "Piment",
"Elemi": "Élémi",
"Weihrauch": "Encens",
"Opoponax": "Opoponax",
"Zistrose": "Ciste",
"Oud": "Oud",
"Leder": "Cuir",
"Rosa Pfeffer": "Baies roses",
"Schwarzer Pfeffer": "Poivre noir",
"Wildleder": "Daim",
"Safran": "Safran",
"Olibanum": "Oliban",
"Labdanum": "Labdanum",
"Hibiskus": "Hibiscus",
"Sauerkirsche": "Griotte",
"Yuzu": "Yuzu",
"Rose": "Rose",
"Osmanthus": "Osmanthus",
"Iris": "Iris",
"Kardamom": "Cardamome",
"Tuberose": "Tubéreuse",
"Narzisse": "Narcisse",
"Kokos": "Noix de coco",
"Ambroxan": "Ambroxan",
"Orangenblüte": "Fleur d’oranger",
"Ylang-Ylang": "Ylang-ylang",
"Pudrige Noten": "Notes poudrées",
"Moschusmalve": "Ambrette",
"Tonkabohne": "Fève tonka",
"Zitrone": "Citron",
"Mandarine": "Mandarine",
"Schwarze Johannisbeere": "Cassis",
"Litschi": "Litchi",
"Magnolie": "Magnolia",
"Veilchen": "Violette",
"Benzoe": "Benjoin",
"Crème brûlée": "Crème brûlée",
"Haselnuss": "Noisette",
"Karamell": "Caramel",
"Fruchtig-holzig": "Boisé fruité",
"Saftige Ananas und Bergamotte über Eichenmoos und Ambra. Strahlend und selbstbewusst.": "Ananas juteux et bergamote sur mousse de chêne et ambre gris. Lumineux et affirmé.",
"Fruchtig-blumig": "Floral fruité",
"Passionsfrucht und Pfirsich, dann Pfingstrose auf weichem Moschus. Verführerisch und frei.": "Fruit de la passion et pêche, puis pivoine sur un musc doux. Séduisant et libre.",
"Rauchig-harzig": "Résineux fumé",
"Weihrauch, Opoponax und Oud auf dunklem Leder. Rauchig, mächtig, geheimnisvoll.": "Encens, opoponax et oud sur un cuir sombre. Fumé, puissant, mystérieux.",
"Würzig-ledrig": "Cuir épicé",
"Rosa Pfeffer, Safran und Wildleder auf warmer Vanille. Wild und magnetisch.": "Baies roses, safran et daim sur une vanille chaude. Sauvage et magnétique.",
"Blumig-ledrig": "Floral cuiré",
"Hibiskus und Sauerkirsche, dann Rose auf weichem Leder. Kühn und unvergesslich.": "Hibiscus et griotte, puis la rose sur un cuir souple. Audacieux et inoubliable.",
"Cremig-blumig": "Floral crémeux",
"Tuberose und Kokos auf Vanille und Moschus. Cremig, sinnlich, unendlich weich.": "Tubéreuse et coco sur vanille et musc. Crémeux, sensuel, infiniment doux.",
"Orientalisch-blumig": "Floral oriental",
"Safran und Rose über Oud, Amber und Vanille. Warm, edel, unvergleichlich.": "Safran et rose sur oud, ambre et vanille. Chaud, noble, incomparable.",
"Pudrige Vanille": "Vanille poudrée",
"Iris und pudrige Noten mit einem Hauch Kokos auf Tonka. Weich wie warmer Kaschmir.": "Iris et notes poudrées avec une touche de coco sur la fève tonka. Doux comme un cachemire tiède.",
"Zitrisch-blumig": "Floral hespéridé",
"Zitrone, Mandarine und Orangenblüte auf Sandelholz. Ein Sonnenuntergang an der Riviera.": "Citron, mandarine et fleur d’oranger sur le santal. Un coucher de soleil sur la Riviera.",
"Litschi, Pfingstrose und Magnolie auf hellem Moschus. Verträumt und romantisch.": "Litchi, pivoine et magnolia sur un musc clair. Rêveur et romantique.",
"Pudrig-holzig": "Boisé poudré",
"Iris, Veilchen und Sandelholz auf Tonka und Leder. Pariser Eleganz auf der Haut.": "Iris, violette et santal sur fève tonka et cuir. L’élégance parisienne sur la peau.",
"Gourmand": "Gourmand",
"Crème brûlée, Haselnuss und Karamell auf Tonka. Ein Dessert zum Tragen.": "Crème brûlée, noisette et caramel sur la fève tonka. Un dessert à porter.",
"Für den Tag": "Pour la journée",
"Für den Abend": "Pour le soir",
"Für die Nacht": "Pour la nuit",
"Herren": "Homme",
"Damen": "Femme",
"Unisex": "Unisexe",
"Kopf": "Tête",
"Herz": "Cœur",
"Basis": "Fond",
"Etikett": "Étiquette",
"Menü": "Menu",
"Die Bar": "Le bar",
"Euer Etikett": "Votre étiquette",
"Anfrage": "Demande",
"Fragen": "Questions",
"Pakete": "Formules",
"Das Erlebnis": "L’expérience",
"Die Düfte": "Les parfums",
"Sechs Düfte stehen schon in der Bar. Tippt auf eine gewählte Nummer, um sie herauszunehmen.": "Six parfums sont déjà dans le bar. Touchez un numéro choisi pour le retirer.",
"Tippt auf eine Nummer, und der Spender füllt einen 25-ml-Flakon. Nochmals tippen nimmt ihn wieder heraus.": "Touchez un numéro et le distributeur remplit un flacon de 25 ml. Touchez à nouveau pour le retirer.",
"L’ODAR Maison": "L’ODAR Maison",
"Willkommen": "Bienvenue",
"in der Perfumebar.": "au bar à parfum.",
"Kopf-, Herz- und Basisnoten jeder Nummer.": "Notes de tête, de cœur et de fond de chaque numéro.",
"Erlebnis ansehen": "Voir l’expérience",
"Vom ersten Treffen bis zum letzten Flakon.": "De la première rencontre au dernier flacon.",
"Eure Namen auf jedem Flakon, live gestaltet.": "Vos noms sur chaque flacon, conçus en direct.",
"Etikett gestalten": "Créer l’étiquette",
"Ein Preis, alles inbegriffen, ab CHF 700.": "Un prix, tout compris, dès CHF 700.",
"Pakete ansehen": "Voir les formules",
"Vier kurze Fragen, ganz unverbindlich.": "Quatre questions courtes, sans engagement.",
"Alles zu Ablauf, Ort und Bezahlung.": "Tout sur le déroulement, le lieu et le paiement.",
"Fragen lesen": "Lire les questions",
"I · Die Kollektion": "I · La collection",
"Unsere Extraits tragen Nummern statt Namen, damit allein die Nase entscheidet. Hier seht ihr Kopf-, Herz- und Basisnoten jeder Nummer. Beim Kennenlernen riecht ihr die ganze Kollektion und wählt sechs Düfte für euren Tag.": "Nos extraits portent des numéros au lieu de noms, pour que seul le nez décide. Retrouvez ici les notes de tête, de cœur et de fond de chaque numéro. Lors de notre rencontre, vous découvrez toute la collection et choisissez six parfums pour votre journée.",
"In eurer Bar": "Dans votre bar",
"Eure Bar": "Votre bar",
"Zur Bar": "Voir votre bar",
"II · Das Erlebnis": "II · L’expérience",
"So läuft es ab, von eurer Anfrage bis zu dem Moment, in dem eure Gäste ihren Duft mit nach Hause nehmen.": "Voici comment tout se déroule, de votre demande jusqu’au moment où vos invités repartent avec leur parfum.",
"III · Euer Etikett": "III · Votre étiquette",
"IV · Pakete": "IV · Formules",
"V · Anfrage": "V · Demande",
"VI · Fragen": "VI · Questions",
"Häufige": "Questions",
"Fragen.": "fréquentes.",
"Was ihr vor der Buchung wissen wollt. Fehlt etwas? Schreibt uns an": "Tout ce qu’il faut savoir avant de réserver. Une question sans réponse ? Écrivez-nous à",
"Ein Preis.": "Un prix.",
"Alles inbegriffen.": "Tout compris.",
"Bar": "Demander",
"anfragen.": "le bar.",
"Eure Bar:": "Votre bar :",
"ändern": "modifier",
"Weiter": "Continuer",
"Zurück": "Retour",
"Abschnitte": "Rubriques",
"steht jetzt in eurer Bar.": "est maintenant dans votre bar.",
"ist nicht mehr in eurer Bar.": "n’est plus dans votre bar.",
"Eure Bar ist voll. Nehmt zuerst einen Duft heraus.": "Votre bar est complet. Retirez d’abord un parfum.",
"Nummern": "Des numéros",
"statt Namen.": "plutôt que des noms."
},
"en": {
"Ananas": "Pineapple",
"Bergamotte": "Bergamot",
"Grapefruit": "Grapefruit",
"Jasmin": "Jasmine",
"Patchouli": "Patchouli",
"Zedernholz": "Cedarwood",
"Eichenmoos": "Oakmoss",
"Holznoten": "Woody notes",
"Ambra": "Ambergris",
"Passionsfrucht": "Passion fruit",
"Pfirsich": "Peach",
"Birne": "Pear",
"Himbeere": "Raspberry",
"Maiglöckchen": "Lily of the valley",
"Pfingstrose": "Peony",
"Heliotrop": "Heliotrope",
"Vanille": "Vanilla",
"Moschus": "Musk",
"Sandelholz": "Sandalwood",
"Amber": "Amber",
"Oregano": "Oregano",
"Piment": "Pimento",
"Elemi": "Elemi",
"Weihrauch": "Frankincense",
"Opoponax": "Opoponax",
"Zistrose": "Cistus",
"Oud": "Oud",
"Leder": "Leather",
"Rosa Pfeffer": "Pink pepper",
"Schwarzer Pfeffer": "Black pepper",
"Wildleder": "Suede",
"Safran": "Saffron",
"Olibanum": "Olibanum",
"Labdanum": "Labdanum",
"Hibiskus": "Hibiscus",
"Sauerkirsche": "Sour cherry",
"Yuzu": "Yuzu",
"Rose": "Rose",
"Osmanthus": "Osmanthus",
"Iris": "Iris",
"Kardamom": "Cardamom",
"Tuberose": "Tuberose",
"Narzisse": "Narcissus",
"Kokos": "Coconut",
"Ambroxan": "Ambroxan",
"Orangenblüte": "Orange blossom",
"Ylang-Ylang": "Ylang-ylang",
"Pudrige Noten": "Powdery notes",
"Moschusmalve": "Musk mallow",
"Tonkabohne": "Tonka bean",
"Zitrone": "Lemon",
"Mandarine": "Mandarin",
"Schwarze Johannisbeere": "Blackcurrant",
"Litschi": "Lychee",
"Magnolie": "Magnolia",
"Veilchen": "Violet",
"Benzoe": "Benzoin",
"Crème brûlée": "Crème brûlée",
"Haselnuss": "Hazelnut",
"Karamell": "Caramel",
"Fruchtig-holzig": "Fruity woody",
"Saftige Ananas und Bergamotte über Eichenmoos und Ambra. Strahlend und selbstbewusst.": "Juicy pineapple and bergamot over oakmoss and ambergris. Radiant and confident.",
"Fruchtig-blumig": "Fruity floral",
"Passionsfrucht und Pfirsich, dann Pfingstrose auf weichem Moschus. Verführerisch und frei.": "Passion fruit and peach, then peony on soft musk. Seductive and free-spirited.",
"Rauchig-harzig": "Smoky resinous",
"Weihrauch, Opoponax und Oud auf dunklem Leder. Rauchig, mächtig, geheimnisvoll.": "Frankincense, opoponax and oud on dark leather. Smoky, powerful, mysterious.",
"Würzig-ledrig": "Spicy leather",
"Rosa Pfeffer, Safran und Wildleder auf warmer Vanille. Wild und magnetisch.": "Pink pepper, saffron and suede on warm vanilla. Wild and magnetic.",
"Blumig-ledrig": "Floral leather",
"Hibiskus und Sauerkirsche, dann Rose auf weichem Leder. Kühn und unvergesslich.": "Hibiscus and sour cherry, then rose on soft leather. Bold and unforgettable.",
"Cremig-blumig": "Creamy floral",
"Tuberose und Kokos auf Vanille und Moschus. Cremig, sinnlich, unendlich weich.": "Tuberose and coconut on vanilla and musk. Creamy, sensual, endlessly soft.",
"Orientalisch-blumig": "Amber floral",
"Safran und Rose über Oud, Amber und Vanille. Warm, edel, unvergleichlich.": "Saffron and rose over oud, amber and vanilla. Warm, refined, incomparable.",
"Pudrige Vanille": "Powdery vanilla",
"Iris und pudrige Noten mit einem Hauch Kokos auf Tonka. Weich wie warmer Kaschmir.": "Iris and powdery notes with a hint of coconut on tonka. Soft as warm cashmere.",
"Zitrisch-blumig": "Citrus floral",
"Zitrone, Mandarine und Orangenblüte auf Sandelholz. Ein Sonnenuntergang an der Riviera.": "Lemon, mandarin and orange blossom on sandalwood. A sunset on the Riviera.",
"Litschi, Pfingstrose und Magnolie auf hellem Moschus. Verträumt und romantisch.": "Lychee, peony and magnolia on light musk. Dreamy and romantic.",
"Pudrig-holzig": "Powdery woody",
"Iris, Veilchen und Sandelholz auf Tonka und Leder. Pariser Eleganz auf der Haut.": "Iris, violet and sandalwood on tonka and leather. Parisian elegance on the skin.",
"Gourmand": "Gourmand",
"Crème brûlée, Haselnuss und Karamell auf Tonka. Ein Dessert zum Tragen.": "Crème brûlée, hazelnut and caramel on tonka. A dessert to wear.",
"Für den Tag": "For the day",
"Für den Abend": "For the evening",
"Für die Nacht": "For the night",
"Herren": "Men",
"Damen": "Women",
"Unisex": "Unisex",
"Kopf": "Top",
"Herz": "Heart",
"Basis": "Base",
"Etikett": "Label",
"Menü": "Menu",
"Die Bar": "The bar",
"Euer Etikett": "Your label",
"Anfrage": "Enquiry",
"Fragen": "Questions",
"Pakete": "Packages",
"Das Erlebnis": "The experience",
"Die Düfte": "The scents",
"Sechs Düfte stehen schon in der Bar. Tippt auf eine gewählte Nummer, um sie herauszunehmen.": "Six scents are already in the bar. Tap a chosen number to take it out.",
"Tippt auf eine Nummer, und der Spender füllt einen 25-ml-Flakon. Nochmals tippen nimmt ihn wieder heraus.": "Tap a number and the dispenser fills a 25 ml bottle. Tap again to take it out.",
"L’ODAR Maison": "L’ODAR Maison",
"Willkommen": "Welcome",
"in der Perfumebar.": "to the perfume bar.",
"Kopf-, Herz- und Basisnoten jeder Nummer.": "Top, heart and base notes of every number.",
"Erlebnis ansehen": "Discover the experience",
"Vom ersten Treffen bis zum letzten Flakon.": "From the first meeting to the last bottle.",
"Eure Namen auf jedem Flakon, live gestaltet.": "Your names on every bottle, designed live.",
"Etikett gestalten": "Design the label",
"Ein Preis, alles inbegriffen, ab CHF 700.": "One price, everything included, from CHF 700.",
"Pakete ansehen": "See the packages",
"Vier kurze Fragen, ganz unverbindlich.": "Four short questions, no obligation.",
"Alles zu Ablauf, Ort und Bezahlung.": "Everything about the process, venue and payment.",
"Fragen lesen": "Read the questions",
"I · Die Kollektion": "I · The collection",
"Unsere Extraits tragen Nummern statt Namen, damit allein die Nase entscheidet. Hier seht ihr Kopf-, Herz- und Basisnoten jeder Nummer. Beim Kennenlernen riecht ihr die ganze Kollektion und wählt sechs Düfte für euren Tag.": "Our extraits carry numbers instead of names, so only your nose decides. Here you can see the top, heart and base notes of every number. When we meet, you will try the whole collection and choose six scents for your day.",
"In eurer Bar": "In your bar",
"Eure Bar": "Your bar",
"Zur Bar": "View your bar",
"II · Das Erlebnis": "II · The experience",
"So läuft es ab, von eurer Anfrage bis zu dem Moment, in dem eure Gäste ihren Duft mit nach Hause nehmen.": "This is how it works, from your enquiry to the moment your guests take their scent home.",
"III · Euer Etikett": "III · Your label",
"IV · Pakete": "IV · Packages",
"V · Anfrage": "V · Enquiry",
"VI · Fragen": "VI · Questions",
"Häufige": "Frequently asked",
"Fragen.": "questions.",
"Was ihr vor der Buchung wissen wollt. Fehlt etwas? Schreibt uns an": "What you want to know before booking. Something missing? Write to us at",
"Ein Preis.": "One price.",
"Alles inbegriffen.": "Everything included.",
"Bar": "Book",
"anfragen.": "the bar.",
"Eure Bar:": "Your bar:",
"ändern": "change",
"Weiter": "Next",
"Zurück": "Back",
"Abschnitte": "Sections",
"steht jetzt in eurer Bar.": "– now in your bar.",
"ist nicht mehr in eurer Bar.": "– no longer in your bar.",
"Eure Bar ist voll. Nehmt zuerst einen Duft heraus.": "Your bar is full. Take a scent out first.",
"Nummern": "Numbers",
"statt Namen.": "instead of names."
}
};
  for(var l in add){ D[l] = D[l] || {}; for(var k in add[l]) D[l][k] = add[l][k]; }
})();

}catch(e){console.error("[lodar-x5-i18n.js]",e)}
/* ==== v18 i18n ==== */
try{
/* L'ODAR Maison v18: fehlende Uebersetzungen. Laeuft nach den Woerterbuechern und vor lodar-x9.js (Adresse). */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  D.fr = D.fr || {}; D.en = D.en || {};
  function swap(s, pairs){ for(var i = 0; i < pairs.length; i++) s = s.split(pairs[i][0]).join(pairs[i][1]); return s; }
  /* 1. Paket fuer 25 Gaeste: Schluessel und Werte aus den Texten mit 20 Gaesten ableiten */
  var K25 = [['Bis 20 Gäste', 'Bis 25 Gäste'], ['bis 20 Gäste', 'bis 25 Gäste'], ['20 Flakons à 25 ml', '25 Flakons à 25 ml']];
  var V25 = {
    fr: [['Jusqu’à 20 invités', 'Jusqu’à 25 invités'], ['jusqu’à 20 invités', 'jusqu’à 25 invités'], ['20 flacons', '25 flacons']],
    en: [['Up to 20 guests', 'Up to 25 guests'], ['up to 20 guests', 'up to 25 guests'], ['20 bottles', '25 bottles']]
  };
  ['fr','en'].forEach(function(l){
    Object.keys(D[l]).forEach(function(k){
      var nk = swap(k, K25);
      if(nk !== k && !D[l].hasOwnProperty(nk)) D[l][nk] = swap(String(D[l][k]), V25[l]);
    });
  });
  /* 2. AGB 1 auf Franzoesisch: neue Adresse (lodar-x9.js uebernimmt den Wert fuer den Schluessel mit der neuen Adresse) */
  Object.keys(D.fr).forEach(function(k){
    if(k.indexOf('Inhaber Hassen Ltaief, Südstrasse 2, 2504 Biel') > -1) D.fr[k] = String(D.fr[k]).split('Südstrasse 2, 2504 Bienne').join('Reitschulstrasse 5, 2502 Bienne');
  });
  /* 3. Ueber uns, Seite 404 und Impressum-Adresse (Entwuerfe, vom Inhaber zu pruefen) */
  var T = {
    'Über uns': ['À propos', 'About us'],
    'Mehr erfahren': ['En savoir plus', 'Learn more'],
    'Wer hinter L’ODAR steht und wofür wir stehen.': ['Qui se trouve derrière L’ODAR et ce qui nous tient à cœur.', 'Who is behind L’ODAR and what we stand for.'],
    'VII · Über uns': ['VII · À propos', 'VII · About us'],
    'Ein Haus': ['Une maison', 'A house'],
    'für Düfte, die bleiben.': ['pour des parfums qui restent.', 'for scents that stay.'],
    'L’ODAR ist eine Schweizer Perfumebar. Wir bringen Extraits de Parfum aus Grasse an Hochzeiten und Events in der ganzen Schweiz und füllen sie vor den Augen eurer Gäste ab.': ['L’ODAR est un bar à parfum suisse. Nous apportons des extraits de parfum de Grasse aux mariages et aux événements dans toute la Suisse et les remplissons sous les yeux de vos invités.', 'L’ODAR is a Swiss perfume bar. We bring extraits de parfum from Grasse to weddings and events all over Switzerland and fill them in front of your guests.'],
    'Ein Duft hält fest, was ein Foto nicht kann: wie sich ein Abend angefühlt hat.': ['Un parfum retient ce qu’une photo ne peut pas retenir : ce que l’on a ressenti ce soir-là.', 'A scent captures what a photo cannot: how an evening felt.'],
    'Darum gibt es L’ODAR. Statt eines Gastgeschenks, das in einer Schublade verschwindet, nehmen eure Gäste ein Extrait de Parfum mit nach Hause. Abgefüllt an eurem Fest, mit euren Namen auf dem Flakon. Jedes Mal, wenn sie ihn tragen, sind sie für einen Moment wieder bei euch.': ['C’est pour cela que L’ODAR existe. Au lieu d’un cadeau qui finit au fond d’un tiroir, vos invités rapportent chez eux un extrait de parfum. Mis en flacon pendant votre fête, à vos noms. Chaque fois qu’ils le portent, ils se retrouvent un instant à vos côtés.', 'That is why L’ODAR exists. Instead of a favour that disappears into a drawer, your guests take an extrait de parfum home with them. Filled at your celebration, with your names on the bottle. Every time they wear it, they are back with you for a moment.'],
    'Wir arbeiten bewusst klein und persönlich. Jede Bar bauen wir selbst auf und begleiten sie, vom ersten Kennenlernen bis zum letzten Flakon.': ['Nous restons volontairement une maison à taille humaine. Nous installons nous-mêmes chaque bar et vous accompagnons, de la première rencontre au dernier flacon.', 'We deliberately keep things small and personal. We set up every bar ourselves and look after it, from the first meeting to the last bottle.'],
    'Wofür wir stehen': ['Ce qui nous tient à cœur', 'What we stand for'],
    'Fünf': ['Cinq', 'Five'],
    'Versprechen.': ['promesses.', 'promises.'],
    'Aus Grasse': ['De Grasse', 'From Grasse'],
    'Unsere Extraits de Parfum stammen aus Grasse, der Heimat der französischen Parfümerie. Hoch konzentriert, damit sie bleiben.': ['Nos extraits de parfum viennent de Grasse, berceau de la parfumerie française. Très concentrés, pour qu’ils tiennent.', 'Our extraits de parfum come from Grasse, the home of French perfumery. Highly concentrated, so they last.'],
    'Jeder Duft trägt eine römische Nummer. So entscheidet allein die Nase, nicht ein Name auf der Flasche.': ['Chaque parfum porte un numéro en chiffres romains. Ainsi, seul le nez décide, et non un nom sur le flacon.', 'Every scent carries a Roman numeral. So only your nose decides, not a name on the bottle.'],
    'Vor euren Augen': ['Sous vos yeux', 'Before your eyes'],
    'Abgefüllt wird live an eurem Fest. Jeder Gast füllt seinen eigenen Flakon und sieht, wie sein Duft entsteht.': ['Le remplissage se fait en direct pendant votre fête. Chaque invité remplit son propre flacon et voit naître son parfum.', 'The filling happens live at your celebration. Every guest fills their own bottle and watches their scent come to life.'],
    'Jedes Etikett trägt eure Namen und euer Datum. Gedruckt wird erst, wenn ihr es freigegeben habt.': ['Chaque étiquette porte vos noms et la date. Elle n’est imprimée qu’une fois que vous l’avez validée.', 'Every label carries your names and your date. It is only printed once you have approved it.'],
    'Persönlich': ['En personne', 'Personal'],
    'Wir sind selbst an eurem Fest und begleiten eure Gäste, in der ganzen Schweiz, auf Deutsch, Französisch und Englisch.': ['Nous sommes nous-mêmes présents à votre fête et accompagnons vos invités, dans toute la Suisse, en allemand, en français et en anglais.', 'We are there in person at your celebration and look after your guests in German, French and English, anywhere in Switzerland.'],
    '25': ['25', '25'],
    '404': ['404', '404'],
    'Diese Seite': ['Cette page', 'This page'],
    'gibt es nicht.': ['n’existe pas.', 'does not exist.'],
    'Der Link ist veraltet oder falsch geschrieben.': ['Le lien est obsolète ou erroné.', 'The link is out of date or misspelled.'],
    'Zur Startseite': ['Retour à l’accueil', 'Back to the homepage'],
    'Reitschulstrasse 5': ['Reitschulstrasse 5', 'Reitschulstrasse 5'],
    '2502 Biel': ['2502 Bienne', '2502 Biel'],
    /* per Skript erzeugt: Leiste unten (lodar-x7.js) und Duftkarten (lodar-x9.js) */
    'Düfte': ['Parfums', 'Scents'],
    'Mehr': ['Plus', 'More'],
    'Schnellnavigation': ['Navigation rapide', 'Quick navigation'],
    'Duft wählen': ['Choisir un parfum', 'Choose a scent'],
    /* B3: Barrierefreiheit, Formular (Entwuerfe, vom Inhaber zu pruefen) */
    'Intro': ['Intro', 'Intro'],
    'Zum Inhalt springen': ['Aller au contenu', 'Skip to content'],
    'Eintreten': ['Entrer', 'Enter'],
    'Vorherige Karte': ['Carte précédente', 'Previous card'],
    'Nächste Karte': ['Carte suivante', 'Next card'],
    'Karten': ['Cartes', 'Cards'],
    'Fotos': ['Photos', 'Photos'],
    'Nummer': ['Numéro', 'Number'],
    'Laufband anhalten': ['Mettre le défilement en pause', 'Pause the scrolling text'],
    '3D-Ansicht der L’ODAR Perfumebar mit den Spendern eurer gewählten Düfte': ['Vue 3D du bar à parfum L’ODAR avec les distributeurs des parfums que vous avez choisis', '3D view of the L’ODAR Perfumebar with the dispensers of the scents you have chosen'],
    '3D-Ansicht des 25-ml-Flakons mit eurem Etikett': ['Vue 3D du flacon de 25 ml avec votre étiquette', '3D view of the 25 ml bottle with your label'],
    'Bitte gebt euren Namen an.': ['Veuillez indiquer votre nom.', 'Please enter your name.'],
    'Bitte gebt eine gültige E-Mail-Adresse an.': ['Veuillez indiquer une adresse e-mail valide.', 'Please enter a valid email address.'],
    /* B4: Seitentitel (document.title wird per exaktem Text uebersetzt; Quelle: theme.liquid) */
    'L’ODAR Perfumebar für Hochzeiten & Events – Ein Duft, der bleibt': ['L’ODAR Perfumebar pour mariages et événements – Un parfum qui reste', 'L’ODAR Perfumebar for weddings & events – A scent that stays'],
    'Die Düfte: Extraits de Parfum aus Grasse – L’ODAR': ['Les parfums : extraits de parfum de Grasse – L’ODAR', 'The scents: extraits de parfum from Grasse – L’ODAR'],
    'Das Erlebnis: so läuft die Perfumebar ab – L’ODAR': ['L’expérience : le déroulement du bar à parfum – L’ODAR', 'The experience: how the perfume bar works – L’ODAR'],
    'Euer Etikett: eure Namen auf jedem Flakon – L’ODAR': ['Votre étiquette : vos noms sur chaque flacon – L’ODAR', 'Your label: your names on every bottle – L’ODAR'],
    'Pakete und Preise ab CHF 700 – L’ODAR Perfumebar': ['Formules et prix dès CHF 700 – L’ODAR Perfumebar', 'Packages and prices from CHF 700 – L’ODAR Perfumebar'],
    'Perfumebar unverbindlich anfragen – L’ODAR': ['Demander le bar à parfum sans engagement – L’ODAR', 'Enquire about the perfume bar, no obligation – L’ODAR'],
    'Häufige Fragen zur Perfumebar – L’ODAR': ['Questions fréquentes sur le bar à parfum – L’ODAR', 'Frequently asked questions about the perfume bar – L’ODAR'],
    'Über uns – L’ODAR Perfumebar': ['À propos – L’ODAR Perfumebar', 'About us – L’ODAR Perfumebar'],
    'Seite nicht gefunden – L’ODAR': ['Page introuvable – L’ODAR', 'Page not found – L’ODAR'],
    /* B4: Owner-Entscheide #2, #3, #9, #11, #16, #17 (Entwuerfe, vom Inhaber zu pruefen) */
    'Wofür L’ODAR steht und wie wir arbeiten.': ['Ce que représente L’ODAR et notre façon de travailler.', 'What L’ODAR stands for and how we work.'],
    'Vor den Augen eurer Gäste abgefüllt: Jeder Gast nimmt sein Extrait de Parfum im 25-ml-Flakon mit nach Hause.': ['Rempli sous les yeux de vos invités : chaque invité rapporte chez lui son extrait de parfum dans un flacon de 25 ml.', 'Filled in front of your guests: every guest takes their extrait de parfum home in a 25 ml bottle.'],
    'L’ODAR ist eine Schweizer Perfumebar. Wir bringen Extraits de Parfum aus Grasse an Hochzeiten und Events in der ganzen Schweiz, wo sie vor den Augen eurer Gäste abgefüllt werden.': ['L’ODAR est un bar à parfum suisse. Nous apportons nos extraits de parfum de Grasse aux mariages et aux événements dans toute la Suisse, où ils sont mis en flacon sous les yeux de vos invités.', 'L’ODAR is a Swiss perfume bar. We bring extraits de parfum from Grasse to weddings and events all over Switzerland, where they are filled in front of your guests.'],
    'Abgefüllt wird live an eurem Fest, vor den Augen eurer Gäste. So sieht jeder Gast, wie sein Flakon gefüllt wird.': ['Le remplissage se fait en direct pendant votre fête, sous les yeux de vos invités. Chaque invité voit ainsi son flacon se remplir.', 'The filling happens live at your celebration, in front of your guests. Every guest sees their bottle being filled.'],
    'Im Preis enthalten sind das Vorgespräch, die Perfumebar mit Auf- und Abbau, die Betreuung während rund 4 Stunden sowie die vereinbarte Anzahl 25-ml-Flakons mit Etiketten. Der Kunde stellt eine ebene, wettergeschützte Fläche von mindestens 2 × 1.5 m und einen Zugang für den Aufbau zur Verfügung. Die Anfahrtskosten werden vor Vertragsabschluss individuell vereinbart und im Angebot ausgewiesen. Zusätzliche Stunden werden nach Absprache verrechnet.': ['Le prix comprend l’entretien préalable, le bar à parfum avec montage et démontage, le service pendant environ 4 heures ainsi que le nombre convenu de flacons de 25 ml avec étiquettes. Le client met à disposition une surface plane et abritée d’au moins 2 × 1,5 m et un accès pour le montage. Les frais de déplacement sont convenus individuellement avant la conclusion du contrat et figurent dans l’offre. Les heures supplémentaires sont facturées selon accord.', 'The price includes the consultation, the perfume bar with set-up and dismantling, service for about 4 hours and the agreed number of 25 ml bottles with labels. The customer provides a flat, sheltered area of at least 2 × 1.5 m and access for set-up. Travel costs are agreed individually before the contract is concluded and are shown in the quote. Extra hours are charged by arrangement.'],
    'Shopify setzt technisch notwendige Cookies, die für den Betrieb der Website erforderlich sind. Weitere Cookies, etwa für Analyse oder Marketing, werden nur gesetzt, wenn du ihnen über das Cookie-Banner zustimmst. Für Komfortfunktionen wie die gewählte Sprache speichern wir Angaben lokal in deinem Browser. Diese Daten verlassen dein Gerät nicht und du kannst sie jederzeit in den Browser-Einstellungen löschen.': ['Shopify utilise des cookies techniquement nécessaires au fonctionnement du site. D’autres cookies, par exemple d’analyse ou de marketing, ne sont déposés que si vous y consentez via la bannière de cookies. Pour des fonctions de confort comme la langue choisie, nous enregistrons des informations localement dans votre navigateur. Ces données ne quittent pas votre appareil et vous pouvez les supprimer à tout moment dans les réglages du navigateur.', 'Shopify sets technically necessary cookies that are required to run the website. Other cookies, for example for analytics or marketing, are only set if you agree to them in the cookie banner. For convenience features such as the chosen language we store information locally in your browser. This data does not leave your device and you can delete it at any time in your browser settings.'],
    'Gut zu wissen': ['Bon à savoir', 'Good to know'],
    'Alle Düfte riecht ihr beim Kennenlernen, bevor ihr unterschreibt.': ['Vous découvrez tous les parfums lors de notre rencontre, avant de signer.', 'You will try every scent at our first meeting, before you sign anything.'],
    'Feste Paketpreise ab CHF 700.': ['Des prix fixes par formule, dès CHF 700.', 'Fixed package prices from CHF 700.'],
    'Gedruckt wird erst nach eurer Freigabe.': ['L’impression n’a lieu qu’après votre validation.', 'Nothing is printed until you approve it.'],
    'Betreuung auf Deutsch, Französisch und Englisch.': ['Accompagnement en allemand, en français et en anglais.', 'Service in German, French and English.'],
    /* B4: Bildbeschreibungen (Alt-Texte) der Fotos, sachlich nach Ansicht der Bilder */
    'Die L’ODAR Perfumebar mit Duftspendern, Flakons und einem weissen Kerzenleuchter': ['Le bar à parfum L’ODAR avec ses distributeurs, des flacons et un chandelier blanc', 'The L’ODAR perfume bar with dispensers, bottles and a white candelabra'],
    'Eine Reihe gefüllter Duftspender mit L’ODAR-Etiketten': ['Une rangée de distributeurs remplis, avec étiquettes L’ODAR', 'A row of filled dispensers with L’ODAR labels'],
    'L’ODAR-Flakons mit schwarzen Kugelverschlüssen auf weissen Stufen, dahinter die Duftspender': ['Flacons L’ODAR à bouchon noir sphérique sur des marches blanches, avec les distributeurs à l’arrière', 'L’ODAR bottles with black spherical caps on white steps, with the dispensers behind them'],
    'Flakon L’ODAR Extrait de Parfum mit schwarzem Kugelverschluss': ['Flacon L’ODAR Extrait de Parfum à bouchon noir sphérique', 'L’ODAR Extrait de Parfum bottle with a black spherical cap'],
    'Die L’ODAR Perfumebar von oben, mit Duftspendern und Flakons': ['Le bar à parfum L’ODAR vu d’en haut, avec ses distributeurs et des flacons', 'The L’ODAR perfume bar seen from above, with dispensers and bottles'],
    'Ein einzelner Duftspender mit L’ODAR-Etikett': ['Un distributeur seul avec étiquette L’ODAR', 'A single dispenser with an L’ODAR label'],
    /* v18 editorial (Teil A): Fusszeile, Seitenabschluss, Startseite, Duefte, Erlebnis, Ueber uns (Entwuerfe, vom Inhaber zu pruefen) */
    'Ein Duft, der bleibt.': ['Un parfum qui reste.', 'A scent that stays.'],
    'Seiten': ['Pages', 'Pages'],
    'Kontakt': ['Contact', 'Contact'],
    'Rechtliches': ['Informations légales', 'Legal'],
    'Erzählt uns von eurem Fest.': ['Parlez-nous de votre fête.', 'Tell us about your celebration.'],
    'Unverbindlich · Druck erst nach eurer Freigabe · Betreuung auf Deutsch, Französisch und Englisch': ['Sans engagement · Impression seulement après votre validation · Accompagnement en allemand, français et anglais', 'No obligation · Printed only after your approval · Service in German, French and English'],
    'Riechen könnt ihr die ganze Kollektion beim Kennenlernen.': ['Vous découvrez toute la collection lors de notre rencontre.', 'You can try the whole collection when we meet.'],
    'Die Kollektion': ['La collection', 'The collection'],
    'zum Fixpreis.': ['à prix fixe.', 'at a fixed price.'],
    'Je nach Anzahl Gäste. Die Anfahrt besprechen wir persönlich mit euch.': ['Selon le nombre d’invités. Nous convenons du déplacement avec vous.', 'Depending on the number of guests. We will discuss the travel details with you personally.'],
    'Abgefüllt vor den Augen eurer Gäste. Jeder Gast nimmt seinen 25-ml-Flakon Extrait de Parfum mit nach Hause.': ['L’extrait de parfum est mis en flacon sous les yeux de vos invités. Chacun repart avec son flacon de 25 ml.', 'Filled in front of your guests. Every guest takes home their own 25 ml bottle of extrait de parfum.'],
    'Gut': ['Bon', 'Good'],
    'zu wissen.': ['à savoir.', 'to know.'],
    'Dauer': ['Durée', 'Duration'],
    'Platz': ['Espace', 'Space'],
    'Region': ['Région', 'Region'],
    'Sprachen': ['Langues', 'Languages'],
    'Abgefüllt wird an eurem Fest, vor den Augen eurer Gäste. So sieht jeder Gast, wie sein Flakon gefüllt wird.': ['Le remplissage se fait pendant votre fête, sous les yeux de vos invités. Chacun voit son flacon se remplir.', 'Filling happens at your celebration, in front of your guests. Every guest sees their bottle being filled.'],
    'Die L’ODAR Perfumebar: weisser Tresen mit Spendern und Flakons': ['Le bar à parfum L’ODAR : comptoir blanc avec distributeurs et flacons', 'The L’ODAR perfume bar: white counter with dispensers and bottles'],
    'Spender mit Extrait de Parfum in einer Reihe an der Bar': ['Distributeurs d’extrait de parfum alignés sur le bar', 'Dispensers of extrait de parfum lined up at the bar'],
    'Flakons mit schwarzer Kugelkappe auf weissen Stufen an der Bar': ['Flacons à bouchon noir sphérique sur des marches blanches au bar', 'Bottles with black spherical caps on white steps at the bar'],
    /* v18: neues Angebot "Flakons ohne Bar" (Owner 20.10.2026; Entwuerfe, vom Inhaber zu pruefen) */
    'Flakons ohne Bar': ['Flacons sans bar', 'Bottles without the bar'],
    'Personalisierte 25-ml-Flakons mit euren Namen und dem Datum, ohne Perfumebar. Ab CHF 370.': ['Des flacons personnalisés de 25 ml à vos noms et à votre date, sans bar à parfum. Dès CHF 370.', 'Personalised 25 ml bottles with your names and date, without the perfume bar. From CHF 370.'],
    'Flakons ohne Bar ansehen': ['Voir les flacons sans bar', 'See bottles without the bar'],
    'Mit Bar': ['Avec bar', 'With the bar'],
    'oder ohne.': ['ou sans.', 'or without.'],
    'Pakete zum Fixpreis, je nach Anzahl Gäste. Die Anfahrt besprechen wir persönlich mit euch.': ['Des formules à prix fixe, selon le nombre d’invités. Nous convenons du déplacement avec vous.', 'Fixed-price packages, depending on the number of guests. We will discuss the travel details with you personally.'],
    'Angebote': ['Formules', 'Offers'],
    'Mit Perfumebar': ['Avec bar à parfum', 'With the perfume bar'],
    'Die Perfumebar': ['Le bar à parfum', 'The perfume bar'],
    'an eurem Fest.': ['à votre fête.', 'at your celebration.'],
    'Für mehr als 100 Gäste machen wir euch ein individuelles Angebot.': ['Pour plus de 100 invités, nous vous préparons une offre sur mesure.', 'For more than 100 guests, we will prepare a tailored quote.'],
    'Ohne Bar': ['Sans bar', 'Without the bar'],
    'Flakons': ['Flacons', 'Bottles'],
    'ohne Bar.': ['sans bar.', 'without the bar.'],
    'Personalisierte 25-ml-Flakons Extrait de Parfum mit euren Namen und dem Datum, ohne Perfumebar und ohne Betreuung vor Ort. Die Düfte wählt ihr frei aus unserer Kollektion.': ['Des flacons de 25 ml d’extrait de parfum, personnalisés à vos noms avec la date, sans bar à parfum ni accompagnement sur place. Vous choisissez librement vos parfums dans notre collection.', 'Personalised 25 ml bottles of extrait de parfum with your names and the date, without the perfume bar or on-site service. Choose any scents you like from our collection.'],
    '25 Flakons': ['25 flacons', '25 bottles'],
    '50 Flakons': ['50 flacons', '50 bottles'],
    '100 Flakons': ['100 flacons', '100 bottles'],
    '150 Flakons': ['150 flacons', '150 bottles'],
    'Mehr als 150 Flakons': ['Plus de 150 flacons', 'More than 150 bottles'],
    'für bis 25 Personen': ['jusqu’à 25 personnes', 'for up to 25 people'],
    'für bis 50 Personen': ['jusqu’à 50 personnes', 'for up to 50 people'],
    'für bis 100 Personen': ['jusqu’à 100 personnes', 'for up to 100 people'],
    'für bis 150 Personen': ['jusqu’à 150 personnes', 'for up to 150 people'],
    'für mehr als 150 Personen': ['plus de 150 personnes', 'for more than 150 people'],
    'nach Absprache': ['Sur demande', 'By arrangement'],
    'Anfragen': ['Demander', 'Enquire'],
    'Inbegriffen': ['Inclus', 'Included'],
    'Nicht inbegriffen': ['Non inclus', 'Not included'],
    '25-ml-Flakons Extrait de Parfum · Etikett mit euren Namen und dem Datum, gedruckt erst nach eurer Freigabe · Wir bringen die Flakons persönlich vorbei.': ['Flacons de 25 ml d’extrait de parfum · Étiquette à vos noms, avec la date, imprimée seulement après votre validation · Nous livrons les flacons en personne.', '25 ml bottles of Extrait de Parfum · Label with your names and date, printed only after your approval · We deliver the bottles in person.'],
    'Perfumebar, Auf- und Abbau, Betreuung vor Ort. Die Anfahrt besprechen wir persönlich mit euch.': ['Bar à parfum, montage et démontage, accompagnement sur place. Nous convenons du déplacement avec vous.', 'Perfume bar, set-up and dismantling, on-site service. We will discuss the travel details with you personally.'],
    'Die Perfumebar von oben: Spender, Flakons und Tresen': ['Le bar à parfum vu d’en haut : distributeurs, flacons et comptoir', 'The perfume bar from above: dispensers, bottles and counter'],
    'Flakon Extrait de Parfum mit schwarzer Kugelkappe': ['Flacon d’Extrait de Parfum à bouchon noir sphérique', 'Extrait de Parfum bottle with a black spherical cap'],
    'Gibt es die Flakons auch ohne Bar?': ['Les flacons existent-ils aussi sans bar ?', 'Are the bottles also available without the bar?'],
    'Ja. Ihr bekommt personalisierte 25-ml-Flakons Extrait de Parfum mit euren Namen und dem Datum, ohne Perfumebar und ohne Betreuung vor Ort: 25 Flakons CHF 370, 50 Flakons CHF 700, 100 Flakons CHF 1300, 150 Flakons CHF 1800, mehr nach Absprache. Die Düfte wählt ihr frei aus unserer Kollektion. Wir bringen die Flakons persönlich vorbei, die Anfahrt besprechen wir mit euch. Gedruckt wird erst nach eurer Freigabe.': ['Oui. Vous recevez des flacons de 25 ml d’extrait de parfum, personnalisés à vos noms avec la date, sans bar à parfum ni accompagnement sur place : 25 flacons CHF 370, 50 flacons CHF 700, 100 flacons CHF 1300, 150 flacons CHF 1800, davantage sur demande. Vous choisissez librement vos parfums dans notre collection. Nous vous livrons les flacons en personne et convenons avec vous du déplacement. L’impression n’a lieu qu’après votre validation.', 'Yes. You receive personalised 25 ml bottles of extrait de parfum with your names and the date, without the perfume bar or on-site service: 25 bottles CHF 370, 50 bottles CHF 700, 100 bottles CHF 1300, 150 bottles CHF 1800, more by arrangement. Choose any scents you like from our collection. We deliver the bottles to you in person and discuss the travel details with you. Labels are printed only after your approval.'],
    'Wie früh sollten wir die Bar buchen?': ['Combien de temps à l’avance réserver le bar ?', 'How early should we book the bar?'],
    'Feste Paketpreise: Bar ab CHF 700, Flakons ab CHF 370.': ['Prix fixes : bar dès CHF 700, flacons dès CHF 370.', 'Fixed package prices: bar from CHF 700, bottles from CHF 370.'],
    'Pakete und Preise, mit Bar oder ohne – L’ODAR Perfumebar': ['Formules et prix, avec ou sans bar – L’ODAR Perfumebar', 'Packages and prices, with or without the bar – L’ODAR Perfumebar'],
    /* v18 editorial: Anfrage und Etikett (Entwuerfe, vom Inhaber zu pruefen) */
    'Eure': ['Votre', 'Your'],
    'Anfrage.': ['demande.', 'enquiry.'],
    'Paket': ['Formule', 'Package'],
    'Eure Angaben': ['Vos informations', 'Your details'],
    'Die Anfrage ist unverbindlich. Wir melden uns persönlich bei euch.': ['La demande est sans engagement. Nous vous recontactons personnellement.', 'There is no obligation. We will get back to you personally.'],
    'Mit diesem Etikett anfragen': ['Demander avec cette étiquette', 'Enquire with this label'],
    /* v18 Verkauf (Owner 20.10.: "kauflockend"): Abzeichen, Laufband, Preis-Anker, Ablauf, Anfrage-Balken, Duft anfragen
       (Entwuerfe, vom Inhaber zu pruefen) */
    'Meist gewählt': ['Très demandé', 'Most popular'],
    'Neu': ['Nouveau', 'New'],
    'Vor den Augen eurer Gäste abgefüllt': ['Mis en flacon sous les yeux de vos invités', 'Filled in front of your guests'],
    'Mit euren Namen auf jedem Flakon': ['Vos noms sur chaque flacon', 'Your names on every bottle'],
    'Perfumebar ab CHF 700': ['Bar à parfum dès CHF 700', 'Perfume bar from CHF 700'],
    'Flakons ohne Bar ab CHF 370': ['Flacons sans bar dès CHF 370', 'Bottles without the bar from CHF 370'],
    'In der ganzen Schweiz': ['Dans toute la Suisse', 'All over Switzerland'],
    'Unverbindlich · Druck erst nach eurer Freigabe': ['Sans engagement · Impression seulement après votre validation', 'No obligation · Printed only after your approval'],
    'Diesen Duft anfragen': ['Demander ce parfum', 'Enquire about this scent'],
    'Ablauf': ['Déroulement', 'How it works'],
    'So einfach': ['Rien de', 'Simple'],
    'geht’s.': ['plus simple.', 'as that.'],
    'Vier kurze Fragen, unverbindlich. Wir melden uns persönlich bei euch.': ['Quatre petites questions, sans engagement. Nous vous recontactons personnellement.', 'Four short questions, no obligation. We will get back to you personally.'],
    'Düfte und Etikett wählen': ['Choisir parfums et étiquette', 'Choose scents and label'],
    'Ihr wählt eure Düfte aus unserer Kollektion. Das Etikett trägt eure Namen und das Datum, gedruckt wird erst nach eurer Freigabe.': ['Vous choisissez vos parfums dans notre collection. L’étiquette porte vos noms et la date ; elle n’est imprimée qu’après votre validation.', 'You choose your scents from our collection. The label carries your names and your date, and it is only printed once you approve it.'],
    'Geniessen': ['Savourer', 'Enjoy'],
    'Mit Bar wird an eurem Fest vor den Augen eurer Gäste abgefüllt. Flakons ohne Bar bringen wir euch persönlich vorbei.': ['Avec le bar, le remplissage se fait pendant votre fête, sous les yeux de vos invités. Les flacons sans bar, nous vous les livrons en personne.', 'With the bar, the bottles are filled at your celebration in front of your guests. Without the bar, we deliver the bottles to you in person.'],
    'Flakons ab CHF 370': ['Flacons dès CHF 370', 'Bottles from CHF 370'],
    'Wunschduft': ['Parfum souhaité', 'Requested scent']
  };
  Object.keys(T).forEach(function(k){ D.fr[k] = T[k][0]; D.en[k] = T[k][1]; });
})();

}catch(e){console.error("[v18 i18n]",e)}
/* ==== v19 i18n ==== */
try{
/* v19 Reicher (Owner 21.10.2026): Texte der Slider, Paketkarten, des Vergleichs und der Duftwahl auf dem Handy
   (Entwuerfe, vom Inhaber zu pruefen). Preise pro Gast/Flakon sind reine Rechnung aus den Paketpreisen. */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  D.fr = D.fr || {}; D.en = D.en || {};
  var T = {
    /* Duftwahl auf der Startseite */
    'Mehr zum Duft': ['En savoir plus', 'More about this scent'],
    'Weniger anzeigen': ['Afficher moins', 'Show less'],
    /* Slider der Kollektion (v20: keine Anzahl der Duefte) */
    'Extraits de Parfum': ['Extraits de parfum', 'Extraits de parfum'],
    'aus Grasse.': ['de Grasse.', 'from Grasse.'],
    'Nummern statt Namen, damit allein die Nase entscheidet. Beim Kennenlernen riecht ihr die ganze Kollektion.': ['Des numéros plutôt que des noms, pour que seul le nez décide. Lors de notre rencontre, vous découvrez toute la collection.', 'Numbers instead of names, so that only your nose decides. When we meet, you can try the whole collection.'],
    'Alle Noten': ['Toutes les notes', 'All notes'],
    'Alle Düfte im Detail': ['Tous les parfums en détail', 'All scents in detail'],
    /* Paketkarten */
    'Zum Fixpreis,': ['À prix fixe,', 'At a fixed price,'],
    'mit Bar oder ohne.': ['avec ou sans bar.', 'with or without the bar.'],
    'ab CHF 28 pro Gast': ['dès CHF 28 par invité', 'from CHF 28 per guest'],
    'ab CHF 26 pro Gast': ['dès CHF 26 par invité', 'from CHF 26 per guest'],
    'ab CHF 19 pro Gast': ['dès CHF 19 par invité', 'from CHF 19 per guest'],
    'CHF 14.80 pro Flakon': ['CHF 14.80 par flacon', 'CHF 14.80 per bottle'],
    'CHF 14 pro Flakon': ['CHF 14 par flacon', 'CHF 14 per bottle'],
    'CHF 13 pro Flakon': ['CHF 13 par flacon', 'CHF 13 per bottle'],
    'CHF 12 pro Flakon': ['CHF 12 par flacon', 'CHF 12 per bottle'],
    'Sechs Düfte nach eurer Wahl': ['Six parfums de votre choix', 'Six scents of your choice'],
    'Persönliches Kennenlernen': ['Rencontre en personne', 'First meeting in person'],
    'Betreuung vor Ort': ['Accompagnement sur place', 'On-site service'],
    '25-ml-Flakons Extrait de Parfum': ['Flacons de 25 ml d’extrait de parfum', '25 ml bottles of extrait de parfum'],
    'Düfte frei wählbar aus der ganzen Kollektion': ['Parfums au choix dans toute la collection', 'Your choice of scents from the whole collection'],
    'Etikett mit euren Namen und dem Datum': ['Étiquette à vos noms, avec la date', 'Label with your names and date'],
    'Persönlich vorbeigebracht': ['Livrés en personne', 'Delivered in person'],
    /* Vergleich */
    'Vergleich': ['Comparaison', 'Comparison'],
    'Mit Bar oder ohne?': ['Avec ou sans bar ?', 'With or without the bar?'],
    'Preis': ['Prix', 'Price'],
    'ab CHF 700': ['dès CHF 700', 'from CHF 700'],
    'ab CHF 370': ['dès CHF 370', 'from CHF 370'],
    'Pro Gast': ['Par invité', 'Per guest'],
    'ab CHF 19': ['dès CHF 19', 'from CHF 19'],
    'ab CHF 12': ['dès CHF 12', 'from CHF 12'],
    'Personalisierte 25-ml-Flakons': ['Flacons personnalisés de 25 ml', 'Personalised 25 ml bottles'],
    'Frei wählbar aus der ganzen Kollektion': ['Au choix dans toute la collection', 'Your choice from the whole collection'],
    'Perfumebar mit Auf- und Abbau': ['Bar à parfum avec montage et démontage', 'Perfume bar with set-up and dismantling'],
    'Übergabe': ['Remise', 'Handover'],
    'An eurem Fest': ['Pendant votre fête', 'At your celebration'],
    'Wir bringen sie persönlich vorbei': ['Nous vous les livrons en personne', 'We deliver them in person'],
    'Anfahrt': ['Déplacement', 'Travel'],
    'Besprechen wir persönlich mit euch': ['Nous en convenons avec vous', 'Discussed with you personally'],
    'Flakons anfragen': ['Demander des flacons', 'Enquire about bottles']
  };
  Object.keys(T).forEach(function(k){ D.fr[k] = T[k][0]; D.en[k] = T[k][1]; });
})();

}catch(e){console.error("[v19 i18n]",e)}
/* ==== v20 i18n ==== */
try{
/* v20 (Owner 21.10.2026): Bildband und Fotos vom Fest (lodar-event-*), neutrale Texte ohne Anzahl der Duefte
   (Entwuerfe, vom Inhaber zu pruefen). Alt-Texte beschreiben nur, was auf dem Foto zu sehen ist. */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  D.fr = D.fr || {}; D.en = D.en || {};
  var T = {
    /* Bildband auf der Startseite */
    'Vor den Augen': ['Sous les yeux', 'Right before'],
    'eurer Gäste.': ['de vos invités.', 'your guests’ eyes.'],
    /* Fotos vom Fest */
    'Brautpaar an der L’ODAR Perfumebar unter Kronleuchtern': ['Les mariés au bar à parfum L’ODAR, sous des lustres', 'Bride and groom at the L’ODAR perfume bar beneath chandeliers'],
    'Braut und Brautjungfer lachen an der Perfumebar, mit Duftstreifen in der Hand': ['La mariée et sa demoiselle d’honneur rient au bar à parfum, une mouillette à la main', 'Bride and bridesmaid laughing at the perfume bar, holding scent strips'],
    'Ein Gast im Anzug riecht an einem Duftstreifen, hinter ihm die Perfumebar in einem Schlosssaal': ['Un invité en costume sent une mouillette, derrière lui le bar à parfum dans une salle de château', 'A guest in a suit smells a scent strip, with the perfume bar behind him in a castle hall'],
    'Die L’ODAR Perfumebar an einem Fest auf einer Dachterrasse in der Abenddämmerung, Gäste riechen an Duftstreifen': ['Le bar à parfum L’ODAR lors d’une fête sur un toit-terrasse au crépuscule, des invités sentent des mouillettes', 'The L’ODAR perfume bar at a celebration on a rooftop terrace at dusk, guests smelling scent strips'],
    'Die Braut riecht mit geschlossenen Augen an einem Duftstreifen, neben ihr lacht eine Freundin; auf dem Marmor stehen gefüllte Flakons': ['La mariée sent une mouillette les yeux fermés, une amie rit à côté d’elle ; des flacons remplis sont posés sur le marbre', 'The bride smells a scent strip with her eyes closed while a friend laughs beside her; filled bottles stand on the marble']
  };
  Object.keys(T).forEach(function(k){ D.fr[k] = T[k][0]; D.en[k] = T[k][1]; });
})();

}catch(e){console.error("[v20 i18n]",e)}
/* ==== v24 i18n ==== */
try{
/* v24 (Owner 23.10.2026): Text unter dem Haus-Film auf dem Handy (lodar-v18-3d.js, Block "v24 Haus-Fuellung"; Entwuerfe,
   vom Inhaber zu pruefen). Keine Anzahl der Duefte. */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  D.fr = D.fr || {}; D.en = D.en || {};
  var T = {
    'Live-Perfumebar': ['Bar à parfum en direct', 'Live perfume bar'],
    'Erlebt die Bar live – auch auf dem Handy.': ['Vivez le bar en direct\u00a0– aussi sur votre mobile.', 'Experience the bar\u00a0live\u00a0– on your phone too.'],
    'Gleich wählt ihr eure Düfte und füllt sie ab.': ['Dans un instant, vous choisissez vos parfums et remplissez vos flacons.', 'In a moment, you will choose your scents and fill your bottles.']
  };
  Object.keys(T).forEach(function(k){ D.fr[k] = T[k][0]; D.en[k] = T[k][1]; });
})();

}catch(e){console.error("[v24 i18n]",e)}
/* ==== v26 i18n ==== */
try{
/* v26 (Owner 23.10.2026): Bilder fuer Flakons ohne Bar (Firmen, Hochzeiten), Musteretiketten auf /pages/etikett, Abfuellen am
   Spender auf /pages/erlebnis. VELORA ist ein erfundenes Musterlogo. Alt-Texte beschreiben nur, was zu sehen ist.
   Review v26: "Eure Namen auf jedem Flakon." und "Mit euren Namen" stehen schon weiter oben (Etikett, Ueber uns) und werden hier nicht
   ueberschrieben; Englisch sagt wie ueberall auf der Website "bottle", Franzoesisch "à vos noms". */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  D.fr = D.fr || {}; D.en = D.en || {};
  var T = {
    'Für Firmen': ['Pour les entreprises', 'For companies'],
    'Euer Logo auf jedem Flakon.': ['Votre logo sur chaque flacon.', 'Your logo on every bottle.'],
    'Ein Geschenk für Gäste, Kundschaft und Team, das in Erinnerung bleibt.': ['Un cadeau mémorable pour vos invités, vos clients et votre équipe.', 'A memorable gift for guests, clients and your team.'],
    'Für eure Firma anfragen': ['Demander une offre pour votre entreprise', 'Enquire about your corporate event'],
    'Für Hochzeiten': ['Pour les mariages', 'For weddings'],
    'Das Gastgeschenk, das bleibt: Extrait de Parfum mit euren Namen und dem Datum.': ['Le cadeau d’invités qui reste : un extrait de parfum à vos noms, avec la date.', 'The wedding favour that lasts: extrait de parfum with your names and the date.'],
    'Für eure Hochzeit anfragen': ['Demander une offre pour votre mariage', 'Enquire about your wedding'],
    'Abbildung mit Musterlogo': ['Illustration avec logo fictif', 'Shown with a sample logo'],
    'Abbildung mit Musteretikett': ['Illustration avec étiquette fictive', 'Shown with a sample label'],
    'Beispiele': ['Exemples', 'Examples'],
    'oder eurem Logo.': ['ou à votre logo.', 'or your logo.'],
    'Für eure Hochzeit': ['Pour votre mariage', 'For your wedding'],
    'Für eure Firma': ['Pour votre entreprise', 'For your company'],
    'Musteretiketten.': ['Étiquettes fictives.', 'Sample labels.'],
    /* Alt-Texte */
    'Festlich gedeckter Tisch an einem Firmenanlass, an jedem Platz ein Flakon mit Firmenlogo in einer weissen Geschenktüte': ['Table de gala dressée lors d’un événement d’entreprise, à chaque place un flacon au logo de l’entreprise dans un sachet cadeau blanc', 'A festive table at a corporate event, with a bottle bearing the company logo in a white gift bag at every place'],
    'Gäste an einem Firmenanlass freuen sich über ihre Flakons mit Firmenlogo': ['Des invités d’un événement d’entreprise se réjouissent de leurs flacons au logo de l’entreprise', 'Guests at a corporate event delighted with their bottles bearing the company logo'],
    'Flakon mit Etikett im Firmendesign (Musterlogo)': ['Flacon avec étiquette aux couleurs de l’entreprise (logo fictif)', 'Bottle with a label in corporate branding (sample logo)'],
    'Flakon mit Hochzeitsetikett und den Namen des Brautpaars': ['Flacon avec étiquette de mariage aux prénoms des mariés', 'Bottle with a wedding label bearing the couple’s names'],
    'Flakon mit Hochzeitsetikett in einer weissen Geschenktüte mit Satinschleife, daneben Rosen und Perlen': ['Flacon à l’étiquette de mariage dans un sachet cadeau blanc noué d’un ruban de satin, à côté de roses et de perles', 'Bottle with a wedding label in a white gift bag with a satin bow, beside roses and pearls'],
    'Ein Flakon mit Hochzeitsetikett wird in einer weissen Geschenktüte überreicht': ['Un flacon à l’étiquette de mariage est offert dans un sachet cadeau blanc', 'A bottle with a wedding label is handed over in a white gift bag'],
    'Ein Flakon mit Hochzeitsetikett wird direkt am Spender mit Extrait de Parfum gefüllt': ['Un flacon à l’étiquette de mariage est rempli d’extrait de parfum directement au distributeur', 'A bottle with a wedding label is filled with extrait de parfum straight from the dispenser']
  };
  Object.keys(T).forEach(function(k){ D.fr[k] = T[k][0]; D.en[k] = T[k][1]; });
})();

}catch(e){console.error("[v26 i18n]",e)}
/* ==== lodar-x7.js ==== */
try{
/* L'ODAR Maison v11: Raster werden zu Slidern (nebeneinander), laeuft vor lodar-x.js */
(function(){
  /* Nach dem Intro beginnt die Seite immer ganz oben beim Haus (iPhone merkt sich sonst die alte Scroll-Position) */
  var introShows = false;
  try{ introShows = !!document.getElementById('xIntro') && sessionStorage.getItem('lodar-x-intro') !== '1' && !/contact_posted|#/.test(location.href); }catch(e){}
  if(introShows){
    try{ history.scrollRestoration = 'manual'; }catch(e){}
    var top = function(){ window.scrollTo(0, 0); };
    top(); window.addEventListener('load', top);
    window.addEventListener('lodar:intro', top, {once:true});
  }
  /* v18 editorial: keine Raster-zu-Slider-Umbauten, kein Fotoband und keine (ohnehin ausgeblendete) Leiste unten mehr;
     Duefte, Erlebnis und Ueber uns sind ruhige Raster direkt aus Liquid */
})();

/* ---------- Slider: alles nebeneinander, mit Pfeilen, Zaehler und Wischen ----------
   v18: aus lodar-x.js hierher verschoben (vor die Sprachumschaltung, damit sie die Knoepfe kennt).
   Jeder Slider ist mit der Tastatur scrollbar (Pfeiltasten), traegt den Namen seines Abschnitts,
   die Knoepfe heissen "Vorherige/Naechste Karte"; bei "Bewegung reduzieren" ohne weiches Scrollen. */
(function(){
  "use strict";
  var ARR = '<svg viewBox="0 0 16 16"><path d="M10 3L5 8l5 5"/></svg>', ARR2 = '<svg viewBox="0 0 16 16"><path d="M6 3l5 5-5 5"/></svg>';
  var beh = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth';
  function nn(n){ return (n < 10 ? '0' : '') + n; }
  function label(box, r){
    var h = box.previousElementSibling;
    if(!h || !/^H[1-6]$/.test(h.tagName)){ var sec = box.closest ? box.closest('section') : null; h = sec ? sec.querySelector('h1,h2') : null; }
    if(h){ if(!h.id) h.id = r.id + 'T'; r.setAttribute('aria-labelledby', h.id); }
    else r.setAttribute('aria-label', (box.closest && box.closest('.x-photos')) ? 'Fotos' : 'Karten');
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-rail]'), function(box, i){
    var r = box.querySelector('.x-rail'); if(!r) return;
    if(!r.id) r.id = 'xRail' + (i + 1);
    r.setAttribute('tabindex', '0'); r.setAttribute('role', 'region'); label(box, r);
    var ctl = document.createElement('div'); ctl.className = 'x-rail-ctl';
    ctl.innerHTML = '<span class="x-rail-n" data-no-i18n></span><span class="x-rail-bar"><i></i></span>' +
      '<button type="button" class="x-rail-b" data-d="-1" aria-label="Vorherige Karte" aria-controls="' + r.id + '">' + ARR + '</button>' +
      '<button type="button" class="x-rail-b" data-d="1" aria-label="Nächste Karte" aria-controls="' + r.id + '">' + ARR2 + '</button>';
    box.appendChild(ctl);
    var num = ctl.querySelector('.x-rail-n'), bar = ctl.querySelector('.x-rail-bar i'), bs = ctl.querySelectorAll('button');
    function items(){ return Array.prototype.filter.call(r.children, function(c){ return c.offsetWidth > 0; }); }
    function step(){ var it = items(); return it.length > 1 ? (it[1].offsetLeft - it[0].offsetLeft) : r.clientWidth; }
    function upd(){
      var it = items(), max = r.scrollWidth - r.clientWidth, st = step() || 1;
      var cur = Math.min(it.length, Math.round(r.scrollLeft / st) + 1);
      if(max > 4 && r.scrollLeft >= max - 4) cur = it.length;
      num.textContent = nn(it.length ? cur : 0) + ' / ' + nn(it.length);
      var vis = r.scrollWidth ? r.clientWidth / r.scrollWidth : 1, k = max > 0 ? r.scrollLeft / max : 0;
      bar.style.width = (vis * 100) + '%'; bar.style.left = (k * (1 - vis) * 100) + '%';
      bs[0].disabled = r.scrollLeft < 4; bs[1].disabled = r.scrollLeft > max - 4;
      ctl.classList.toggle('x-rail-static', max < 4);
    }
    Array.prototype.forEach.call(bs, function(b){ b.addEventListener('click', function(){ r.scrollBy({left:step() * +b.getAttribute('data-d'), behavior:beh}); }); });
    r.addEventListener('scroll', upd, {passive:true});
    window.addEventListener('resize', upd);
    if(window.MutationObserver) new MutationObserver(function(){ requestAnimationFrame(upd); }).observe(r, {attributes:true, subtree:true, attributeFilter:['class', 'hidden', 'style']});
    if(window.ResizeObserver) new ResizeObserver(upd).observe(r);
    upd();
    /* mit der Maus ziehen */
    var down = false, x0 = 0, s0 = 0, moved = 0;
    r.addEventListener('pointerdown', function(e){ if(e.pointerType !== 'mouse' || e.button !== 0) return; down = true; x0 = e.clientX; s0 = r.scrollLeft; moved = 0; });
    window.addEventListener('pointermove', function(e){ if(!down) return; moved = Math.abs(e.clientX - x0); if(moved > 6){ r.classList.add('drag'); r.scrollLeft = s0 - (e.clientX - x0); } });
    window.addEventListener('pointerup', function(){ if(!down) return; down = false; if(r.classList.contains('drag')){ var st = step() || 1, to = Math.round(r.scrollLeft / st) * st; r.classList.remove('drag'); r.scrollTo({left:to, behavior:beh}); } });
    r.addEventListener('click', function(e){ if(moved > 6){ e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
  });
})();

}catch(e){console.error("[lodar-x7.js]",e)}
/* ==== lodar-x9.js ==== */
try{
/* L'ODAR Maison v14 – Duftauswahl als Flakon-Karten, Abfuell-Anzeige an der Bar */
(function(){
"use strict";
/* Texte ohne Ortsangabe: Uebersetzungen ergaenzen */
(function(){
  var D = window.LODAR_I18N = window.LODAR_I18N || {fr:{}, en:{}};
  D.fr = D.fr || {}; D.en = D.en || {};
  var T = {
    'Perfumebar für Hochzeiten und Events in der ganzen Schweiz.': ['Bar à parfum pour mariages et événements dans toute la Suisse.', 'Perfume bar for weddings and events across Switzerland.'],
    'In jedem Paket mit Bar: persönliches Kennenlernen, Etiketten mit euren Namen, Auf- und Abbau der Bar und Betreuung vor Ort. Die Anfahrt besprechen wir persönlich mit euch.': ['Dans chaque formule avec bar : rencontre en personne, étiquettes à vos noms, montage et démontage du bar et accompagnement sur place. Nous convenons du déplacement avec vous.', 'Every package with the bar includes a first meeting in person, labels with your names, set-up and dismantling of the bar, and our team on site. We will discuss the travel details with you personally.'],
    'In der ganzen Schweiz. Die Anfahrt besprechen wir persönlich mit euch.': ['Dans toute la Suisse. Nous convenons du déplacement avec vous.', 'All over Switzerland. We will discuss the travel details with you personally.']
  };
  Object.keys(T).forEach(function(k){ D.fr[k] = T[k][0]; D.en[k] = T[k][1]; });
  /* neue Adresse: vorhandene Uebersetzungen uebernehmen */
  ['fr','en'].forEach(function(l){ Object.keys(D[l]).forEach(function(k){ if(k.indexOf('Südstrasse 2, 2504 Biel') > -1) D[l][k.split('Südstrasse 2, 2504 Biel').join('Reitschulstrasse 5, 2502 Biel')] = String(D[l][k]).split('Südstrasse 2, 2504 Biel').join('Reitschulstrasse 5, 2502 Biel'); }); });
})();
/* Leiste "Eure Bar" auf Unterseiten nur zeigen, wenn schon ein Duft gewaehlt ist */
window.addEventListener('lodar:bar', function(e){
  var s = (e.detail && e.detail.slots) || [];
  document.documentElement.classList.toggle('p9-tray0', !s.some(function(v){ return v > -1; }));
});
/* v18 Verkauf (Owner 20.10.: "die Duftnoten moechte ich als Bilder haben"): jede Duftnote wieder mit ihrem Zutaten-Foto,
   aus denselben Bildboegen und mit derselben Zuordnung wie lodar-x9.js in v17 (16 bzw. 12 Felder je Bogen).
   Das Skript setzt nur die Klasse ed-ni und den Bildausschnitt (--ni Bild, --nic/--nir Spalten/Zeilen, --nix/--niy Feld);
   der Text der Note und ihre Uebersetzung bleiben unveraendert. Ohne Skript oder ohne Treffer bleiben die Noten reiner Text
   (html.ed-notes fehlt). Aussehen: lodar-v18.css, Block "v18 Verkauf". Achtung: --nc ist schon die alte Farbe der Note. */
(function(){
  var CDN = 'https://cdn.shopify.com/s/files/1/0960/3907/6173/files/';
  var SHEETS = {
    f: {u: CDN + 'lodar-noten-frucht.png?v=1792422465&width=800', c: 4, r: 4, n: ['Ananas','Bergamotte','Birne','Grapefruit','Himbeere','Litschi','Mandarine','Passionsfrucht','Pfirsich','Sauerkirsche','Schwarze Johannisbeere','Yuzu','Zitrone','Kokos','Haselnuss','Oregano']},
    b: {u: CDN + 'lodar-noten-blumen.png?v=1792422464&width=800', c: 4, r: 4, n: ['Jasmin','Rose','Pfingstrose','Maiglöckchen','Magnolie','Orangenblüte','Tuberose','Ylang-Ylang','Veilchen','Iris','Heliotrop','Hibiskus','Narzisse','Osmanthus','Zistrose','Moschusmalve']},
    g: {u: CDN + 'lodar-noten-gewuerz.png?v=1792422464&width=800', c: 4, r: 4, n: ['Safran','Rosa Pfeffer','Schwarzer Pfeffer','Kardamom','Piment','Vanille','Tonkabohne','Karamell','Crème brûlée','Benzoe','Labdanum','Opoponax','Elemi','Olibanum','Weihrauch','Amber']},
    h: {u: CDN + 'lodar-noten-holz.png?v=1792422464&width=900', c: 4, r: 3, n: ['Oud','Sandelholz','Zedernholz','Patchouli','Eichenmoos','Holznoten','Leder','Wildleder','Moschus','Ambra','Ambroxan','Pudrige Noten']}
  };
  var map = {}, hit = 0;
  Object.keys(SHEETS).forEach(function(k){ var sh = SHEETS[k]; sh.n.forEach(function(name, i){ map[name] = {u: sh.u, c: sh.c, r: sh.r, x: i % sh.c, y: Math.floor(i / sh.c)}; }); });
  var clean = function(el){ return (el.textContent || '').replace(/\s+/g, ' ').trim(); };
  Array.prototype.forEach.call(document.querySelectorAll('.x-pyr dd span'), function(sp){
    var m = map[clean(sp)]; if(!m) return;
    sp.classList.add('ed-ni');
    sp.style.setProperty('--ni', 'url("' + m.u + '")');
    sp.style.setProperty('--nic', String(m.c)); sp.style.setProperty('--nir', String(m.r));
    sp.style.setProperty('--nix', String(m.x)); sp.style.setProperty('--niy', String(m.y));
    hit++;
  });
  if(hit) document.documentElement.classList.add('ed-notes');
  /* Startseite, Computer: unter der Bar stehen die drei Leitnoten (Kopf, Herz, Basis) als kleine Bilder; beim Zeigen erscheint
     ihr Name in der gewaehlten Sprache (data-n, neu gesetzt bei jedem Sprachwechsel) */
  var tips = function(){ Array.prototype.forEach.call(document.querySelectorAll('.x-hero .x-pyr dd span.ed-ni'), function(sp){ sp.setAttribute('data-n', clean(sp)); }); };
  tips();
  window.addEventListener('lodar:lang', tips);
})();
var dial = document.getElementById('dial');
if(!dial) return;
var NUMS = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'];
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var arts = Array.prototype.slice.call(document.querySelectorAll('.x-sc'));
var info = [];
arts.forEach(function(a){
  var i = +a.getAttribute('data-i'), n = a.querySelector('.x-sc-n'), top = a.querySelectorAll('.x-sc-top span'), t = a.querySelector('.x-sc-t');
  info[i] = { c: (n && n.style.getPropertyValue('--c')) || '#C9A66B', who: top[0] ? top[0].textContent : '', fam: top[1] ? top[1].textContent : '', t: t ? t.textContent : '' };
});
var SUN = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="3"/><path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M3.4 12.6l1.4-1.4M11.2 4.8l1.4-1.4"/></svg>';
var MOON = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M12.8 10.4A5.6 5.6 0 0 1 5.6 3.2a5.6 5.6 0 1 0 7.2 7.2z"/></svg>';

/* ---------- Karten ---------- */
var box = document.createElement('div');
box.className = 'p9';
box.innerHTML = '<div class="p9-track" id="p9Track" role="group" aria-label="Duft wählen"></div>';
var track = box.firstChild;
NUMS.forEach(function(num, j){
  var d = info[j] || {c:'#C9A66B', who:'', fam:'', t:''};
  var night = /Nacht|Abend/i.test(d.t);
  var b = document.createElement('button');
  b.type = 'button'; b.className = 'p9-card'; b.setAttribute('aria-pressed', 'false'); b.style.setProperty('--c', d.c);
  /* v18: der Name der Karte ist ihr sichtbarer Text ("Nummer I, Fruchtig-holzig, Herren"); nur die Flakon-Teile sind Dekoration */
  b.innerHTML =
    '<span class="p9-fl"><i class="p9-cap" aria-hidden="true"></i><i class="p9-neck" aria-hidden="true"></i><span class="p9-body"><span class="p9-liq" aria-hidden="true"></span><span class="p9-shine" aria-hidden="true"></span><b><span class="vh">Nummer </span><span data-no-i18n>' + num + '</span></b></span></span>' +
    '<span class="p9-meta"><span class="p9-fam">' + d.fam + '</span><span class="p9-who">' + (night ? MOON : SUN) + '<span>' + d.who + '</span></span></span>' +
    '<span class="p9-ok" aria-hidden="true"><svg viewBox="0 0 16 16"><path d="M3.5 8.4l3 3 6-6.6"/></svg></span>';
  b.addEventListener('click', function(){
    if(navigator.vibrate) try{ navigator.vibrate(12); }catch(e){}
    var t = dial.children[j]; if(t) t.click();
  });
  track.appendChild(b);
});
dial.parentNode.insertBefore(box, dial);
document.documentElement.classList.add('p9-on');

/* ---------- Abfuell-Anzeige auf der Buehne ---------- */
var stage = document.getElementById('stageWrap');
var pill = null;
if(stage){
  pill = document.createElement('div');
  pill.className = 'p9-pour'; pill.hidden = true; pill.setAttribute('role', 'status'); pill.setAttribute('aria-live', 'polite');
  pill.innerHTML = '<span class="p9-pd"></span><span class="p9-pn" data-no-i18n></span><span class="p9-pt"></span><i class="p9-pbar"><b></b></i>';
  stage.appendChild(pill);
}
var TXT = {
  de: {fill:'wird abgefüllt', done:'steht in eurer Bar', out:'aus der Bar genommen', full:'Die Bar ist voll'},
  fr: {fill:'en cours de remplissage', done:'est dans votre bar', out:'retiré du bar', full:'Votre bar est complet'},
  en: {fill:'is being filled', done:'is now in your bar', out:'removed from the bar', full:'Your bar is full'}
};
function tx(k){ var l = (document.documentElement.lang || 'de').slice(0,2); return (TXT[l] || TXT.de)[k]; }
var pillT = [], POUR_MS = 5900;
function clearPill(){ pillT.forEach(clearTimeout); pillT = []; }
function showPill(i, mode){
  if(!pill) return; clearPill();
  var has3d = !!window.__lodarBar3d && !document.querySelector('.x-hero.no-gl');
  if(mode === 'fill' && !has3d) mode = 'done';
  pill.style.setProperty('--c', (info[i] || {}).c || '#C9A66B');
  pill.querySelector('.p9-pn').textContent = i == null ? '' : NUMS[i];
  pill.querySelector('.p9-pt').textContent = tx(mode);
  pill.className = 'p9-pour is-' + mode;
  pill.hidden = false; void pill.offsetWidth; pill.classList.add('show');
  var bar = pill.querySelector('.p9-pbar b');
  bar.style.transition = 'none'; bar.style.transform = 'scaleX(0)'; void bar.offsetWidth;
  if(mode === 'fill'){
    bar.style.transition = 'transform ' + (POUR_MS/1000) + 's cubic-bezier(.45,.05,.4,1)'; bar.style.transform = 'scaleX(1)';
    pillT.push(setTimeout(function(){ showPill(i, 'done'); }, POUR_MS));
  } else {
    bar.style.transform = 'scaleX(1)';
    pillT.push(setTimeout(function(){ pill.classList.remove('show'); pillT.push(setTimeout(function(){ pill.hidden = true; }, 450)); }, mode === 'done' ? 1900 : 1400));
  }
}

/* ---------- Zustand von der Bar uebernehmen ---------- */
var slotsEl = document.getElementById('slots');
var prev = null, prevCur = -1, ready = false;
function center(card, smooth){
  if(!card || track.scrollWidth <= track.clientWidth) return;
  var left = card.offsetLeft - track.clientWidth/2 + card.clientWidth/2;
  track.scrollTo({left: Math.max(0, left), behavior: smooth && !reduce ? 'smooth' : 'auto'});
}
function update(slots, refill){
  var cur = -1;
  Array.prototype.forEach.call(dial.children, function(btn, j){
    var c = track.children[j]; if(!c) return;
    var on = btn.getAttribute('aria-pressed') === 'true', isCur = btn.classList.contains('cur');
    if(isCur) cur = j;
    c.setAttribute('aria-pressed', on ? 'true' : 'false'); c.classList.toggle('cur', isCur);
  });
  if(slotsEl) Array.prototype.forEach.call(slotsEl.children, function(li){
    var k = NUMS.indexOf((li.textContent || '').trim());
    if(k > -1){ li.style.setProperty('--c', info[k] ? info[k].c : ''); } else li.style.removeProperty('--c');
  });
  if(cur !== prevCur){ center(track.children[cur], ready); prevCur = cur; }
  if(slots && prev && ready){
    var added = slots.filter(function(v){ return v > -1 && prev.indexOf(v) < 0; });
    var removed = prev.filter(function(v){ return v > -1 && slots.indexOf(v) < 0; });
    if(added.length) showPill(added[added.length - 1], 'fill');
    else if(refill != null && refill > -1) showPill(refill, 'fill');
    else if(removed.length) showPill(removed[0], 'out');
  }
  if(slots) prev = slots.slice();
}
window.addEventListener('lodar:bar', function(e){ var d = e.detail || {}; update(d.slots || null, d.refill); });
var full = document.getElementById('pickFull');
if(full && window.MutationObserver) new MutationObserver(function(){ if(!full.hidden && ready && pill){ clearPill(); pill.querySelector('.p9-pn').textContent = '6/6'; pill.querySelector('.p9-pt').textContent = tx('full'); pill.className = 'p9-pour is-out'; pill.hidden = false; void pill.offsetWidth; pill.classList.add('show'); pillT.push(setTimeout(function(){ pill.classList.remove('show'); }, 1800)); } }).observe(full, {attributes:true, attributeFilter:['hidden']});
setTimeout(function(){ ready = true; update(null); }, 400);

/* Noten der Duftpyramide erscheinen nacheinander */
if(window.MutationObserver) arts.forEach(function(a){
  new MutationObserver(function(){ if(!a.hidden){ a.classList.remove('p9-in'); void a.offsetWidth; a.classList.add('p9-in'); } }).observe(a, {attributes:true, attributeFilter:['hidden']});
});
})();

}catch(e){console.error("[lodar-x9.js]",e)}
/* ==== v19 Slider ==== */
try{
/* v19 Reicher (Owner 21.10.2026: "mehr Slides von links nach rechts"): ein Slider fuer Duefte, Fotos, Pakete und (Handy) den Ablauf.
   Nach dem Vorbild der v17-Schienen (lodar-x7.js): natives Scrollen mit Einrasten (Wischen, Trackpad, Pfeiltasten im Fokus),
   Pfeile blaettern eine sichtbare Seite weiter, Zaehler und Fortschrittslinie, Ziehen mit der Maus. Kein Autoplay.
   "Bewegung reduzieren": ohne weiches Scrollen. Passt alles auf den Bildschirm, ist die Leiste weg (ed-sl-static) und die
   Schiene kein eigener Tab-Halt. Markup: [data-ed-sl] mit .ed-sl-ctl und [data-ed-track] (snippets/lodar-v18.liquid). */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nn = function(n){ return (n < 10 ? '0' : '') + n; };
  var all = [];
  Array.prototype.forEach.call(document.querySelectorAll('[data-ed-sl]'), function(box){
    var tr = box.querySelector('[data-ed-track]'); if(!tr) return;
    var ctl = box.querySelector('.ed-sl-ctl');
    var num = ctl ? ctl.querySelector('.ed-sl-n b') : null, tot = ctl ? ctl.querySelector('.ed-sl-n i') : null;
    var bar = ctl ? ctl.querySelector('.ed-sl-bar i') : null;
    var prev = ctl ? ctl.querySelector('.ed-sl-b[data-d="-1"]') : null, next = ctl ? ctl.querySelector('.ed-sl-b[data-d="1"]') : null;
    var items = function(){ return Array.prototype.filter.call(tr.children, function(c){ return c.offsetWidth > 0; }); };
    var step = function(){ var it = items(); return it.length > 1 ? (it[1].offsetLeft - it[0].offsetLeft) : tr.clientWidth; };
    var ticking = false;
    var padL = function(){ var p = 0; try{ p = parseFloat(window.getComputedStyle(tr).paddingLeft) || 0; }catch(e){} return p; };
    /* v22 (fluessig): beim Wischen laeuft upd in jedem Bild; geschrieben wird nur, was sich geaendert hat (ein neu gesetzter
       Text loest sonst in jedem Bild ein neues Layout aus). Erst alles lesen, dann schreiben. */
    var was = {};
    var put = function(k, v, fn){ if(was[k] !== v){ was[k] = v; fn(v); } };
    function upd(){
      ticking = false;
      var it = items(), cw = tr.clientWidth, sw = tr.scrollWidth, max = sw - cw, sl = tr.scrollLeft, st = step() || 1;
      /* "alles sichtbar": die letzte Karte endet im sichtbaren Bereich (der Rand rechts zaehlt nicht) */
      var last = it[it.length - 1];
      var stat = !it.length || max < 4 || (sl < 4 && last.offsetLeft + last.offsetWidth <= cw + 1);
      var cur = Math.min(it.length, Math.round(sl / st) + 1);
      if(max > 4 && sl >= max - 4) cur = it.length;
      var f = sw ? Math.min(1, cw / sw) : 1, k = max > 0 ? sl / max : 0;
      if(stat && sl > 0) tr.scrollLeft = 0;
      box.classList.toggle('ed-sl-static', stat);
      if(stat){ if(tr.hasAttribute('tabindex')) tr.removeAttribute('tabindex'); }
      else if(tr.getAttribute('tabindex') !== '0') tr.setAttribute('tabindex', '0');
      if(num) put('n', nn(Math.max(1, cur)), function(v){ num.textContent = v; });
      if(tot) put('t', nn(it.length), function(v){ tot.textContent = v; });
      if(bar){
        put('w', (f * 100) + '%', function(v){ bar.style.width = v; });
        put('x', 'translateX(' + (f < 1 ? k * (1 / f - 1) * 100 : 0) + '%)', function(v){ bar.style.transform = v; });
      }
      if(prev) put('p', stat || sl < 4, function(v){ prev.disabled = v; });
      if(next) put('q', stat || sl > max - 4, function(v){ next.disabled = v; });
    }
    var req = function(){ if(!ticking){ ticking = true; requestAnimationFrame(upd); } };
    /* eine Seite weiter: so viele ganze Karten, wie gerade sichtbar sind (mindestens eine) */
    function go(d){
      var st = step() || tr.clientWidth, per = Math.max(1, Math.floor((tr.clientWidth - padL() + 8) / st));
      var to = Math.round(tr.scrollLeft / st) * st + d * per * st;
      tr.scrollTo({left: Math.max(0, to), behavior: reduce ? 'auto' : 'smooth'});
    }
    if(prev) prev.addEventListener('click', function(){ go(-1); });
    if(next) next.addEventListener('click', function(){ go(1); });
    tr.addEventListener('scroll', req, {passive:true});
    window.addEventListener('resize', req);
    window.addEventListener('lodar:lang', req);
    if(window.ResizeObserver) new ResizeObserver(req).observe(tr);
    /* Ziehen mit der Maus (Touch scrollt nativ) */
    var down = false, moved = false, x0 = 0, s0 = 0;
    tr.addEventListener('pointerdown', function(e){ if(e.pointerType !== 'mouse' || e.button !== 0 || box.classList.contains('ed-sl-static')) return; down = true; moved = false; x0 = e.clientX; s0 = tr.scrollLeft; });
    window.addEventListener('pointermove', function(e){
      if(!down) return; var dx = e.clientX - x0;
      if(!moved && Math.abs(dx) > 6){ moved = true; tr.classList.add('drag'); }
      if(moved){ tr.scrollLeft = s0 - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function(){
      if(!down) return; down = false;
      if(moved){ var st = step() || 1; tr.classList.remove('drag'); tr.scrollTo({left: Math.round(tr.scrollLeft / st) * st, behavior: reduce ? 'auto' : 'smooth'}); }
    });
    tr.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    tr.addEventListener('dragstart', function(e){ if(down) e.preventDefault(); });
    box.__edUpd = upd;
    all.push(upd);
    upd();
  });
  /* Schriften laden spaeter: danach stimmen die Breiten */
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ all.forEach(function(f){ f(); }); });
  window.addEventListener('load', function(){ all.forEach(function(f){ f(); }); });

  /* ---------- v19 Reiter (Startseite: "Mit Perfumebar" / "Flakons ohne Bar") ----------
     WAI-ARIA-Tabs: Pfeiltasten links/rechts, Pos1/Ende; ohne Skript stehen beide Angebote untereinander */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ed-tabs]'), function(list){
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    if(!tabs.length) return;
    function sel(t, focus){
      tabs.forEach(function(x){
        var on = x === t, p = document.getElementById(x.getAttribute('aria-controls'));
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        if(p){ p.hidden = !on; if(on){ var b = p.querySelector('[data-ed-sl]'); if(b && b.__edUpd) b.__edUpd(); } }
      });
      if(focus) try{ t.focus(); }catch(e){}
    }
    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){ sel(t); });
      t.addEventListener('keydown', function(e){
        var k = e.key, j = -1;
        if(k === 'ArrowRight' || k === 'Right') j = (i + 1) % tabs.length;
        else if(k === 'ArrowLeft' || k === 'Left') j = (i - 1 + tabs.length) % tabs.length;
        else if(k === 'Home') j = 0;
        else if(k === 'End') j = tabs.length - 1;
        if(j > -1){ e.preventDefault(); sel(tabs[j], true); }
      });
    });
    var start = tabs.filter(function(t){ return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    sel(start);
  });
})();

}catch(e){console.error("[v19 Slider]",e)}
/* ==== lodar-x10.js ==== */
try{
/* L'ODAR Maison v16 – Abschnitte beim Scrollen sanft einblenden (nur was noch unter dem Bildschirm liegt) */
(function(){
"use strict";
if(!('IntersectionObserver' in window)) return;
if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
function run(){
  /* v18 editorial: nur ganze Bloecke, einmal, kurz (12 px in 600 ms, siehe CSS); keine einzelnen Fragen-Zeilen mehr */
  /* v19 Reicher: auch die Slider (Kopf und Schiene), die Paketkarten und der Vergleich; v20: Bildband und Foto am Schlusssatz statt Foto-Slider */
  var sel = '.ed-trip-grid, .m-pk-head, .m-pk-track, .ed-more, .ed-offer-head, .ed-carte, .x-grid, .ed-step, .ed-facts, .x-about-in, .ed-values, .x-quote, .ed-close, .m-form, .ed-how-list, .ed-sl-head, .ed-sk-track, .ed-band-main, .ed-band-side, .ed-st-fig, .ed-lead, .ed-pk-head, .ed-tabpanel, .ed-cmp';
  var els = Array.prototype.slice.call(document.querySelectorAll(sel)), vh = window.innerHeight;
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('p10-in'); io.unobserve(e.target); } });
  }, {rootMargin: '0px 0px -8% 0px', threshold: .08});
  els.forEach(function(el){
    if(el.closest('.x-hero') || el.closest('.p10-rv')) return;
    if(el.getBoundingClientRect().top < vh) return;
    el.classList.add('p10-rv'); io.observe(el);
  });
}
if(window.__lodarIntroDone || !document.getElementById('xIntro')) setTimeout(run, 60);
else window.addEventListener('lodar:intro', function(){ setTimeout(run, 60); }, {once:true});
})();
/* Intro-Video: etwas schneller, auf dem Handy weniger stark gezoomt (Rand weich verwischt) */
(function(){
  var RATE = 1.3;
  document.addEventListener('play', function(e){
    var v = e.target; if(!v || !v.classList || !v.classList.contains('xv-video')) return;
    if(v.playbackRate !== RATE){ try{ v.defaultPlaybackRate = RATE; v.playbackRate = RATE; }catch(err){} }
  }, true);
  document.addEventListener('playing', function(e){
    var v = e.target; if(!v || !v.classList || !v.classList.contains('xv-video') || v.__p10) return;
    v.__p10 = true;
    try{ v.playbackRate = RATE; }catch(err){}
    if(!(window.matchMedia && window.matchMedia('(max-aspect-ratio: 1/1)').matches)) return;
    var box = v.parentNode;
    /* v22 (fluessig): der unscharfe Hintergrund ist kein zweites <video> mehr (zweiter Download auf iPhones, zweiter Decoder,
       Nachfuehren alle 700 ms), sondern eine Leinwand, auf die jedes neue Bild des Intro-Films gezeichnet wird: gleiche
       Quelle, gleiche Klasse xv-bg (gleiches CSS: Groesse, object-fit, blur 26px, Einblenden), immer bildgenau synchron.
       Halbe Aufloesung genuegt, das Bild wird ohnehin mit 26 px weichgezeichnet. Ohne 2D-Leinwand bleibt es beim Video. */
    var bg = document.createElement('canvas'), cx = null;
    try{ cx = bg.getContext('2d'); }catch(err){}
    if(!cx){
      bg = document.createElement('video');
      bg.className = 'xv-bg'; bg.muted = true; bg.defaultMuted = true; bg.setAttribute('muted', ''); bg.playsInline = true; bg.setAttribute('playsinline', ''); bg.setAttribute('aria-hidden', 'true'); bg.preload = 'auto';
      box.insertBefore(bg, v); box.classList.add('p10-vfit');
      bg.addEventListener('loadedmetadata', function(){
        try{ bg.currentTime = v.currentTime; bg.playbackRate = RATE; }catch(err){}
        var q; try{ q = bg.play(); }catch(err){} if(q && q.catch) q.catch(function(){});
      }, {once:true});
      bg.src = v.currentSrc || v.src;
      var iv = setInterval(function(){
        if(!bg.isConnected){ clearInterval(iv); return; }
        if(v.paused || v.ended){ if(!bg.paused) bg.pause(); return; }
        if(Math.abs(bg.currentTime - v.currentTime) > .3){ try{ bg.currentTime = v.currentTime; }catch(err){} }
      }, 700);
      return;
    }
    bg.className = 'xv-bg'; bg.setAttribute('aria-hidden', 'true');
    bg.width = Math.max(2, Math.round((v.videoWidth || 854) / 2)); bg.height = Math.max(2, Math.round((v.videoHeight || 480) / 2));
    box.insertBefore(bg, v); box.classList.add('p10-vfit');
    var paint = function(){ try{ cx.drawImage(v, 0, 0, bg.width, bg.height); }catch(err){} };
    var alive = function(){ return bg.isConnected && v.isConnected && !!v.getAttribute('src'); };
    if(v.requestVideoFrameCallback){
      /* nur wenn der Film ein neues Bild hat (bei Pause oder Ende kommt keins) */
      var onFrame = function(){ if(!alive()) return; paint(); v.requestVideoFrameCallback(onFrame); };
      paint(); v.requestVideoFrameCallback(onFrame);
    } else {
      var looping = false;
      var loop = function(){ if(!alive() || v.paused || v.ended){ looping = false; return; } paint(); requestAnimationFrame(loop); };
      var start = function(){ if(!looping && alive()){ looping = true; requestAnimationFrame(loop); } };
      v.addEventListener('play', start); v.addEventListener('playing', start); v.addEventListener('seeked', paint);
      paint(); start();
    }
  }, true);
})();

}catch(e){console.error("[lodar-x10.js]",e)}
/* ==== lodar-x.js ==== */
try{
/* L'ODAR Maison: Duftuhr-Intro, 3D-Bar, Duftkarten, Pakete, Anfrage */
(function(){
  var $ = function(id){ return document.getElementById(id); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var store = { get:function(k){ try{ return localStorage.getItem(k); }catch(e){ return null; } },
                set:function(k,v){ try{ localStorage.setItem(k,v); }catch(e){} },
                sget:function(k){ try{ return sessionStorage.getItem(k); }catch(e){ return null; } },
                sset:function(k,v){ try{ sessionStorage.setItem(k,v); }catch(e){} } };
  var focusEl = function(el){ if(!el || !el.focus) return; try{ el.focus({preventScroll:true}); }catch(e){ try{ el.focus(); }catch(e2){} } };

  /* v18: Ueberlagerungen (Intro, Menue, Rechtliches) machen die Seite dahinter "inert" (keine Tastatur, kein Screenreader)
     und sperren das Scrollen. Jede meldet sich mit einem eigenen Schluessel an und ab, so stoeren sie sich nicht. */
  var inertHolds = {}, inertSeen = [];
  function setInert(key, els){
    if(els) inertHolds[key] = els.filter(function(el){ return !!el; }); else delete inertHolds[key];
    var on = [];
    Object.keys(inertHolds).forEach(function(k){ inertHolds[k].forEach(function(el){ if(on.indexOf(el) < 0) on.push(el); if(inertSeen.indexOf(el) < 0) inertSeen.push(el); }); });
    inertSeen.forEach(function(el){ if(on.indexOf(el) > -1) el.setAttribute('inert', ''); else el.removeAttribute('inert'); });
    document.body.classList.toggle('m-lock', Object.keys(inertHolds).length > 0);
  }
  var pageParts = function(){ return [document.querySelector('.x-skiplink'), document.querySelector('main'), document.querySelector('.x-foot'), document.querySelector('.m-mob-cta'), document.querySelector('.ed-sticky')]; };

  /* Signal fuer die 3D-Bar: jetzt hereinfliegen */
  function introDone(){
    if(window.__lodarIntroDone) return;
    window.__lodarIntroDone = true;
    try{ window.dispatchEvent(new Event('lodar:intro')); }catch(e){}
  }

  /* ---------- Video-Intro: Flug durch die Duftnoten, danach erscheint das Logo mit dem Slogan ---------- */
  function videoIntro(box, close){
    /* v22 (fluessig): derselbe Film, leichter und mit dem Index am Anfang (2,5 statt 6,3 MB, startet sofort), aus dem Theme
       (theme.liquid setzt LODAR_INTRO_VIDEO). Laedt er nicht, kommt einmal der bisherige Film; erst danach wie bisher das Logo. */
    var OLD = 'https://cdn.shopify.com/s/files/1/0960/3907/6173/files/lodar-intro.mp4?v=1792214382';
    var SRC = window.LODAR_INTRO_VIDEO || (window.LODAR_ASSET_BASE ? window.LODAR_ASSET_BASE + 'lodar-intro-web.mp4' : OLD);
    var alt = SRC !== OLD ? OLD : '', gen = 0;
    var END = 19.3;   /* der letzte Tropfen ist gelandet */
    var fl = document.querySelector('.x-foot-logo'), logoUrl = fl ? fl.style.getPropertyValue('--logo') : '';
    var skipBtn = $('xSkip');
    box.classList.add('x-vintro');
    box.innerHTML = '<video class="xv-video" muted playsinline webkit-playsinline preload="auto" aria-hidden="true"></video><div class="xv-grain" aria-hidden="true"></div><div class="xv-veil" aria-hidden="true"></div>' +
      '<div class="xv-end" aria-hidden="true"><span class="xv-mark" role="img" aria-label="L’ODAR"></span><p class="xv-tag" data-no-i18n><span>A scent that stays,</span><span>long after you’ve left</span></p></div>';
    if(skipBtn) box.appendChild(skipBtn);
    var v = box.querySelector('video'), mark = box.querySelector('.xv-mark');
    mark.style.backgroundImage = logoUrl;
    var started = false, shown = false;
    /* Logo-Pause 5,2 s wie in v17 (B4: Owner-Vorrang 20.10., Intro bleibt genau wie v17) */
    function finale(){
      if(shown || done) return; shown = true;
      box.classList.add('xv-fin');
      setTimeout(close, 5200);
    }
    function tick(){
      if(done || shown) return;
      if(v.currentTime >= END || v.ended){ finale(); return; }
      requestAnimationFrame(tick);
    }
    v.addEventListener('playing', function(){ if(!started){ started = true; box.classList.add('xv-on'); requestAnimationFrame(tick); } });
    v.addEventListener('error', function(){ if(!v.error) return; if(!useAlt()) finale(); });
    v.addEventListener('ended', finale);
    v.src = SRC;
    /* v22: Ersatz, wenn der neue Film nicht laedt: einmal der bisherige Film, solange noch nichts zu sehen ist. Eine Absage
       von play(), die nur vom Wechsel kommt, zaehlt nicht (gen); "nicht unterstuetzt" heisst: Film laedt nicht, also Ersatz. */
    function tryPlay(fail){
      var g = gen, q; try{ q = v.play(); }catch(e){ fail(); return false; }
      if(q && q.catch) q.catch(function(err){ if(g !== gen) return; if(err && err.name === 'NotSupportedError' && useAlt()) return; fail(); });
      return true;
    }
    function useAlt(){
      if(!alt || started || shown || done) return false;
      var u = alt; alt = ''; gen++;
      v.src = u;
      if(!tapWait) tryPlay(askTap);
      return true;
    }
    /* erst wenn das Intro gepuffert ist, darf der Haus-Film laden (lodar-v18-3d.js) */
    v.addEventListener('canplaythrough', function(){ window.__lodarIntroBuffered = true; try{ window.dispatchEvent(new Event('lodar:introbuffered')); }catch(e){} }, {once:true});
    var tapWait = false;
    /* Stromsparmodus: Videos duerfen erst nach einem Tippen starten */
    function askTap(){
      if(tapWait || started || shown) return; tapWait = true;
      box.classList.add('xv-tap');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'xv-enter'; b.innerHTML = '<span class="xv-enter-mark"></span><span>Eintreten</span>';
      b.querySelector('.xv-enter-mark').style.backgroundImage = logoUrl;
      box.appendChild(b);
      if(window.LODAR_I18N_ADD) window.LODAR_I18N_ADD(b);
      focusEl(b);
      b.addEventListener('click', function(e){
        e.stopPropagation(); box.classList.remove('xv-tap'); b.remove();
        if(window.__lodarUnlockHouse) window.__lodarUnlockHouse();
        if(!tryPlay(finale)) return;
        tapWait = false;
      });
    }
    tryPlay(askTap);
    /* laedt das Video zu langsam (schwaches Netz), kommt direkt das Logo (Ablauf wie in v17; B4: Owner-Vorrang 20.10.) */
    (function wait(n){ setTimeout(function(){ if(done) return; if(started) return; if(tapWait) return wait(n); if(v.readyState >= 3 || (n < 4 && v.networkState === 2)) return wait(n + 1); finale(); }, 3000); })(0);
    (function guard(){ setTimeout(function(){ if(done) return; if(tapWait) return guard(); close(); }, 40000); })();
  }

  /* ---------- Intro: die Duftuhr (einmal pro Besuch) ---------- */
  var intro = $('xIntro');
  if(intro){
    /* v18: kam das Skript erst nach 7,5 s an (sehr langsames Netz), hat die CSS-Notbremse das Intro schon ausgeblendet: dann kein Intro mehr */
    var late = false; try{ late = !!(window.performance && performance.now && performance.now() > 7500); }catch(e){}
    /* v18 (B4): Datensparen (Save-Data) oder 2G: kein Intro-Film (dieselbe Regel steht im Kopf-Skript in theme.liquid und in lodar-v18-3d.js) */
    var lite = false; try{ var cn = navigator.connection; lite = !!(cn && (cn.saveData || /2g/.test(cn.effectiveType || ''))); }catch(e){}
    var skip = reduce || lite || late || store.sget('lodar-x-intro') === '1' || /contact_posted|#(agb|datenschutz|impressum|anfrage|pakete|fragen)/.test(location.href);
    if(skip){ intro.classList.add('gone'); introDone(); }
    else{
      store.sset('lodar-x-intro','1');
      /* v18: das Intro ist ein Dialog; die Seite dahinter ist fuer Tastatur und Screenreader gesperrt */
      setInert('intro', [$('xHead'), $('xMenu')].concat(pageParts()));
      var done = false, gone = false;
      /* B4 (Owner-Vorrang 20.10.: Intro wie v17): kein Beenden per Scrollen, Wischen oder Klick; nur der Knopf "Ueberspringen"
         und, wie bei jedem Dialog, die Escape-Taste (Barrierefreiheit) */
      var endOnKey = function(e){ if(e.key === 'Escape' || e.key === 'Esc') close(); };
      var unbindEnd = function(){ document.removeEventListener('keydown', endOnKey); };
      var close = function(){
        if(done) return; done = true;
        unbindEnd();
        intro.classList.add('out'); setInert('intro', null);
        /* der Fokus lag im Intro: weiter am Anfang des Inhalts */
        if(intro.contains(document.activeElement)) focusEl(document.querySelector('main'));
        setTimeout(introDone, 500);
        setTimeout(function(){
          intro.classList.add('gone'); gone = true;
          /* alle Videos im Intro stoppen und entfernen (auch die unscharfe Kopie auf dem Handy, deren Takt endet dann von selbst) */
          Array.prototype.forEach.call(intro.querySelectorAll('video'), function(x){ x.pause(); x.removeAttribute('src'); x.load(); if(x.parentNode) x.parentNode.removeChild(x); });
        }, 1700);
      };
      videoIntro(intro, close);
      $('xSkip').addEventListener('click', function(e){ e.stopPropagation(); close(); });
      if(!done){
        document.addEventListener('keydown', endOnKey);
        if(!intro.querySelector('.xv-enter')) focusEl($('xSkip'));
      }
    }
  } else introDone();

  /* ---------- Kopfzeile ---------- */
  var head = $('xHead');
  var onScroll = function(){ if(head) head.classList.toggle('scrolled', window.scrollY > 30); };
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  /* ---------- Eure Bar: bis zu sechs Duefte, gilt auf allen Seiten (3D-Bar folgt diesem Zustand) ---------- */
  var dial = $('dial'), panels = document.querySelectorAll('.x-sc'), slotsEl = $('slots'), pickN = $('pickN'), fullMsg = $('pickFull'), tog = $('pickToggle'), clr = $('pickClear');
  var NUMS = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'];
  var saved = null; try{ saved = JSON.parse(store.sget('lodar-bar') || 'null'); }catch(e){}
  var bar = (saved && saved.b && saved.b.length === 6) ? saved.b : [-1,-1,-1,-1,-1,-1];
  var curI = (saved && typeof saved.c === 'number') ? saved.c : 6, warn = false;
  /* touched: der Gast hat selbst gewaehlt (der Start-Duft VII der Bar zaehlt nicht als Wahl) */
  var touched = !!(saved && saved.u);
  var inBar = function(i){ return bar.indexOf(i) > -1; };
  var count = function(){ return bar.filter(function(v){ return v > -1; }).length; };
  function fillSlots(ol, cur){ if(!ol) return; Array.prototype.forEach.call(ol.children, function(li, k){ li.textContent = bar[k] > -1 ? NUMS[bar[k]] : ''; li.classList.toggle('on', bar[k] > -1); li.classList.toggle('cur', cur && bar[k] === curI); }); }
  function sync(refill){
    if(dial) Array.prototype.forEach.call(dial.children, function(b, j){ b.setAttribute('aria-pressed', inBar(j) ? 'true' : 'false'); b.classList.toggle('cur', j === curI); });
    panels.forEach(function(p){ p.hidden = +p.getAttribute('data-i') !== curI; });
    fillSlots(slotsEl, true); fillSlots($('traySlots'), false);
    if(pickN) pickN.textContent = count();
    if($('trayN')) $('trayN').textContent = count() + ' / 6';
    if(tog){ tog.classList.toggle('rem', inBar(curI)); tog.disabled = !inBar(curI) && count() >= 6; }
    if(clr) clr.hidden = count() === 0;
    if(fullMsg) fullMsg.hidden = !warn;
    document.querySelectorAll('[data-pick]').forEach(function(btn){ var on = inBar(+btn.getAttribute('data-pick')); btn.classList.toggle('in', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var ch = $('mChosen'); if(ch){ ch.hidden = !(touched && count() > 0); $('mChosenList').textContent = bar.filter(function(v){ return v > -1; }).map(function(v){ return NUMS[v]; }).join(' · '); }
    try{ store.sset('lodar-bar', JSON.stringify({b: bar, c: curI, u: touched})); }catch(e){}
    try{ window.dispatchEvent(new CustomEvent('lodar:bar', {detail:{slots: bar.slice(), refill: refill == null ? null : refill}})); }catch(e){}
  }
  var toastEl = $('xToast'), toastT = 0;
  function toast(i, k){
    if(!toastEl) return; var tt = toastEl.querySelector('.x-tt[data-k="' + k + '"]');
    $('xToastN').textContent = k === 'full' ? '' : NUMS[i]; $('xToastT').textContent = tt ? tt.textContent : '';
    toastEl.hidden = false; toastEl.classList.remove('show'); void toastEl.offsetWidth; toastEl.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function(){ toastEl.classList.remove('show'); setTimeout(function(){ toastEl.hidden = true; }, 400); }, 2600);
  }
  function centerDial(i){
    var b = dial && dial.children[i];
    if(b && dial.scrollWidth > dial.clientWidth) dial.scrollTo({left: b.offsetLeft - dial.clientWidth/2 + b.clientWidth/2, behavior: reduce ? 'auto' : 'smooth'});
  }
  function shake(){ if(fullMsg){ fullMsg.classList.remove('shake'); void fullMsg.offsetWidth; fullMsg.classList.add('shake'); } }
  /* Tippen: noch nicht in der Bar -> hinein; schon in der Bar -> wieder heraus */
  function toggle(i, withToast){
    curI = i; warn = false;
    if(inBar(i)){ bar[bar.indexOf(i)] = -1; sync(); if(withToast) toast(i, 'out'); return 'out'; }
    if(count() < 6){ bar[bar.indexOf(-1)] = i; sync(); if(withToast) toast(i, 'in'); return 'in'; }
    warn = true; sync(); shake(); if(withToast) toast(i, 'full'); return 'full';
  }
  if(dial) Array.prototype.forEach.call(dial.children, function(b, j){ b.addEventListener('click', function(){ touched = true; toggle(j); centerDial(j); }); });
  if(slotsEl) Array.prototype.forEach.call(slotsEl.children, function(li, k){ li.addEventListener('click', function(){ if(bar[k] > -1){ touched = true; curI = bar[k]; warn = false; sync(bar[k]); centerDial(curI); } }); });
  if(tog) tog.addEventListener('click', function(){ touched = true; toggle(curI); });
  if(clr) clr.addEventListener('click', function(){ touched = true; bar = [-1,-1,-1,-1,-1,-1]; warn = false; sync(); });
  window.addEventListener('lodar:barclick', function(e){ var i = e.detail && e.detail.i; if(i == null) return; touched = true; curI = i; warn = false; sync(i); centerDial(i); });
  window.addEventListener('lodar:bar3d', function(){ sync(); });
  document.querySelectorAll('[data-pick]').forEach(function(btn){ btn.addEventListener('click', function(){ touched = true; toggle(+btn.getAttribute('data-pick'), true); }); });
  /* zum Start stellt die Bar selbst einen Duft hinein (nur beim ersten Besuch der Startseite) */
  var demo = !!saved || !dial;
  function startDemo(){ if(demo) return; demo = true; if(count() === 0 && window.scrollY < window.innerHeight*.6) toggle(6); }
  window.addEventListener('lodar:barready', function(){ setTimeout(startDemo, 250); });
  function afterIntroFallback(){ setTimeout(function(){ if(!window.__lodarBar3d) startDemo(); }, 1200); }
  if(window.__lodarIntroDone) afterIntroFallback(); else window.addEventListener('lodar:intro', afterIntroFallback, {once:true});
  sync();
  /* v18 Verkauf: "Diesen Duft anfragen" (Duftkarten, Startseite) fuehrt zur Anfrage mit ?duft=VII. Die Nummer kommt ins Feld
     contact[Wunschduft] und, wenn noch Platz ist, in "Eure Bar" (dann steht sie links unter "Eure Bar" und in der Zusammenfassung) */
  (function(){
    var q = (location.search.match(/[?&]duft=([^&#]+)/) || [])[1], fd = $('fDuft');
    if(!q || !fd) return;
    try{ q = decodeURIComponent(q.replace(/\+/g, ' ')); }catch(e){}
    var di = NUMS.indexOf(String(q).replace(/\s+/g, '').toUpperCase());
    if(di < 0) return;
    fd.value = NUMS[di]; fd.disabled = false;
    touched = true;
    if(!inBar(di) && count() < 6) bar[bar.indexOf(-1)] = di;
    curI = di; warn = false;
    sync();
  })();

  /* ---------- Menue (Handy) ---------- */
  /* v18: Escape schliesst und gibt den Fokus an den Knopf zurueck; Fokus springt ins Menue; die Seite dahinter ist gesperrt;
     nach "Zurueck" im Browser (Cache) und beim Drehen/Verbreitern auf Computerbreite ist das Menue zu */
  var menuBtn = $('xMenuBtn'), menu = $('xMenu');
  if(menuBtn && menu){
    var setMenu = function(open, refocus){
      menu.hidden = !open; menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('menu-open', open);
      setInert('menu', open ? pageParts().concat([$('xTray')]) : null);
      if(open) focusEl(menu.querySelector('a'));
      else if(refocus) focusEl(menuBtn);
    };
    menuBtn.addEventListener('click', function(){ setMenu(menu.hidden); });
    document.addEventListener('keydown', function(e){ if((e.key === 'Escape' || e.key === 'Esc') && !menu.hidden) setMenu(false, true); });
    window.addEventListener('pageshow', function(e){ if(e.persisted && !menu.hidden) setMenu(false); });
    if(window.matchMedia){
      /* v18 editorial: das Menue-Symbol gibt es bis 1279 px (kompakte Kopfzeile, lodar-v18.css) */
      var mqWide = window.matchMedia('(min-width:1280px)');
      var onWide = function(m){ if(m.matches && !menu.hidden) setMenu(false); };
      if(mqWide.addEventListener) mqWide.addEventListener('change', onWide); else if(mqWide.addListener) mqWide.addListener(onWide);
    }
  }

  /* ---------- Anfrage: Paket aus dem Link vorwaehlen ---------- */
  /* alte Links mit paket=20 fuehren zum Paket fuer 25 Gaeste; fl25 bis flmehr sind die "Flakons ohne Bar" (v18);
     ohne oder mit unbekanntem Wert ist nichts vorgewaehlt */
  var pk = (location.search.match(/[?&]paket=([^&#]+)/) || [])[1];
  if(pk){
    try{ pk = decodeURIComponent(pk.replace(/\+/g, ' ')); }catch(e){}
    var map = {'20':'Bis 25 Gäste','25':'Bis 25 Gäste','50':'Bis 50 Gäste','100':'Bis 100 Gäste','mehr':'Mehr als 100 Gäste',
      'fl25':'Flakons ohne Bar: 25 Flakons','fl50':'Flakons ohne Bar: 50 Flakons','fl100':'Flakons ohne Bar: 100 Flakons','fl150':'Flakons ohne Bar: 150 Flakons','flmehr':'Flakons ohne Bar: mehr als 150 Flakons'};
    if(Object.prototype.hasOwnProperty.call(map, pk)) document.querySelectorAll('input[name="contact[Paket]"]').forEach(function(r){ r.checked = r.value === map[pk]; });
  }
  /* v26 Anlass: "Fuer eure Firma / Hochzeit anfragen" (Flakons ohne Bar) waehlt den Anlass vor; unbekannte Werte waehlen nichts */
  var anl = (location.search.match(/[?&]anlass=([^&#]+)/) || [])[1];
  var anlMap = {'firma':'Firmenanlass','hochzeit':'Hochzeit'};
  if(anl && Object.prototype.hasOwnProperty.call(anlMap, anl)) document.querySelectorAll('input[name="contact[Anlass]"]').forEach(function(r){ r.checked = r.value === anlMap[anl]; });

  var chips = $('chips'), GROUPS = ['alle','damen','herren','unisex'];
  if(chips){
    Array.prototype.forEach.call(chips.children, function(b, j){
      b.addEventListener('click', function(){
        Array.prototype.forEach.call(chips.children, function(c, k){ c.setAttribute('aria-pressed', k === j ? 'true' : 'false'); });
        var g = GROUPS[j];
        /* v19: der Slider der Kollektion filtert mit (gleiche Gruppen in data-g) */
        document.querySelectorAll('.x-card, .ed-sk-track > li').forEach(function(c){ c.classList.toggle('off', g !== 'alle' && c.getAttribute('data-g') !== g); });
        /* v19 Gatekeeper: Zaehler, Pfeile und "alles sichtbar" sofort neu berechnen (scrollLeft = 0 loest kein scroll-Ereignis aus, wenn die Schiene schon am Anfang steht) */
        var skt = document.getElementById('skTrack'); if(skt){ skt.scrollLeft = 0; if(skt.parentNode && skt.parentNode.__edUpd) skt.parentNode.__edUpd(); }

      });
    });
  }

  /* ---------- Seitlich verschieben: Wischen, Ziehen, Pfeile ---------- */
  function slider(track, bar, arrows, itemSel){
    if(!track) return;
    var items = function(){ return Array.prototype.filter.call(track.querySelectorAll(itemSel), function(c){ return c.offsetParent !== null; }); };
    var step = function(){ var c = items(); return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : track.clientWidth; };
    var upd = function(){
      var max = track.scrollWidth - track.clientWidth, r = max > 0 ? track.scrollLeft / max : 0;
      var w = Math.max(12, Math.min(100, track.clientWidth / track.scrollWidth * 100));
      if(bar){ bar.style.width = w + '%'; bar.style.transform = 'translateX(' + (r * (100 / w - 1) * 100) + '%)'; }
      if(arrows && arrows.length){ arrows[0].disabled = track.scrollLeft < 8; arrows[1].disabled = track.scrollLeft > max - 8; }
    };
    if(arrows) arrows.forEach(function(b){ b.addEventListener('click', function(){ track.scrollBy({left: step() * +b.getAttribute('data-dir'), behavior: reduce ? 'auto' : 'smooth'}); }); });
    track.addEventListener('scroll', function(){ requestAnimationFrame(upd); }, {passive:true});
    window.addEventListener('resize', upd); upd();
    var down = false, moved = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', function(e){ if(e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', function(e){
      if(!down) return; var dx = e.clientX - sx;
      if(!moved && Math.abs(dx) > 6){ moved = true; track.classList.add('drag'); }
      if(moved){ track.scrollLeft = sl - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function(){
      if(!down) return; down = false;
      if(moved){ track.classList.remove('drag'); var s = step(); track.scrollTo({left: Math.round(track.scrollLeft / s) * s, behavior: reduce ? 'auto' : 'smooth'}); }
    });
    track.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function(e){ e.preventDefault(); });
  }
  /* v18 editorial: die Pakete stehen als ruhige Spalten nebeneinander; den Slider gibt es nur noch, wo die alte Leiste (#pkBar) im Markup steht */
  if($('pkBar')) slider($('pkTrack'), $('pkBar'), Array.prototype.slice.call(document.querySelectorAll('.m-arrow')), '.m-pk');
  /* v18 editorial: keine 3D-Neigung und kein Glanz unter der Maus mehr */

  /* ---------- Etikett ---------- */
  /* v18 editorial: Text in der aktuellen Sprache fuer Inhalte, die das Skript selbst schreibt (Etikett-Platzhalter, Zusammenfassung der Anfrage) */
  var trNow = function(s){ var l = (document.documentElement.lang || 'de').slice(0, 2), d = window.LODAR_I18N && window.LODAR_I18N[l]; return (l !== 'de' && d && d[s]) || s; };
  window.LODAR_TR = trNow;
  var nm = $('mName'), dt = $('mDate'), stk = document.querySelector('.m-stk'), nmCount = $('mNameCount');
  function renderLabel(){
    if(nmCount && nm) nmCount.textContent = (nm.value || '').length + ' / ' + (nm.maxLength > 0 ? nm.maxLength : 28);
    if(!stk || !nm) return;
    var v = (nm.value || '').trim();
    var p = v.split(/\s*(?:&|\+|\bund\b|\bet\b|\band\b)\s*/i).filter(function(x){ return x; });
    /* v18 editorial: leeres Namensfeld zeigt blass "Eure Namen" (wird nie mitgeschickt: lodar-label speichert nur eigene Eingaben) */
    var empty = !p.length;
    stk.classList.toggle('ed-ph', empty);
    if(empty) p = [trNow('Eure Namen')];
    var a = p[0] || '', b = p.slice(1).join(' '), d = dt ? (dt.value || '').trim() : '';
    stk.querySelector('.n1').textContent = a;
    stk.querySelector('.n2').textContent = b;
    stk.querySelector('.d').textContent = d;
    stk.classList.toggle('one', !b);
    stk.classList.toggle('nod', !d);
    var m = Math.max(a.length, b.length, 1);
    stk.style.setProperty('--stk-fs', Math.max(8, Math.min(b ? 17 : 20, 105 / m)) + 'cqw');
  }
  if(nm){
    /* Entwurf merken (nur echte Eingaben: die Beispiele "Lea & Marco" und "12.06.2027" werden nie gesendet) und in der Anfrage mitschicken */
    var own = function(el){ var x = el ? (el.value || '').trim() : ''; return x === (el ? (el.defaultValue || '').trim() : '') ? '' : x; };
    var lab = null; try{ lab = JSON.parse(store.sget('lodar-label') || 'null'); }catch(e){}
    if(lab){ if(typeof lab.n === 'string' && lab.n) nm.value = lab.n; if(dt && typeof lab.d === 'string' && lab.d) dt.value = lab.d; }
    var saveLabel = function(){ store.sset('lodar-label', JSON.stringify({n: own(nm), d: own(dt)})); };
    nm.addEventListener('input', function(){ saveLabel(); renderLabel(); });
    if(dt) dt.addEventListener('input', function(){ saveLabel(); renderLabel(); });
    window.addEventListener('lodar:lang', renderLabel);
    renderLabel();
  }

  /* ---------- v18 Verkauf: Anfrage-Balken auf dem Handy ----------
     (Owner 20.10.: "es muss kauflockend sein"; ersetzt Entscheid #1 "kein fixer Balken") Nur bis 760 px, erst wenn der Hero
     (Startseite) bzw. der Seitenkopf vorbei ist. Weg, solange Intro, Menue oder Rechtliches offen sind (body.m-lock), ein Eingabefeld
     den Fokus hat (Tastatur), das Shopify-Cookie-Banner sichtbar ist oder ein Abschluss mit eigenen Knoepfen im Bild ist. */
  (function(){
    var sb = $('edSticky'); if(!sb) return;
    var hero = document.querySelector('.x-hero');
    var mq = window.matchMedia ? window.matchMedia('(max-width:760px)') : null;
    var typing = false, ticking = false;
    var cookieOpen = function(){
      var c = document.getElementById('shopify-pc__banner'); if(!c) return false;
      var r = c.getBoundingClientRect(), cs = window.getComputedStyle(c);
      return r.height > 0 && r.bottom > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity !== 0;
    };
    var seen = function(sel, vh){
      var els = document.querySelectorAll(sel);
      for(var i = 0; i < els.length; i++){ var r = els[i].getBoundingClientRect(); if(r.height > 0 && r.top < vh && r.bottom > 0) return true; }
      return false;
    };
    var upd = function(){
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var on = !!(mq && mq.matches);
      var hh = head ? head.offsetHeight : 0;
      if(on) on = hero ? hero.getBoundingClientRect().bottom < hh + 8 : (window.scrollY || window.pageYOffset || 0) > vh * .75;
      if(on && (typing || document.body.classList.contains('m-lock') || document.documentElement.classList.contains('menu-open') || cookieOpen())) on = false;
      if(on && seen('.ed-close, .x-statement, .ed-label-cta, .x-foot', vh)) on = false;
      if(sb.classList.contains('on') !== on) sb.classList.toggle('on', on);
    };
    var req = function(){ if(!ticking){ ticking = true; setTimeout(upd, 40); } };
    window.addEventListener('scroll', req, {passive:true});
    window.addEventListener('resize', req);
    if(mq){ if(mq.addEventListener) mq.addEventListener('change', req); else if(mq.addListener) mq.addListener(req); }
    document.addEventListener('focusin', function(e){ var t = e.target; typing = !!(t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) && !/^(radio|checkbox|button|submit)$/i.test(t.type || '')); req(); });
    document.addEventListener('focusout', function(){ typing = false; setTimeout(req, 60); });
    if(window.MutationObserver) new MutationObserver(req).observe(document.body, {attributes:true, attributeFilter:['class'], childList:true});
    upd();
  })();

  /* ---------- Anfrage in vier Schritten ---------- */
  var wiz = $('mWiz'), go = null;
  if(wiz){
    var slidesEl = $('wizSlides'), slides = wiz.querySelectorAll('.m-slide'), cur = 0;
    var steps = document.querySelectorAll('.m-wiz-steps li');
    /* v18 editorial: Schritt 4 zeigt eine kurze Zusammenfassung der Antworten (nur textContent; Beschriftungen in der aktuellen Sprache) */
    var recapBox = $('edRecapBox'), recapEl = $('edRecap');
    var recap = function(){
      if(!recapEl || !recapBox) return;
      /* v18 Verkauf: Abzeichen ("Unsere Empfehlung" usw.) gehoeren nicht in die Zusammenfassung */
      var rows = [], txt = function(el){
        if(!el) return '';
        if(el.querySelector && el.querySelector('.ed-badges')){ el = el.cloneNode(true); Array.prototype.forEach.call(el.querySelectorAll('.ed-badges'), function(b){ b.parentNode.removeChild(b); }); }
        return (el.textContent || '').replace(/\s+/g, ' ').trim();
      };
      var an = wiz.querySelector('input[name="contact[Anlass]"]:checked');
      rows.push(['Anlass', an ? txt(an.nextElementSibling) : '–']);
      var pk2 = wiz.querySelector('input[name="contact[Paket]"]:checked'), pv = '–';
      if(pk2){
        var box = pk2.nextElementSibling, sp = box && box.querySelector(':scope > span'), em = box && box.querySelector('em');
        pv = sp ? txt(sp) + (em ? ' · ' + txt(em) : '') : txt(box);
      }
      rows.push(['Paket', pv]);
      var fd = $('fDatum'), dv = fd && fd.value ? fd.value.split('-') : null;
      rows.push(['Datum', dv && dv.length === 3 ? dv[2] + '.' + dv[1] + '.' + dv[0] : '–']);
      var fo = $('fOrt'); if(fo && fo.value.trim()) rows.push(['Ort', fo.value.trim()]);
      var ch = $('mChosen'), chList = (ch && !ch.hidden) ? txt($('mChosenList')) : '';
      if(chList) rows.push(['Eure Bar', chList]);
      /* Wunschduft von einer Duftkarte, der nicht mehr in die volle Bar passte */
      var fdu = $('fDuft'); if(fdu && !fdu.disabled && fdu.value && chList.split(' · ').indexOf(fdu.value) < 0) rows.push(['Wunschduft', fdu.value]);
      var lab2 = null; try{ lab2 = JSON.parse(store.sget('lodar-label') || 'null'); }catch(e){}
      if(lab2 && lab2.n) rows.push(['Etikett', lab2.n + (lab2.d ? ' · ' + lab2.d : '')]);
      while(recapEl.firstChild) recapEl.removeChild(recapEl.firstChild);
      rows.forEach(function(r){
        var d = document.createElement('div'), t = document.createElement('dt'), v = document.createElement('dd');
        t.textContent = trNow(r[0]); v.textContent = r[1];
        d.appendChild(t); d.appendChild(v); recapEl.appendChild(d);
      });
      recapBox.hidden = false;
    };
    window.addEventListener('lodar:lang', function(){ if(wiz.classList.contains('last')){ recap(); fit(); } });
    var fit = function(){ slidesEl.parentNode.style.height = slides[cur].offsetHeight + 'px'; };
    go = function(n, focus){
      cur = Math.max(0, Math.min(slides.length - 1, n));
      slidesEl.style.transform = 'translateX(-' + (cur * 100) + '%)';
      /* v18 Gatekeeper: erst die Zusammenfassung fuellen, dann die Hoehe messen (sonst schneidet der Ausschnitt beim
         ersten Erreichen von Schritt 4 die Felder Name, E-Mail, Telefon und Nachricht ab) */
      wiz.classList.toggle('last', cur === slides.length - 1);
      if(cur === slides.length - 1) recap();
      fit();
      slides.forEach(function(s, k){ if(k === cur) s.removeAttribute('inert'); else s.setAttribute('inert', ''); });
      $('wizN').textContent = cur + 1;
      $('wizLine').style.width = ((cur + 1) / slides.length * 100) + '%';
      $('wizBack').classList.toggle('show', cur > 0);
      steps.forEach(function(li, k){ li.classList.toggle('on', k === cur); li.classList.toggle('done', k < cur); });
      if(focus){
        var f = slides[cur].querySelector('input:checked, input:not([type=radio]), textarea');
        if(f) setTimeout(function(){ f.focus({preventScroll:true}); }, 450);
        var top = wiz.getBoundingClientRect().top;
        if(top < 0 || top > window.innerHeight * .6) $('mForm').scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'start'});
      }
    };
    /* der sichtbare Ausschnitt wird nur ueber transform bewegt; der Browser darf ihn beim Fokus (Pfeiltasten) nicht seitlich verschieben (aeltere Browser ohne overflow:clip) */
    var wview = slidesEl.parentNode;
    wview.addEventListener('scroll', function(){ if(wview.scrollLeft || wview.scrollTop){ wview.scrollLeft = 0; wview.scrollTop = 0; } });
    $('wizNext').addEventListener('click', function(){ go(cur + 1, true); });
    $('wizBack').addEventListener('click', function(){ go(cur - 1, true); });
    /* automatisch weiter nur nach Tippen oder Klicken auf eine Kachel; mit der Tastatur waehlt man in Ruhe und geht mit Enter oder "Weiter" */
    var viaPtr = false;
    wiz.addEventListener('pointerdown', function(e){ viaPtr = !!(e.target.closest && e.target.closest('.m-tile,.m-unsure')); }, true);
    wiz.addEventListener('keydown', function(){ viaPtr = false; }, true);
    wiz.querySelectorAll('.m-slide[data-step="0"] input, .m-slide[data-step="1"] input').forEach(function(r){
      r.addEventListener('change', function(){ if(!viaPtr) return; viaPtr = false; var k = cur; setTimeout(function(){ if(cur === k) go(k + 1, true); }, 400); });
    });
    wiz.addEventListener('keydown', function(e){
      if(e.key === 'Enter' && cur < slides.length - 1 && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'BUTTON'){ e.preventDefault(); go(cur + 1, true); }
    });
    /* Antworten der Schritte 1 bis 3 merken, damit sie nach einem Fehler beim Senden wieder da sind */
    var WIZ_KEY = 'lodar-wiz';
    var saveWiz = function(){
      var a = wiz.querySelector('input[name="contact[Anlass]"]:checked'), p = wiz.querySelector('input[name="contact[Paket]"]:checked'), fd = $('fDatum'), fo = $('fOrt');
      store.sset(WIZ_KEY, JSON.stringify({a: a ? a.value : null, p: p ? p.value : null, d: fd ? fd.value : '', o: fo ? fo.value : ''}));
    };
    wiz.querySelectorAll('input[name="contact[Anlass]"], input[name="contact[Paket]"]').forEach(function(r){ r.addEventListener('change', saveWiz); });
    ['fDatum', 'fOrt'].forEach(function(id){ var el = $(id); if(el){ el.addEventListener('change', saveWiz); el.addEventListener('input', saveWiz); } });
    var MARK = '— Angaben von der Website —';
    var mail = $('fMail'), okMail = function(v){ return /^\S+@\S+\.\S+$/.test(v.trim()); };
    /* v18: Fehler als Text in der gewaehlten Sprache (statt Browser-Blase), mit aria-invalid; Absenden nur einmal */
    var form = $('mForm'), sendBtn = $('wizSend'), sending = false;
    form.noValidate = true;
    var fieldErr = function(inp, bad){
      if(!inp) return;
      var msg = $(inp.id + 'Err');
      inp.classList.toggle('bad', bad);
      if(bad) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid');
      if(msg) msg.hidden = !bad;
    };
    [$('fName'), mail].forEach(function(inp){ if(inp) inp.addEventListener('input', function(){ if(inp.getAttribute('aria-invalid')){ fieldErr(inp, false); fit(); } }); });
    window.addEventListener('pageshow', function(e){ if(e.persisted && sendBtn){ sending = false; sendBtn.disabled = false; sendBtn.removeAttribute('aria-busy'); } });
    form.addEventListener('submit', function(e){
      if(sending){ e.preventDefault(); return; }
      var nm2 = $('fName'), badN = !nm2.value.trim(), badM = !okMail(mail.value);
      if(badN || badM){
        e.preventDefault(); go(slides.length - 1);
        fieldErr(nm2, badN); fieldErr(mail, badM); fit();
        (badN ? nm2 : mail).focus();
        return;
      }
      sending = true;
      if(sendBtn){ sendBtn.disabled = true; sendBtn.setAttribute('aria-busy', 'true'); }
      saveWiz();
      var msg = $('fMsg'), lines = [];
      var lab = null; try{ lab = JSON.parse(store.sget('lodar-label') || 'null'); }catch(err){}
      if(lab && lab.n) lines.push('Etikett-Wunsch: ' + lab.n + (lab.d ? ' / ' + lab.d : ''));
      var chosen = bar.filter(function(v){ return v > -1; }).map(function(v){ return NUMS[v]; });
      if(touched && chosen.length) lines.push('Auf der Website gewählte Düfte: ' + chosen.join(', '));
      if(msg && lines.length && msg.value.indexOf(MARK) < 0) msg.value = (msg.value ? msg.value + '\n\n' : '') + MARK + '\n' + lines.join('\n');
    });
    go(0);
    window.addEventListener('resize', fit);
    /* Fehler vom Server: Antworten zurueckholen und direkt bei Schritt 4 (Kontakt) weitermachen */
    var srvErr = document.querySelector('.m-err');
    if(srvErr){
      var sw = null; try{ sw = JSON.parse(store.sget(WIZ_KEY) || 'null'); }catch(e){}
      if(sw){
        var pickVal = function(name, val){ if(val == null) return; wiz.querySelectorAll('input[name="' + name + '"]').forEach(function(r){ if(r.value === val) r.checked = true; }); };
        pickVal('contact[Anlass]', sw.a); pickVal('contact[Paket]', sw.p);
        if($('fDatum') && sw.d) $('fDatum').value = sw.d;
        if($('fOrt') && sw.o) $('fOrt').value = sw.o;
      }
      slidesEl.style.transition = 'none';
      go(slides.length - 1);
      void slidesEl.offsetWidth; slidesEl.style.transition = '';
      try{ srvErr.focus(); }catch(e){}
    }
  }
  document.querySelectorAll('[data-pack]').forEach(function(a){
    a.addEventListener('click', function(){
      var v = a.getAttribute('data-pack');
      document.querySelectorAll('input[name="contact[Paket]"]').forEach(function(r){ r.checked = r.value === v; });
      if(go) go(0);
    });
  });

  /* ---------- Rechtliches als eigene Seiten ---------- */
  /* v18: als Dialog; Fokus auf die Ueberschrift, Seite dahinter gesperrt, Escape oder "Zurueck" schliessen
     ohne Sprung nach oben, der Fokus kehrt zum Link in der Fusszeile zurueck */
  var legal = $('mLegal'), legalOpen = false, legalLast = null;
  function route(){
    var h = (location.hash || '').replace('#','');
    var pages = legal ? legal.querySelectorAll('.m-legal-page') : [];
    var hit = null;
    Array.prototype.forEach.call(pages, function(p){ var on = p.getAttribute('data-page') === h; p.hidden = !on; if(on) hit = p; });
    if(!legal) return;
    legal.hidden = !hit;
    if(hit){
      legal.scrollTop = 0;
      if(!legalOpen){ legalOpen = true; legalLast = document.activeElement; }
      var h1 = hit.querySelector('h1');
      if(h1 && h1.id) legal.setAttribute('aria-labelledby', h1.id);
      setInert('legal', [$('xHead'), $('xMenu')].concat(pageParts()));
      focusEl(h1);
    } else if(legalOpen){
      legalOpen = false;
      setInert('legal', null);
      var back = legalLast; legalLast = null;
      if(back && back !== document.body && document.documentElement.contains(back)) focusEl(back);
      else if(legal.contains(document.activeElement)) focusEl(document.querySelector('main'));
    }
  }
  function closeLegal(){
    try{ history.replaceState(null, '', location.pathname + location.search); }catch(e){ location.hash = ''; }
    route();
  }
  if(legal){
    var legalBack = legal.querySelector('.m-legal-close');
    if(legalBack) legalBack.addEventListener('click', function(e){ e.preventDefault(); closeLegal(); });
    document.addEventListener('keydown', function(e){ if((e.key === 'Escape' || e.key === 'Esc') && !legal.hidden) closeLegal(); });
  }
  window.addEventListener('hashchange', route); route();

  if(/contact_posted=true/.test(location.search)){
    var an = $('anfrage');
    if(an) setTimeout(function(){ an.scrollIntoView(); var s = $('mSent'); if(s) s.focus({preventScroll:true}); }, 60);
  }

  /* v22 (fluessig): ausserhalb des Bildschirms steht das Laufband (Klasse mq-off, CSS: animation-play-state paused);
     es laeuft an derselben Stelle weiter, sobald es wieder zu sehen ist. Spart dem Compositor das Dauerbild. */
  (function(){
    var mqs = document.querySelectorAll('.ed-mq'); if(!mqs.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ e.target.classList.toggle('mq-off', !e.isIntersecting); }); }, {rootMargin: '64px 0px'});
    Array.prototype.forEach.call(mqs, function(m){ io.observe(m); });
  })();

  /* ---------- Laufbaender: Pause-Knopf (v18; Maus und Fokus pausieren per CSS, "Bewegung reduzieren" macht sie still) ---------- */
  (function(){
    var bs = document.querySelectorAll('.x-mq-pause'); if(!bs.length) return;
    var root = document.documentElement;
    var setP = function(p){ root.classList.toggle('mq-paused', p); Array.prototype.forEach.call(bs, function(b){ b.setAttribute('aria-pressed', p ? 'true' : 'false'); }); };
    setP(store.get('lodar-mq') === 'paused');
    Array.prototype.forEach.call(bs, function(b){ b.addEventListener('click', function(){ var p = !root.classList.contains('mq-paused'); setP(p); store.set('lodar-mq', p ? 'paused' : 'on'); }); });
  })();

  /* ---------- Sprache: DE, FR, EN ---------- */
  var DICT = window.LODAR_I18N || {fr:{}, en:{}};
  var norm = function(s){ return s.replace(/\s+/g,' ').trim(); };
  var nodes = [], attrs = [], curLang = 'de';
  var I18N_ATTRS = ['placeholder','aria-label','alt'];
  function collect(root){
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode:function(n){
      var p = n.parentNode; if(!p) return NodeFilter.FILTER_REJECT;
      if(p.closest && p.closest('script,style,[data-no-i18n]')) return NodeFilter.FILTER_REJECT;
      return norm(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; } });
    var n; while((n = w.nextNode())) nodes.push({n:n, de:n.nodeValue, k:norm(n.nodeValue)});
    var els = Array.prototype.slice.call(root.querySelectorAll('[placeholder],[aria-label],[alt]'));
    if(root.matches && root.matches('[placeholder],[aria-label],[alt]')) els.unshift(root);
    els.forEach(function(el){
      I18N_ATTRS.forEach(function(at){ if(el.hasAttribute(at)) attrs.push({el:el, at:at, de:el.getAttribute(at)}); });
    });
  }
  collect(document.body);
  function applyLang(ns, as, d){
    ns.forEach(function(o){
      var t = d && d[o.k];
      if(t){ var lead = o.de.match(/^\s*/)[0], tail = o.de.match(/\s*$/)[0]; o.n.nodeValue = lead + t + tail; }
      else o.n.nodeValue = o.de;
    });
    as.forEach(function(o){ var t = d && d[norm(o.de)]; o.el.setAttribute(o.at, t || o.de); });
  }
  var titleDe = document.title;
  /* auto: vom Browser abgeleitet, wird nicht gespeichert (gespeichert wird nur eine eigene Wahl) */
  function setLang(l, auto){
    var d = DICT[l] || null;
    curLang = l;
    applyLang(nodes, attrs, d);
    document.title = (d && d[titleDe]) || titleDe;
    /* v18 (B4): Deutsch ist Schweizer Hochdeutsch (de-CH, wie im html-Tag); lodar-x9.js liest nur die ersten zwei Buchstaben */
    document.documentElement.lang = l === 'de' ? 'de-CH' : l;
    document.querySelectorAll('.x-lang button').forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-lang') === l ? 'true' : 'false'); });
    /* die Anfrage sagt, in welcher Sprache der Gast die Seite gelesen hat */
    var fl = $('fLang'); if(fl) fl.value = ({de:'Deutsch', fr:'Französisch', en:'Englisch'})[l] || l;
    if(!auto) store.set('lodar-lang', l);
    document.documentElement.classList.remove('i18n-wait');
    try{ window.dispatchEvent(new Event('resize')); }catch(e){}
    /* v18 editorial: Texte, die das Skript selbst schreibt (Etikett, Zusammenfassung), neu setzen */
    try{ var ev = document.createEvent('Event'); ev.initEvent('lodar:lang', false, false); window.dispatchEvent(ev); }catch(e){}
  }
  /* v18: spaeter eingefuegte Elemente (z. B. "Eintreten") in die Uebersetzung aufnehmen und gleich in der aktuellen Sprache zeigen */
  window.LODAR_I18N_ADD = function(root){
    if(!root || root.nodeType !== 1) return;
    var n0 = nodes.length, a0 = attrs.length;
    collect(root);
    if(curLang !== 'de') applyLang(nodes.slice(n0), attrs.slice(a0), DICT[curLang] || null);
  };
  document.querySelectorAll('.x-lang button').forEach(function(b){ b.addEventListener('click', function(){ setLang(b.getAttribute('data-lang')); }); });
  /* v18 (Owner-Entscheid): eigene Wahl hat Vorrang; sonst Browser fr = FR, de = DE, alle anderen = EN
     (Suchmaschinen sehen Deutsch). Dieselbe Regel steht im Kopf-Skript in theme.liquid. */
  function autoLang(){
    var n = '', u = '';
    try{ n = ((navigator.languages && navigator.languages[0]) || navigator.language || '').toLowerCase().split('-')[0]; u = navigator.userAgent || ''; }catch(e){}
    if(!n || n === 'de' || n === 'gsw' || /bot|crawl|spider|slurp|lighthouse/i.test(u)) return 'de';
    return n === 'fr' ? 'fr' : 'en';
  }
  var start = store.get('lodar-lang');
  if(start === 'de' || start === 'fr' || start === 'en'){ if(start !== 'de') setLang(start); }
  else { start = autoLang(); if(start !== 'de') setLang(start, true); }
  document.documentElement.classList.remove('i18n-wait');
})();

}catch(e){console.error("[lodar-x.js]",e)}
/* ==== v19 Duftwahl ==== */
try{
/* v19 (Owner 21.10.2026: "die Handy-Version: das mit der Nummer und die Duftwahl sollte man auf einer Seite sehen, man sollte
   nicht runterscrollen"). Auf dem Handy stehen Buehne, die Nummern (2 Reihen) und der gewaehlte Duft zusammen auf einem
   Bildschirm (lodar-v18-home.css, Block "v19"). Dieses Skript
   - misst die Hoehe von Nummern und Duft (--ed-pick-h am Hero), damit die Buehne nach dem Film genau den Rest einnimmt,
   - setzt "Diesen Duft anfragen" auf den gewaehlten Duft (?duft=) und zeigt "Eure Bar n / 6" bei den Nummern,
   - klappt "Mehr zum Duft" (ganze Pyramide) auf und zu,
   - holt nach dem Tippen auf eine Nummer den Duft ganz ins Bild, falls er unten angeschnitten ist.
   Intro, Haus-Film, Standbild und "Eintreten" bleiben unberuehrt (Owner-Vorrang). */
(function(){
  var hero = document.querySelector('.x-hero'), dial = document.getElementById('dial');
  if(!hero || !dial) return;
  var NUMS = ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mq = window.matchMedia ? window.matchMedia('(max-width:760px)') : null;
  var scent = hero.querySelector('.x-scent'), dbar = hero.querySelector('.x-dialbar');
  var ask = document.getElementById('pickAsk'), more = document.getElementById('pickMore'), cnt = document.getElementById('pickN2');
  var open = false;
  function cur(){ var a = hero.querySelector('.x-sc:not([hidden])'); return a ? +a.getAttribute('data-i') : -1; }
  function upd(){
    var i = cur();
    if(ask && i > -1) ask.setAttribute('href', '/pages/anfrage?duft=' + NUMS[i]);
    if(cnt) cnt.textContent = dial.querySelectorAll('button[aria-pressed="true"]').length + ' / 6';
  }
  window.addEventListener('lodar:bar', upd);
  upd();
  /* Hoehe von Nummern und Duft (nur Handy, nur zugeklappt; aufgeklappt darf es laenger werden) */
  var mT = 0;
  function measure(){
    if(!mq || !mq.matches){ hero.style.removeProperty('--ed-pick-h'); return; }
    if(open || !scent || !dbar) return;
    var h = dbar.offsetHeight + scent.offsetHeight;
    if(h > 120) hero.style.setProperty('--ed-pick-h', h + 'px');
  }
  var later = function(){ clearTimeout(mT); mT = setTimeout(measure, 60); };
  window.addEventListener('resize', later);
  window.addEventListener('lodar:lang', later);
  window.addEventListener('lodar:intro', later);
  if(mq){ if(mq.addEventListener) mq.addEventListener('change', later); else if(mq.addListener) mq.addListener(later); }
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(later);
  window.addEventListener('load', later);
  measure();
  /* Mehr zum Duft */
  if(more && scent){
    more.addEventListener('click', function(){
      if(!open) measure();
      open = !open;
      scent.classList.toggle('ed-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(!open) later();
    });
  }
  /* nach dem Tippen auf eine Nummer: ist der Duft unten angeschnitten, sanft so weit scrollen, dass er ganz zu sehen ist */
  dial.addEventListener('click', function(){
    if(!mq || !mq.matches || !scent) return;
    setTimeout(function(){
      var r = scent.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      if(r.bottom > vh + 2){
        var by = Math.min(r.bottom - vh + 8, r.top - 64);
        if(by > 4) window.scrollBy({top: by, behavior: reduce ? 'auto' : 'smooth'});
      }
    }, 30);
  });
})();

}catch(e){console.error("[v19 Duftwahl]",e)}
